
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lICpR", function(module, exports) {

$parcel$export(module.exports, "UserPermissionProvider", () => $377f98047994ea77$export$ea5ef74fdb7fc4f8);
$parcel$export(module.exports, "prefetchAll", () => $377f98047994ea77$export$aba5d6cf034db22e);

var $kBWmB = parcelRequire("kBWmB");

var $irYQs = parcelRequire("irYQs");

var $dcO0p = parcelRequire("dcO0p");

var $bgtNw = parcelRequire("bgtNw");

var $adCrz = parcelRequire("adCrz");

var $grirN = parcelRequire("grirN");
const $377f98047994ea77$var$fetchPermission = (0, $bgtNw.withCached)(({ cloudId: cloudId, permissionId: permissionId })=>(0, $kBWmB.postJson)(`/gateway/api/permissions/permitted`, {
        permissionId: permissionId,
        resourceId: `ari:cloud:platform::site/${cloudId}`
    }).then((permission)=>permission.permitted));
const $377f98047994ea77$export$ea5ef74fdb7fc4f8 = (0, $adCrz.default)((0, $irYQs.default)('permission', (0, $grirN.ExperienceMark).API_PERMISSIONS, $377f98047994ea77$var$fetchPermission, $377f98047994ea77$var$fetchPermission.cached), false);
const $377f98047994ea77$export$aba5d6cf034db22e = ({ cloudId: cloudId })=>{
    $377f98047994ea77$var$fetchPermission({
        cloudId: cloudId,
        permissionId: (0, $dcO0p.Permissions).MANAGE
    });
};
const $377f98047994ea77$export$ffe8c06b7e356699 = ()=>{
    $377f98047994ea77$var$fetchPermission.reset();
};

});
parcelRegister("adCrz", function(module, exports) {

$parcel$export(module.exports, "default", () => $abd7f18c1dd90667$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $irYQs = parcelRequire("irYQs");
/**
 * Inject the ability to handle cases when cloudID is missing into the provided component.
 *
 * When cloud ID is available, this HOC will wrap {children} with the given provided component.
 * Otherwise, {children} is executed with the provided fallback result.
 *
 * @param ProviderComponent component to wrap
 * @param fallbackProviderResult result used to execute children if cloud id is missing
 *
 * @type P component props
 * @type U provider result type
 */ function $abd7f18c1dd90667$var$withHandleOptionalCloudId(ProviderComponent, fallbackProviderResult) {
    return function(props) {
        const { cloudId: cloudId, children: children } = props;
        if (cloudId) return /*#__PURE__*/ (0, $7UHDa.jsx)(ProviderComponent, {
            ...props,
            children: children
        });
        else {
            const resultComplete = {
                status: (0, $irYQs.Status).COMPLETE,
                data: fallbackProviderResult
            };
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: children(resultComplete)
            });
        }
    };
}
var $abd7f18c1dd90667$export$2e2bcd8739ae039 = $abd7f18c1dd90667$var$withHandleOptionalCloudId;

});


parcelRegister("cA3Tq", function(module, exports) {

$parcel$export(module.exports, "AvailableProductsProvider", () => $d506fce92bbefc59$export$4c169257ef988618);
$parcel$export(module.exports, "prefetchAvailableProducts", () => $d506fce92bbefc59$export$1c5684a3ba697d80);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $9yNEc = parcelRequire("9yNEc");
const { fetchMethod: $d506fce92bbefc59$var$fetchAppSwitcherBffAvailableProducts, ProviderComponent: $d506fce92bbefc59$var$DefaultBffDataProviderComponent } = (0, $9yNEc.createAppSwitcherBffAvailableProductsProvider)();
const $d506fce92bbefc59$export$4c169257ef988618 = ({ cloudId: cloudId, product: product, children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)($d506fce92bbefc59$var$DefaultBffDataProviderComponent, {
        cloudId: cloudId,
        product: product,
        children: children
    });
const $d506fce92bbefc59$export$1c5684a3ba697d80 = $d506fce92bbefc59$var$fetchAppSwitcherBffAvailableProducts;
const $d506fce92bbefc59$export$cd9fc41c59711bdd = ()=>$d506fce92bbefc59$var$fetchAppSwitcherBffAvailableProducts.reset();

});
parcelRegister("9yNEc", function(module, exports) {

$parcel$export(module.exports, "createAppSwitcherBffAvailableProductsProvider", () => $02cabd97f79fd287$export$7fd9c7ae7afb494c);

var $cj14x = parcelRequire("cj14x");

var $kBWmB = parcelRequire("kBWmB");

var $grirN = parcelRequire("grirN");

var $alOHm = parcelRequire("alOHm");
const $02cabd97f79fd287$export$f36bb44a614923a8 = '/gateway/api/app-switcher/api/available-products';
// TODO: remove this once Asset app becomes standalone app
const $02cabd97f79fd287$var$transformAppSwitcherBffResponse = (response)=>{
    if (response.switcherTeam25ExperimentCohort === 'test' && response.assetsAsAnAppEnabled) response.sites.forEach((site)=>{
        if (site.availableProducts.some((product)=>product.productType === 'JIRA_SERVICE_DESK' && product.isJsmPremium)) site.availableProducts.push({
            productType: (0, $alOHm.ASSETS_APP_KEY)
        });
    });
    return response;
};
const $02cabd97f79fd287$export$1096efb00c5f8afc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    const response = await (0, $kBWmB.fetchJsonWithNetworkRetries)(`${$02cabd97f79fd287$export$f36bb44a614923a8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
    return $02cabd97f79fd287$var$transformAppSwitcherBffResponse(response);
};
const $02cabd97f79fd287$export$7fd9c7ae7afb494c = ()=>{
    return (0, $cj14x.createProviderWithCustomFetchData)('appSwitcherBffAvailableProducts', (0, $grirN.ExperienceMark).API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, $02cabd97f79fd287$export$1096efb00c5f8afc);
};

});
parcelRegister("alOHm", function(module, exports) {

$parcel$export(module.exports, "COLLAPSED_ORG_SELECTOR_WIDTH", () => $f990887179ccebd8$export$2f90b4ad2fe04542);
$parcel$export(module.exports, "DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH", () => $f990887179ccebd8$export$4103378b1e498da3);
$parcel$export(module.exports, "MIN_ORG_SELECTOR_EXPAND_WIDTH", () => $f990887179ccebd8$export$85408825f773203f);
$parcel$export(module.exports, "MAX_ORG_SELECTOR_EXPANDED_WIDTH", () => $f990887179ccebd8$export$d1ad8b9b8feac8dc);
$parcel$export(module.exports, "ORG_SELECTOR_WIDTH_LS_KEY", () => $f990887179ccebd8$export$22193936843a6dda);
$parcel$export(module.exports, "ASSETS_APP_KEY", () => $f990887179ccebd8$export$45e63649edff1e2a);
const $f990887179ccebd8$export$2f90b4ad2fe04542 = 56;
const $f990887179ccebd8$export$4103378b1e498da3 = 200;
const $f990887179ccebd8$export$85408825f773203f = $f990887179ccebd8$export$2f90b4ad2fe04542 + ($f990887179ccebd8$export$4103378b1e498da3 - $f990887179ccebd8$export$2f90b4ad2fe04542) / 2;
const $f990887179ccebd8$export$d1ad8b9b8feac8dc = 400;
const $f990887179ccebd8$export$22193936843a6dda = 'AS_ORG_SELECTOR_WIDTH';
const $f990887179ccebd8$export$45e63649edff1e2a = 'ASSETS';

});



parcelRegister("l2qS4", function(module, exports) {

$parcel$export(module.exports, "JoinableSitesProvider", () => $19041cad7a2e4757$export$70da68d3b04f82d0);
$parcel$export(module.exports, "prefetchJoinableSites", () => $19041cad7a2e4757$export$2aed3ef1595b4d9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $emHKt = parcelRequire("emHKt");
const { fetchMethod: $19041cad7a2e4757$var$fetchJoinableSites, ProviderComponent: $19041cad7a2e4757$var$DefaultDataProviderComponent } = (0, $emHKt.createJoinableSitesProvider)();
const $19041cad7a2e4757$export$70da68d3b04f82d0 = ({ children: children, joinableSitesDataProvider: joinableSitesDataProvider, cloudId: cloudId })=>{
    const CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
    const DataProviderComponent = CustomDataProviderComponent || $19041cad7a2e4757$var$DefaultDataProviderComponent;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(DataProviderComponent, {
        cloudId: cloudId,
        children: children
    });
};
const $19041cad7a2e4757$export$2aed3ef1595b4d9 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod({});
        return;
    }
    $19041cad7a2e4757$var$fetchJoinableSites({});
};
const $19041cad7a2e4757$export$4ba2a997caa6db74 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod.reset();
        return;
    }
    $19041cad7a2e4757$var$fetchJoinableSites.reset();
};

});

parcelRegister("gyt00", function(module, exports) {

$parcel$export(module.exports, "performanceNow", () => $54b2b65df874895b$export$fb4230f160368c88);
const $54b2b65df874895b$export$fb4230f160368c88 = typeof window !== 'undefined' && window.performance && window.performance.now.bind(performance) || Date.now;

});

parcelRegister("eW67h", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2e601f91649bdbc$export$2e2bcd8739ae039);
/* switcher.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $lzcvT = parcelRequire("lzcvT");

var $js7oX = parcelRequire("js7oX");

var $c6GJD = parcelRequire("c6GJD");

var $8ADrh = parcelRequire("8ADrh");
var $hRQgD = parcelRequire("hRQgD");
var $fWYwq = parcelRequire("fWYwq");

var $a3xa0 = parcelRequire("a3xa0");

var $gyt00 = parcelRequire("gyt00");

var $kJvtV = parcelRequire("kJvtV");

var $1OZQT = parcelRequire("1OZQT");

var $bfFYO = parcelRequire("bfFYO");

var $f8Iqd = parcelRequire("f8Iqd");

var $jhVsa = parcelRequire("jhVsa");

var $9N1hJ = parcelRequire("9N1hJ");

var $97yjv = parcelRequire("97yjv");

var $iKB3c = parcelRequire("iKB3c");

var $39NFn = parcelRequire("39NFn");

var $hcLCO = parcelRequire("hcLCO");

var $z8Sbd = parcelRequire("z8Sbd");

var $024W3 = parcelRequire("024W3");

var $gdv5Z = parcelRequire("gdv5Z");

var $dh538 = parcelRequire("dh538");
function $f2e601f91649bdbc$var$_defineProperty(e, r, t) {
    return (r = $f2e601f91649bdbc$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f2e601f91649bdbc$var$_toPropertyKey(t) {
    var i = $f2e601f91649bdbc$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f2e601f91649bdbc$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $f2e601f91649bdbc$var$getAnalyticsContext = (itemsCount, currentOrg)=>({
        ...(0, $a3xa0.analyticsAttributes)({
            itemsCount: itemsCount,
            currentOrg: currentOrg
        })
    });
const $f2e601f91649bdbc$var$styles = {
    wrapper: "_1e0c1txw _2lx2vrvc",
    standalone: "_1reo15vq _18m915vq _p12fauwl _4t3i1us8 _kqswh2mm _bfhk1bhr",
    standaloneAfter: "_11q7kiet _1sb2b3bt _kqswstnw _94n5idpf _1ltvidpf _1bsb1osq _4t3i7vkz _mrkb14y2 _1pbykb7n",
    refreshedStandalone: "_2rkopd34",
    dynamicHeight: "_c71l1us8",
    switchToContainer: "_ca0qpxbi _u5f3u2gc _n3tdpxbi _19bvu2gc",
    currentOrgContainer: "_18u0u2gc",
    currentOrgContainerRefreshed: "_18u0pxbi _otyrpxbi _19pkpxbi",
    manageButton: "_19bvpxbi _n3tdu2gc"
};
class $f2e601f91649bdbc$export$e313913ef2c28083 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).PureComponent {
    componentDidMount() {
        this.mountedAt = (0, $gyt00.performanceNow)();
        this.setSwitchToContainerHeight();
    }
    componentDidUpdate() {
        this.context[1](this.state.activeOrgId);
        this.setSwitchToContainerHeight();
    }
    static getDerivedStateFromProps(props, state) {
        if (!state.activeOrgId) {
            const currentSite = props.cloudId ? props.rawProviderResults?.availableProducts?.data?.sites?.find((site)=>site.cloudId === props.cloudId) : null;
            const currentOrg = currentSite?.org ? props.organisations?.get(currentSite.org.id) : null;
            if (currentOrg) return {
                currentOrgId: currentOrg.id,
                activeOrgId: currentOrg.id
            };
        }
        return null;
    }
    timeSinceMounted() {
        return this.mountedAt !== undefined ? Math.round((0, $gyt00.performanceNow)() - this.mountedAt) : 0;
    }
    render() {
        const { licensedProductLinks: licensedProductLinks, isPartialResult: isPartialResult, adminLinks: adminLinks, customLinks: customLinks, exploreProductsLink: exploreProductsLink, manageLink: manageLink, hasLoaded: hasLoaded, hasLoadedCritical: hasLoadedCritical, hasLoadedInstanceProviders: hasLoadedInstanceProviders, rawProviderResults: rawProviderResults, onClose: onClose, getExtendedAnalyticsAttributes: getExtendedAnalyticsAttributes, product: product, discoverySection: discoverySection, organisations: organisations, intl: intl, showFlag: showFlag, switcherTeam25ExperimentCohort: switcherTeam25ExperimentCohort, isTeam25AppRebrandEnabled: isTeam25AppRebrandEnabled } = this.props;
        const isVisualRefreshEnabled = switcherTeam25ExperimentCohort === 'test';
        const featureFlags = {
            isTeam25AppRebrandEnabled: isTeam25AppRebrandEnabled || false
        }; /**
        * It is essential that switchToLinks reflects the order corresponding nav items
        * are rendered below in the 'Switch to' section.
        */ 
        const switchToLinks = [
            ...licensedProductLinks,
            ...adminLinks
        ];
        const locale = intl.locale.toLowerCase();
        const isJoinableProductsExperimentGateEnabled = (locale === 'en' || locale.startsWith('en-')) && (0, $c6GJD.default).checkGate('joinable_products_in_switcher_gate');
        const isDiscoveryInEmptyGateEnabled = (0, $dh538.fg)('enable_xflow_in_empty_switcher');
        const joinableSiteLinks = isJoinableProductsExperimentGateEnabled && this.props.joinableSiteLinks ? this.props.joinableSiteLinks?.filter((site)=>site.cloudId === this.props.cloudId) : this.props.joinableSiteLinks || [];
        const itemsCount = switchToLinks.length + customLinks.length + joinableSiteLinks.length;
        const isEmptyState = !isPartialResult && itemsCount === 0;
        const firstContentArrived = Boolean(licensedProductLinks.length);
        let numberOfSites = firstContentArrived ? 1 : 0;
        if (licensedProductLinks) {
            const uniqueSets = {};
            licensedProductLinks.forEach((link)=>{
                (link.childItems || []).forEach((item)=>{
                    uniqueSets[item.label] = true;
                });
            });
            const numbberOfUniqueSites = Object.keys(uniqueSets).length;
            if (numbberOfUniqueSites > 0) numberOfSites = numbberOfUniqueSites;
        }
        const multiOrgEnabled = organisations && organisations?.size > 1;
        const selectedOrg = multiOrgEnabled ? organisations?.get(this.state.activeOrgId) : null;
        const isSwitcherDynamicHeight = (0, $dh538.fg)('app_switcher_dynamic_height');
        const dynamicHeightTransitionStyles = {
            height: isSwitcherDynamicHeight && this.state.switchToContainerHeight ? `${this.state.switchToContainerHeight}px` : '80vh',
            transition: this.state.prevSelectedOrgId && 'height 0.3s ease-in-out'
        };
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.NavigationAnalyticsContext), {
            data: $f2e601f91649bdbc$var$getAnalyticsContext(itemsCount, this.state.activeOrgId === this.state.currentOrgId),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $024W3.BackendFeatureFlagsProvider), {
                featureFlags: featureFlags,
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div" // This ID is important as a workaround to address the duplicated compiled CSS issue in the remote App Switcher
                , {
                    // https://hello.jira.atlassian.cloud/browse/NAVX-414
                    id: "atlassian-app-switcher",
                    role: "dialog",
                    "aria-label": intl ? intl.formatMessage((0, $z8Sbd.default).switcherModalLabel) : (0, $z8Sbd.default).switcherModalLabel.defaultMessage,
                    style: dynamicHeightTransitionStyles,
                    className: (0, $35pXk.default)([
                        $f2e601f91649bdbc$var$styles.wrapper,
                        $f2e601f91649bdbc$var$styles.standalone,
                        isVisualRefreshEnabled && $f2e601f91649bdbc$var$styles.refreshedStandalone,
                        isSwitcherDynamicHeight && $f2e601f91649bdbc$var$styles.dynamicHeight
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                            className: (0, $35pXk.default)([
                                $f2e601f91649bdbc$var$styles.standaloneAfter
                            ])
                        }),
                        multiOrgEnabled && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f8Iqd.default), {
                            product: product,
                            triggerSubject: "orgSelector",
                            hideFallbackUI: true,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $97yjv.default), {
                                activeOrgId: this.state.activeOrgId,
                                handleSetActiveOrg: this.setActiveOrg,
                                organisations: organisations,
                                product: product,
                                switchToSectionHeight: this.state.switchToContainerHeight
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fWYwq.default), {
                            activeOrgId: selectedOrg ? this.state.activeOrgId : undefined,
                            children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                                ref: this.switchToContainerRef,
                                className: (0, $35pXk.default)([
                                    !isVisualRefreshEnabled && $f2e601f91649bdbc$var$styles.switchToContainer,
                                    isSwitcherDynamicHeight && $f2e601f91649bdbc$var$styles.dynamicHeight
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                                        children: [
                                            selectedOrg ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $f8Iqd.default), {
                                                product: product,
                                                triggerSubject: "currentOrgErrorBoundary",
                                                hideFallbackUI: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.ViewedTracker), {
                                                        subject: (0, $a3xa0.SWITCHER_CURRENT_ORG),
                                                        data: {
                                                            organisation: selectedOrg.id
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                                                        className: (0, $35pXk.default)([
                                                            isVisualRefreshEnabled ? $f2e601f91649bdbc$var$styles.currentOrgContainerRefreshed : $f2e601f91649bdbc$var$styles.currentOrgContainer
                                                        ]),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iKB3c.default), {
                                                                ...selectedOrg
                                                            }),
                                                            this.props.userEmail && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $39NFn.default), {
                                                                ...selectedOrg,
                                                                email: this.props.userEmail
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.NotRenderedTracker), {
                                                subject: (0, $a3xa0.SWITCHER_CURRENT_ORG),
                                                data: {
                                                    organisation: null
                                                }
                                            }),
                                            hasLoaded && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.ViewedTracker), {
                                                        subject: (0, $a3xa0.SWITCHER_SUBJECT),
                                                        data: {
                                                            licensedProducts: licensedProductLinks.map((item)=>item.productType),
                                                            licensedProductsNewlyAdded: licensedProductLinks.filter((item)=>item.shouldShowNewLozenge).map((item)=>item.productType),
                                                            autoprovisionedProducts: licensedProductLinks.filter((item)=>!!item.autoProvisionDate).map((item)=>item.productType),
                                                            inactiveProducts: licensedProductLinks.filter((item)=>!!item.isProductInactive).map((item)=>item.productType),
                                                            adminLinks: adminLinks.map((item)=>item.key),
                                                            joinableSiteLinks: joinableSiteLinks.map((item)=>item.key),
                                                            joinableSiteProductLinks: joinableSiteLinks.map((item)=>({
                                                                    cloudId: item.key,
                                                                    product: item.productType
                                                                })),
                                                            numOrganisations: organisations?.size || 0,
                                                            numberOfSites: numberOfSites
                                                        }
                                                    }),
                                                    joinableSiteLinks.length > 0 && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.ViewedTracker), {
                                                        subject: (0, $a3xa0.SWITCHER_JOINABLE_SITES),
                                                        data: {
                                                            duration: this.timeSinceMounted()
                                                        }
                                                    }),
                                                    licensedProductLinks.length > 0 ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.RenderTracker), {
                                                        subject: (0, $a3xa0.SWITCHER_AVAILABLE_PRODUCTS),
                                                        data: {
                                                            duration: this.timeSinceMounted()
                                                        }
                                                    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.NotRenderedTracker), {
                                                        subject: (0, $a3xa0.SWITCHER_AVAILABLE_PRODUCTS),
                                                        data: {
                                                            duration: this.timeSinceMounted()
                                                        }
                                                    })
                                                ]
                                            }),
                                            hasLoadedInstanceProviders && (0, $a3xa0.getCustomLinksRenderTracker)(rawProviderResults.customLinks, rawProviderResults.userSiteData, customLinks, {
                                                duration: this.timeSinceMounted()
                                            }),
                                            firstContentArrived && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.RenderTracker), {
                                                subject: (0, $a3xa0.SWITCHER_SUBJECT),
                                                data: {
                                                    duration: this.timeSinceMounted()
                                                }
                                            }),
                                            hasLoadedCritical && (isEmptyState ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f8Iqd.default), {
                                                product: product,
                                                triggerSubject: "emptyStateErrorBoundary",
                                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jhVsa.default), {
                                                    exploreProductsLink: exploreProductsLink
                                                })
                                            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1OZQT.SwitchToSection), {
                                                adminLinks: adminLinks,
                                                isPartialResult: isPartialResult || false,
                                                licensedProductLinks: licensedProductLinks,
                                                getExtendedAnalyticsAttributes: getExtendedAnalyticsAttributes,
                                                product: product,
                                                experimentalJoinableSiteLinks: isJoinableProductsExperimentGateEnabled ? joinableSiteLinks : undefined,
                                                showFlag: showFlag
                                            }))
                                        ]
                                    }),
                                    !isJoinableProductsExperimentGateEnabled && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $f8Iqd.default), {
                                        product: product,
                                        triggerSubject: "crossJoinErrorBoundary",
                                        hideFallbackUI: true,
                                        children: [
                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kJvtV.CrossJoinSection), {
                                                joinableSiteLinks: joinableSiteLinks,
                                                onClose: onClose
                                            }),
                                            hasLoadedCritical && (0, $a3xa0.getJoinableSitesRenderTracker)(rawProviderResults.joinableSites, joinableSiteLinks, {
                                                duration: this.timeSinceMounted()
                                            })
                                        ]
                                    }),
                                    (isEmptyState && isDiscoveryInEmptyGateEnabled || !isEmptyState) && !(0, $lzcvT.isFedRamp)() && !!discoverySection && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f8Iqd.default), {
                                        product: product,
                                        triggerSubject: "crossFlowErrorBoundary",
                                        hideFallbackUI: true,
                                        children: discoverySection
                                    }),
                                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $f8Iqd.default), {
                                        product: product,
                                        triggerSubject: "customLinksErrorBoundary",
                                        hideFallbackUI: true,
                                        children: [
                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bfFYO.CustomLinksSection), {
                                                customLinks: customLinks
                                            }),
                                            !hasLoadedCritical && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hRQgD.default), {}),
                                            manageLink && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                                xcss: $f2e601f91649bdbc$var$styles.manageButton,
                                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8ADrh.default), {
                                                    href: manageLink
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        });
    }
    constructor(props){
        super(props);
        $f2e601f91649bdbc$var$_defineProperty(this, "mountedAt", void 0);
        $f2e601f91649bdbc$var$_defineProperty(this, "context", void 0);
        $f2e601f91649bdbc$var$_defineProperty(this, "switchToContainerRef", void 0);
        $f2e601f91649bdbc$var$_defineProperty(this, "setSwitchToContainerHeight", ()=>{
            if (this.switchToContainerRef.current) {
                // we add 12 to the height to account for the margin that is not included in 'this.switchToContainerRef.current.scrollHeight'
                const height = this.switchToContainerRef.current.scrollHeight + 12;
                this.setState({
                    switchToContainerHeight: height
                });
            }
        });
        $f2e601f91649bdbc$var$_defineProperty(this, "setActiveOrg", (id)=>{
            const prevSelectedOrgId = this.state.activeOrgId;
            this.setState({
                prevSelectedOrgId: prevSelectedOrgId,
                activeOrgId: id
            });
        });
        this.switchToContainerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createRef();
        this.state = {
            currentOrgId: '',
            activeOrgId: '',
            switchToContainerHeight: null,
            prevSelectedOrgId: ''
        };
    }
}
$f2e601f91649bdbc$var$_defineProperty($f2e601f91649bdbc$export$e313913ef2c28083, "contextType", (0, $hcLCO.OrgContext));
$f2e601f91649bdbc$var$_defineProperty($f2e601f91649bdbc$export$e313913ef2c28083, "defaultProps", {});
var $f2e601f91649bdbc$export$2e2bcd8739ae039 = (0, $js7oX.default)((0, $9N1hJ.withExperienceTracker)($f2e601f91649bdbc$export$e313913ef2c28083), {
    enforceContext: false
});

});
parcelRegister("8ADrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $008eb0ebadf801b1$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $kaECR = parcelRequire("kaECR");

var $7p4As = parcelRequire("7p4As");

var $a3xa0 = parcelRequire("a3xa0");
class $008eb0ebadf801b1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { href: href } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7p4As.default), {
            href: href,
            onClick: this.onClick,
            testId: "app-switcher-manage-button",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $kaECR.default).manageList
            })
        });
    }
    constructor(...args){
        super(...args);
        this.onClick = (_, analyticsEvent)=>{
            analyticsEvent.update({
                eventType: (0, $a3xa0.UI_EVENT_TYPE),
                actionSubjectId: 'manageListButton'
            }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
        };
    }
}

});

parcelRegister("fWYwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $acff22f1c1fd4980$export$2e2bcd8739ae039);
/* wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $8ADrh = parcelRequire("8ADrh");

var $78Fx5 = parcelRequire("78Fx5");
const $acff22f1c1fd4980$var$styles = {
    wrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _vchhusvi _4t3i1osq _1ul9idpf _18m91wug _1bsb1vd0 _1874idpf _ujqdidpf",
    body: "_1tke1oqc",
    footer: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _x3dozgxb _1e0c1txw _vchhusvi _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _kqsw1if8 _94n5idpf _4cvr1h6o _1bah1h6o",
    activeOrg: "_4t3iu6a3"
};
class $acff22f1c1fd4980$var$SwitcherWrapper extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { children: children, activeOrgId: activeOrgId } = this.props;
        const manageButton = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(children).filter((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child) && (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.only(child).type === (0, $8ADrh.default));
        const items = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(children).filter((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child) && (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.only(child).type !== (0, $8ADrh.default));
        const tabProps = activeOrgId ? {
            id: `${0, $78Fx5.SWITCHER_TAB_PANEL_PREFIX}-${activeOrgId}`,
            role: 'tabpanel',
            'aria-labelledby': `${0, $78Fx5.SWITCHER_TAB_BUTTON_PREFIX}-${activeOrgId}`
        } : {};
        return /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
            ...tabProps,
            className: (0, $35pXk.default)([
                $acff22f1c1fd4980$var$styles.wrapper,
                activeOrgId && $acff22f1c1fd4980$var$styles.activeOrg
            ]),
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                    className: (0, $35pXk.default)([
                        $acff22f1c1fd4980$var$styles.body
                    ]),
                    children: items
                }),
                manageButton.length ? /*#__PURE__*/ (0, $7UHDa.jsx)("footer", {
                    className: (0, $35pXk.default)([
                        $acff22f1c1fd4980$var$styles.footer
                    ]),
                    children: manageButton
                }) : null
            ]
        });
    }
}
var $acff22f1c1fd4980$export$2e2bcd8739ae039 = $acff22f1c1fd4980$var$SwitcherWrapper;

});
parcelRegister("78Fx5", function(module, exports) {

$parcel$export(module.exports, "SWITCHER_TAB_PANEL_PREFIX", () => $918f15f8f008784d$export$b82967a5e2e15f88);
$parcel$export(module.exports, "SWITCHER_TAB_BUTTON_PREFIX", () => $918f15f8f008784d$export$5148db3936b81051);
const $918f15f8f008784d$export$b82967a5e2e15f88 = 'app-switcher-tab-panel';
const $918f15f8f008784d$export$5148db3936b81051 = 'app-switcher-tab-btn';

});


parcelRegister("kJvtV", function(module, exports) {

$parcel$export(module.exports, "CrossJoinSection", () => $da65cf23b6e682f3$export$d4676c9f6943a445);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $kaECR = parcelRequire("kaECR");

var $gtzep = parcelRequire("gtzep");
var $fJvXe = parcelRequire("fJvXe");

var $dcO0p = parcelRequire("dcO0p");

var $a3xa0 = parcelRequire("a3xa0");

var $4jR19 = parcelRequire("4jR19");

var $grirN = parcelRequire("grirN");
var $88ga6 = parcelRequire("88ga6");

var $4HhdG = parcelRequire("4HhdG");
const $da65cf23b6e682f3$export$d4676c9f6943a445 = (props)=>{
    const { joinableSiteLinks: joinableSiteLinks = [], onClose: onClose } = props;
    (0, $88ga6.useExperienceSuccess)((0, $grirN.Experience).RENDER_JOIN_SECTION);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fJvXe.SectionContainer), {
        sectionId: "join",
        title: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $kaECR.default).join
        }),
        children: joinableSiteLinks.map(({ cloudId: cloudId, description: description, href: href, iconKey: iconKey, label: label, productType: productType, users: users }, groupIndex)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.NavigationAnalyticsContext), {
                data: (0, $a3xa0.getItemAnalyticsContext)(groupIndex, cloudId, (0, $dcO0p.AnalyticsItemType).JOIN, productType),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gtzep.default), {
                    icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4HhdG.AppIcon), {
                        iconKey: iconKey
                    }),
                    description: description,
                    users: users,
                    href: href,
                    onItemClick: ()=>{
                        onClose && onClose();
                    },
                    target: "_blank",
                    rel: "noreferrer",
                    children: label
                })
            }, groupIndex))
    });
};

});
parcelRegister("gtzep", function(module, exports) {

$parcel$export(module.exports, "default", () => $a492a87ef885b738$export$2e2bcd8739ae039);
/* item-with-avatar-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2Pg7f = parcelRequire("2Pg7f");

var $a3xa0 = parcelRequire("a3xa0");

var $hhh77 = parcelRequire("hhh77");

var $6FJLn = parcelRequire("6FJLn");
const $a492a87ef885b738$var$noop = ()=>{};
class $a492a87ef885b738$var$ItemWithAvatarGroup extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { icon: icon, description: description, users: users = [], onItemClick: onItemClick, tag: tag = 'li', maxCount: maxCount = 3, ...rest } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hhh77.FadeIn), {
            tag: tag,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FJLn.default), {
                description: description,
                icon: icon,
                elemAfter: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Pg7f.default), {
                    appearance: "stack",
                    data: users,
                    maxCount: maxCount,
                    size: "small",
                    onMoreClick: $a492a87ef885b738$var$noop
                }),
                onClick: onItemClick,
                ...rest
            })
        });
    }
}
var $a492a87ef885b738$export$2e2bcd8739ae039 = (0, $a3xa0.withAnalyticsEvents)({
    onItemClick: (0, $a3xa0.createAndFireNavigationEvent)({
        eventType: (0, $a3xa0.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: (0, $a3xa0.SWITCHER_ITEM_SUBJECT)
    })
})($a492a87ef885b738$var$ItemWithAvatarGroup);

});

parcelRegister("4HhdG", function(module, exports) {

$parcel$export(module.exports, "AppIcon", () => $5649b6a58fe3778d$export$5153830bdfb71453);
/* app-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $6fnsQ = parcelRequire("6fnsQ");

var $024W3 = parcelRequire("024W3");

var $33YL4 = parcelRequire("33YL4");

var $6LeZx = parcelRequire("6LeZx");

var $dJDhX = parcelRequire("dJDhX");

var $guzTv = parcelRequire("guzTv");

var $lQxxH = parcelRequire("lQxxH");

var $7MUoO = parcelRequire("7MUoO");

var $g1L9J = parcelRequire("g1L9J");

var $741y4 = parcelRequire("741y4");

var $eQW47 = parcelRequire("eQW47");

var $4oGib = parcelRequire("4oGib");

var $fnOp7 = parcelRequire("fnOp7");

var $lv6Nr = parcelRequire("lv6Nr");

var $cYvef = parcelRequire("cYvef");

var $3R8cQ = parcelRequire("3R8cQ");

var $foJyA = parcelRequire("foJyA");

var $i36zl = parcelRequire("i36zl");

var $5GHmV = parcelRequire("5GHmV");

var $7akaY = parcelRequire("7akaY");

var $1phn0 = parcelRequire("1phn0");

var $grMZU = parcelRequire("grMZU");

var $fUqJZ = parcelRequire("fUqJZ");

var $eZovf = parcelRequire("eZovf");

var $1BtHN = parcelRequire("1BtHN");

var $9x4nz = parcelRequire("9x4nz");

var $lghJI = parcelRequire("lghJI");
var $4Nwes = parcelRequire("4Nwes");
var $fIkwO = parcelRequire("fIkwO");
var $l8sjW = parcelRequire("l8sjW");
const $5649b6a58fe3778d$var$styles = {
    root: "_2rkopd34 _1e0c1txw _4cvr1h6o _1bah1h6o _1bsbxy5q _4t3ixy5q"
}; // The product keys need to match the iconKey registered by products in Flight Deck:
const $5649b6a58fe3778d$var$IconBase = ({ backgroundColor: backgroundColor, children: children, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "aria-hidden": true,
        "data-testid": testId,
        style: {
            backgroundColor: backgroundColor
        },
        className: (0, $35pXk.default)([
            $5649b6a58fe3778d$var$styles.root
        ]),
        children: children
    });
const $5649b6a58fe3778d$export$5fa681ac80bb4d5c = (InnerIcon, options)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($5649b6a58fe3778d$var$IconBase, {
        testId: options?.testId,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)(InnerIcon, {
            label: options?.label || '',
            size: "32",
            appearance: options?.appearance || 'legacy'
        })
    });
}; // HOC for '@atlaskit/logo'
const $5649b6a58fe3778d$export$e72d31d687d0cca6 = (InnerIcon, options)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    /*#__PURE__*/ (0, $7UHDa.jsx)($5649b6a58fe3778d$var$IconBase, {
        backgroundColor: "#1868DB",
        testId: options?.testId,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)(InnerIcon, {
            iconColor: $6fnsQ.N0,
            size: "small"
        })
    }));
};
const $5649b6a58fe3778d$export$5153830bdfb71453 = ({ iconKey: iconKey, testId: testId })=>{
    const featureFlags = (0, $024W3.useBackendFeatureFlag)();
    const appearance = featureFlags.isTeam25AppRebrandEnabled || (0, $dh538.fg)('platform-team25-app-icon-tiles') ? 'brand' : 'legacy';
    switch(iconKey){
        case 'assets':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $3R8cQ.AssetsIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'atlassian-analytics':
            return $5649b6a58fe3778d$export$e72d31d687d0cca6((0, $lghJI.AtlassianAnalyticsIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'atlassian-analytics-rebrand':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $4oGib.AnalyticsIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'guard':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $33YL4.GuardIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'bitbucket':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $6LeZx.BitbucketIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'compass':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $dJDhX.CompassIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'confluence':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $guzTv.ConfluenceIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'company-hub':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $5GHmV.CompanyHubIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'atlassian':
            return $5649b6a58fe3778d$export$e72d31d687d0cca6((0, $4Nwes.AtlassianIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'atlassian-home':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $9x4nz.HomeIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'jira-product-discovery':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $lQxxH.JiraProductDiscoveryIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'jira-service-management':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $7MUoO.JiraServiceManagementIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'jira-software':
            return $5649b6a58fe3778d$export$e72d31d687d0cca6((0, $fIkwO.JiraSoftwareIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'jira-work-management':
            return $5649b6a58fe3778d$export$e72d31d687d0cca6((0, $l8sjW.JiraWorkManagementIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'jira':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $g1L9J.JiraIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'loom':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $741y4.LoomIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'mercury':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $eQW47.FocusIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'opsgenie':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $fnOp7.OpsgenieIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'rovo':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $lv6Nr.RovoIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'statuspage':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $cYvef.StatuspageIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'trello':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $foJyA.TrelloIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'townsquare':
            return $5649b6a58fe3778d$export$e72d31d687d0cca6((0, $4Nwes.AtlassianIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'admin':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $i36zl.AdminIcon), {
                testId: testId,
                appearance: appearance
            });
        case 'custom-link':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $7akaY.CustomLinkIcon), {
                testId: testId,
                label: 'Custom link'
            });
        case 'chat':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $grMZU.ChatIcon), {
                testId: testId
            });
        case 'search':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $1phn0.SearchIcon), {
                testId: testId
            });
        case 'teams':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $eZovf.TeamsIcon), {
                testId: testId
            });
        case 'goals':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $1BtHN.GoalsIcon), {
                testId: testId
            });
        case 'studio':
            return $5649b6a58fe3778d$export$5fa681ac80bb4d5c((0, $fUqJZ.StudioIcon), {
                testId: testId
            });
        // fallback to atlassian icon
        default:
            return $5649b6a58fe3778d$export$e72d31d687d0cca6((0, $4Nwes.AtlassianIcon), {
                testId: testId
            });
    }
};

});
parcelRegister("024W3", function(module, exports) {

$parcel$export(module.exports, "useBackendFeatureFlag", () => $713c0663b807f571$export$e109577d5d37b24f);
$parcel$export(module.exports, "BackendFeatureFlagsProvider", () => $713c0663b807f571$export$353aad0acf76f004);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $713c0663b807f571$var$BackendFeatureFlagsContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    isTeam25AppRebrandEnabled: false
});
const $713c0663b807f571$export$e109577d5d37b24f = ()=>{
    return (0, $gwFzn.useContext)($713c0663b807f571$var$BackendFeatureFlagsContext);
};
const $713c0663b807f571$export$353aad0acf76f004 = ({ children: children, featureFlags: featureFlags })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($713c0663b807f571$var$BackendFeatureFlagsContext.Provider, {
        value: featureFlags,
        children: children
    });
};

});



parcelRegister("1OZQT", function(module, exports) {

$parcel$export(module.exports, "SwitchToSection", () => $c6197faac9b394a9$export$17c868d7a399d176);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $fJvXe = parcelRequire("fJvXe");
var $lgfSs = parcelRequire("lgfSs");

var $lYygP = parcelRequire("lYygP");

var $z8Sbd = parcelRequire("z8Sbd");

var $a3xa0 = parcelRequire("a3xa0");

var $dcO0p = parcelRequire("dcO0p");

var $04v1K = parcelRequire("04v1K");

var $8FzJP = parcelRequire("8FzJP");

var $grirN = parcelRequire("grirN");
var $88ga6 = parcelRequire("88ga6");

var $9Kn58 = parcelRequire("9Kn58");

var $f8Iqd = parcelRequire("f8Iqd");

var $7NMcw = parcelRequire("7NMcw");

var $4HhdG = parcelRequire("4HhdG");

var $eycgM = parcelRequire("eycgM");
const $c6197faac9b394a9$var$getLozenges = (item)=>{
    const lozenges = [];
    if (item.shouldShowTryLozenge) lozenges.push((0, $lYygP.LozengeType).Try);
    else if (item.shouldShowNewBoldLozenge) lozenges.push((0, $lYygP.LozengeType).NewBold);
    else if (item.shouldShowNewLozenge) lozenges.push((0, $lYygP.LozengeType).New);
    return lozenges;
};
const $c6197faac9b394a9$var$getDescription = (item, licensedProductLinks, product)=>{
    const description = item.description;
    if (!item.shouldShowNewLozenge && !item.shouldShowTryLozenge && !item.shouldShowNewBoldLozenge) return description;
    if (item.isProductInactive) {
        // show different message if JSW is a licensedProduct
        const hasJSWlicensedProduct = licensedProductLinks.some((link)=>link.productType === 'JIRA_SOFTWARE');
        const message = hasJSWlicensedProduct ? (0, $z8Sbd.default).jwmInactiveSwitcherWithJSWItemDescription : (0, $z8Sbd.default).jwmInactiveSwitcherWithDefaultItemDescription;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...message
        });
    }
    // TBLZ-2123: Growth - Trailblazers experiment - More info at go/trailblazerexperiments
    if (item.shouldShowNewBoldLozenge) {
        const nudge = product === (0, $dcO0p.Product).CONFLUENCE ? (0, $z8Sbd.default).experimentNudgeToJiraConfluenceDescription : (0, $z8Sbd.default).experimentNudgeToJiraDescription;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...nudge
        });
    }
    const message = (0, $z8Sbd.default)[`autoProvisionedSwitcherItem${(0, (/*@__PURE__*/$parcel$interopDefault($9Kn58)))(item.productType)}Description`];
    if (message?.id) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...message
    });
    return description;
};
const $c6197faac9b394a9$export$17c868d7a399d176 = ({ adminLinks: adminLinks, isPartialResult: isPartialResult, licensedProductLinks: licensedProductLinks, getExtendedAnalyticsAttributes: getExtendedAnalyticsAttributes, product: product, experimentalJoinableSiteLinks: experimentalJoinableSiteLinks, showFlag: showFlag })=>{
    (0, $88ga6.useExperienceSuccess)((0, $grirN.Experience).RENDER_SWITCH_TO_SECTION);
    const isVisualRefreshEnabled = (0, $eycgM.useIsSwitcherTeam25TestCohort)();
    const renderChildren = ()=>{
        return [
            licensedProductLinks.map((item, groupIndex)=>{
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.NavigationAnalyticsContext), {
                    data: (0, $a3xa0.getItemAnalyticsContext)(groupIndex, null, (0, $dcO0p.AnalyticsItemType).PRODUCT, item.productType, {
                        ...getExtendedAnalyticsAttributes(item.productType),
                        isProductInactive: Boolean(item.isProductInactive).toString(),
                        isAutoProvisioned: Boolean(item.autoProvisionDate).toString()
                    }),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lgfSs.default), {
                        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4HhdG.AppIcon), {
                            iconKey: item.iconKey,
                            testId: "switcher-item-icon__product"
                        }),
                        description: $c6197faac9b394a9$var$getDescription(item, licensedProductLinks, product),
                        href: item.href,
                        childItems: item.childItems,
                        testId: `switcher-item__${item.key}`,
                        lozenges: $c6197faac9b394a9$var$getLozenges(item),
                        shouldShowNewLozenge: item.shouldShowNewLozenge,
                        shouldShowTryLozenge: item.shouldShowTryLozenge,
                        shouldShowNewBoldLozenge: item.shouldShowNewBoldLozenge,
                        productName: item.label,
                        experimentNudgeToJira: item.experimentNudgeToJira,
                        children: item.label
                    })
                }, item.key);
            }),
            isPartialResult ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8FzJP.PartialResultError), {
                emptyResult: licensedProductLinks.length === 0
            }, "partial-result-error") : null,
            adminLinks.length > 0 && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $04v1K.AdminSubsection), {
                adminLinks: adminLinks
            }, "admin-item")
        ];
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fJvXe.SectionContainer), {
        sectionId: "switchTo",
        title: isVisualRefreshEnabled ? undefined : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $z8Sbd.default).yourApps
        }),
        actionSubject: "atlassianLink",
        children: [
            renderChildren(),
            experimentalJoinableSiteLinks && (product === (0, $dcO0p.Product).JIRA || product === (0, $dcO0p.Product).CONFLUENCE) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f8Iqd.default), {
                product: product,
                triggerSubject: "JoinProductItem",
                hideFallbackUI: true,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7NMcw.JoinProductItem), {
                    joinableSiteLinks: experimentalJoinableSiteLinks,
                    showFlag: showFlag
                })
            })
        ]
    });
};

});
parcelRegister("lgfSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $546b61a5afd219b0$export$2e2bcd8739ae039);
/* item-with-dropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $7kzZ3 = parcelRequire("7kzZ3");

var $dDJDQ = parcelRequire("dDJDQ");

var $bvdmh = parcelRequire("bvdmh");

var $6FJLn = parcelRequire("6FJLn");

var $8X9X0 = parcelRequire("8X9X0");

var $g6fUv = parcelRequire("g6fUv");

var $hhh77 = parcelRequire("hhh77");

var $a3xa0 = parcelRequire("a3xa0");

var $eycgM = parcelRequire("eycgM");

var $9fhu3 = parcelRequire("9fhu3");
const $546b61a5afd219b0$var$styles = {
    itemContainer: "_1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4",
    refreshedItemContainer: "_2rkoiti9 _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1yb4",
    childItemsContainer: "_2rkoglpi _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkv77o _2hwxidpf _otyrv77o _18u0idpf _bfhk1w7a",
    refreshedChildItemsContainer: "_2rkoiti9 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkv77o _2hwxidpf _otyrv77o _18u0idpf _bfhk166n",
    themeableItemWrapper: "_2rkoglpi _1reo15vq _18m915vq _1bsb1osq _4t3ioahv",
    refreshedThemeableItemWrapper: "_2rkoglpi _1reo15vq _18m915vq _1bsb1osq _4t3ioahv _2hwxk4tm",
    hoverColor: "_bfhk166n",
    zIndex: "_1pbykb7n"
};
function $546b61a5afd219b0$var$SwitcherItemWithDropDown({ icon: icon, description: description, childItems: childItems, onItemClick: onItemClick, onChildItemClick: onChildItemClick, shouldShowNewLozenge: shouldShowNewLozenge, shouldShowNewBoldLozenge: shouldShowNewBoldLozenge, shouldShowTryLozenge: shouldShowTryLozenge, onExpandClick: onExpandClick, productName: productName, experimentNudgeToJira: experimentNudgeToJira, ...rest }) {
    const [showChildItems, setShowChildItems] = (0, $gwFzn.useState)(false);
    const [isHovered, setHovered] = (0, $gwFzn.useState)(false);
    const childItemsExist = childItems && childItems.length > 0;
    const productDescription = childItemsExist || shouldShowNewLozenge || shouldShowTryLozenge || shouldShowNewBoldLozenge ? description : null;
    const isVisualRefreshEnabled = (0, $eycgM.useIsSwitcherTeam25TestCohort)();
    (0, $9fhu3.useNudgeToJira)(experimentNudgeToJira);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hhh77.FadeIn), {
        tag: "li",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                    className: (0, $35pXk.default)([
                        isVisualRefreshEnabled ? $546b61a5afd219b0$var$styles.refreshedItemContainer : $546b61a5afd219b0$var$styles.itemContainer
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                            className: (0, $35pXk.default)([
                                isVisualRefreshEnabled ? $546b61a5afd219b0$var$styles.refreshedThemeableItemWrapper : $546b61a5afd219b0$var$styles.themeableItemWrapper,
                                isVisualRefreshEnabled && isHovered && $546b61a5afd219b0$var$styles.hoverColor
                            ]),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FJLn.default), {
                                icon: icon,
                                description: productDescription,
                                onClick: onItemClick,
                                ...rest
                            })
                        }),
                        childItemsExist && /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                            onMouseOver: ()=>setHovered(true),
                            onMouseOut: ()=>setHovered(false),
                            onFocus: ()=>setHovered(true),
                            onBlur: ()=>setHovered(false),
                            className: (0, $35pXk.default)([
                                $546b61a5afd219b0$var$styles.zIndex
                            ]),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bvdmh.default), {
                                icon: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: showChildItems ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dDJDQ))), {
                                        color: "currentColor",
                                        label: "Collapse",
                                        size: "small"
                                    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kzZ3))), {
                                        color: "currentColor",
                                        label: "Expand",
                                        size: "small"
                                    })
                                }),
                                onClick: (e)=>{
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setShowChildItems(!showChildItems);
                                    if (!showChildItems) onExpandClick && onExpandClick();
                                },
                                expanded: showChildItems,
                                productName: productName,
                                numSites: childItems.length
                            })
                        })
                    ]
                }),
                showChildItems && childItems && /*#__PURE__*/ (0, $7UHDa.jsx)("ul", {
                    className: (0, $35pXk.default)([
                        isVisualRefreshEnabled ? $546b61a5afd219b0$var$styles.refreshedChildItemsContainer : $546b61a5afd219b0$var$styles.childItemsContainer
                    ]),
                    children: childItems.map((item)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $8X9X0.default), {
                            tag: "li",
                            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g6fUv.default), {
                                avatarUrl: item.avatar,
                                alt: ""
                            }),
                            href: item.href,
                            onClick: onChildItemClick,
                            testId: "switcher-child-item",
                            children: item.label
                        }, item.label))
                })
            ]
        })
    });
}
const $546b61a5afd219b0$var$SwitcherItemWithDropDownWithEvents = (0, $a3xa0.withAnalyticsEvents)({
    onChildItemClick: (0, $a3xa0.createAndFireNavigationEvent)({
        eventType: (0, $a3xa0.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: (0, $a3xa0.SWITCHER_CHILD_ITEM_SUBJECT)
    }),
    onExpandClick: (0, $a3xa0.createAndFireNavigationEvent)({
        eventType: (0, $a3xa0.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: (0, $a3xa0.SWITCHER_ITEM_EXPAND_SUBJECT)
    }),
    onItemClick: (0, $a3xa0.createAndFireNavigationEvent)({
        eventType: (0, $a3xa0.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: (0, $a3xa0.SWITCHER_ITEM_SUBJECT)
    })
})($546b61a5afd219b0$var$SwitcherItemWithDropDown);
var $546b61a5afd219b0$export$2e2bcd8739ae039 = $546b61a5afd219b0$var$SwitcherItemWithDropDownWithEvents;

});
parcelRegister("dDJDQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::636414aaf061bfcc39e7053bfa952962>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ee25257c3a1c2ac$var$_react = $9ee25257c3a1c2ac$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $9ee25257c3a1c2ac$var$_chevronUp = $9ee25257c3a1c2ac$var$_interopRequireDefault((parcelRequire("2AytZ")));

var $9ee25257c3a1c2ac$var$_chevronUp2 = $9ee25257c3a1c2ac$var$_interopRequireDefault((parcelRequire("8fhBi")));
function $9ee25257c3a1c2ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "ChevronUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ee25257c3a1c2ac$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $9ee25257c3a1c2ac$var$_react.default.createElement($9ee25257c3a1c2ac$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $9ee25257c3a1c2ac$var$_chevronUp2.default
    }, props));
$9ee25257c3a1c2ac$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $9ee25257c3a1c2ac$var$_default = module.exports.default = $9ee25257c3a1c2ac$var$ChevronUpIcon;

});

parcelRegister("bvdmh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea5b7a179b120a1d$export$2e2bcd8739ae039);
/* item-dropdown-toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $3gadb = parcelRequire("3gadb");

var $js7oX = parcelRequire("js7oX");
var $hlhtG = parcelRequire("hlhtG");
var $dBxQj = parcelRequire("dBxQj");

var $d3Dtl = parcelRequire("d3Dtl");

var $eycgM = parcelRequire("eycgM");
const $ea5b7a179b120a1d$var$styles = {
    button: "_19itidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7glyw _2rkoglpi _19pkidpf _2hwxidpf _otyridpf _18u0v77o _4t3ickbl _1bsbckbl _80omtlke _irr3166n _30l31r31 _1di61dty _180dglyw _9h8h1r31",
    buttonRefreshed: "_19itidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7glyw _2rkoglpi _19pkidpf _2hwxu2gc _otyridpf _18u0v77o _4t3izwfg _1bsbzwfg _80omtlke _irr3166n _30l31r31 _1di61dty _180dglyw _9h8h1r31"
};
const $ea5b7a179b120a1d$var$Toggle = ({ icon: icon, onClick: onClick, expanded: expanded, productName: productName, numSites: numSites })=>{
    const intl = (0, $dBxQj.default)();
    const label = intl.formatMessage((0, $d3Dtl.default).sites, {
        productName: productName,
        numSites: numSites
    });
    const isVisualRefreshEnabled = (0, $eycgM.useIsSwitcherTeam25TestCohort)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: label,
        hideTooltipOnMouseDown: true,
        position: "top",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("button", {
            "aria-label": label,
            "aria-expanded": expanded,
            "data-testid": "switcher-expand-toggle",
            onClick: onClick,
            className: (0, $35pXk.default)([
                isVisualRefreshEnabled ? $ea5b7a179b120a1d$var$styles.buttonRefreshed : $ea5b7a179b120a1d$var$styles.button
            ]),
            children: icon
        })
    });
};
const $ea5b7a179b120a1d$var$ItemDropdownToggle = ({ icon: icon, onClick: onClick, intl: intl, expanded: expanded, productName: productName, numSites: numSites })=>{
    return intl ? /*#__PURE__*/ (0, $7UHDa.jsx)($ea5b7a179b120a1d$var$Toggle, {
        icon: icon,
        onClick: onClick,
        expanded: expanded,
        productName: productName,
        numSites: numSites
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($ea5b7a179b120a1d$var$Toggle, {
            icon: icon,
            onClick: onClick,
            expanded: expanded,
            productName: productName,
            numSites: numSites
        })
    });
};
var $ea5b7a179b120a1d$export$2e2bcd8739ae039 = (0, $js7oX.default)($ea5b7a179b120a1d$var$ItemDropdownToggle, {
    enforceContext: false
});

});

parcelRegister("8X9X0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cff46cbaeacd392$export$2e2bcd8739ae039);
/* themed-child-item.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $lYygP = parcelRequire("lYygP");

var $eycgM = parcelRequire("eycgM");
// temp workaround to fix mix usage of emotion and compiled css: https://hello.jira.atlassian.cloud/browse/NAVX-551
const $7cff46cbaeacd392$var$styles = {
    childItem: "_11q7yw7e _4bfu18uv _1hmsglyw _ajmmnqa1 _ca0q126e _u5f31a66 _n3td126e _19bv1a66 _syaz16l4 _19lc1hek _j6xt1y1z",
    refreshedChildItem: "_ca0q126e _u5f31a66 _n3td126e _19bv1a66 _19lc1ing _j6xt1wwy",
    iconStyles: "_2hwxr5cr"
};
var $7cff46cbaeacd392$export$2e2bcd8739ae039 = (props)=>{
    const { icon: icon, ...rest } = props;
    const isVisualRefreshEnabled = (0, $eycgM.useIsSwitcherTeam25TestCohort)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lYygP.default), {
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            className: (0, $35pXk.default)([
                $7cff46cbaeacd392$var$styles.iconStyles
            ]),
            children: icon
        }),
        ...rest,
        className: (0, $35pXk.default)([
            isVisualRefreshEnabled ? $7cff46cbaeacd392$var$styles.refreshedChildItem : $7cff46cbaeacd392$var$styles.childItem
        ])
    });
};

});

parcelRegister("g6fUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $81d0d864760ed3d9$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $4Nwes = parcelRequire("4Nwes");
function $81d0d864760ed3d9$var$_defineProperty(e, r, t) {
    return (r = $81d0d864760ed3d9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $81d0d864760ed3d9$var$_toPropertyKey(t) {
    var i = $81d0d864760ed3d9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $81d0d864760ed3d9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $81d0d864760ed3d9$var$styles = {
    image: "_2rkoglpi _1bsb1ejb _4t3i1ejb _19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66",
    container: "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bah1h6o"
};
class $81d0d864760ed3d9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { avatarUrl: avatarUrl, alt: alt } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
            className: (0, $35pXk.default)([
                $81d0d864760ed3d9$var$styles.container
            ]),
            children: [
                (!avatarUrl || this.state.imageLoadFailed) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4Nwes.AtlassianIcon), {
                    size: "medium"
                }),
                avatarUrl && !this.state.imageLoadFailed && /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
                    alt: alt,
                    src: avatarUrl,
                    onError: this.onError,
                    className: (0, $35pXk.default)([
                        $81d0d864760ed3d9$var$styles.image
                    ])
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        $81d0d864760ed3d9$var$_defineProperty(this, "state", {
            imageLoadFailed: false
        });
        $81d0d864760ed3d9$var$_defineProperty(this, "onError", ()=>{
            this.setState({
                imageLoadFailed: true
            });
        });
    }
}

});

parcelRegister("9fhu3", function(module, exports) {

$parcel$export(module.exports, "getIsEligibleForNudgeToJira", () => $3115c8606ec7b652$export$ec037696a34b52ab);
$parcel$export(module.exports, "useNudgeToJira", () => $3115c8606ec7b652$export$cb1249f4f0058a10);
/**
 * TBLZ-2123: Growth - Trailblazers experiment - More info at go/trailblazerexperiments
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $a3xa0 = parcelRequire("a3xa0");

var $96eLn = parcelRequire("96eLn");

var $7TH2w = parcelRequire("7TH2w");
const $3115c8606ec7b652$var$isWithinD1to6AI = (date)=>{
    if (date === undefined) return false;
    const now = new Date();
    const compare = new Date(date);
    if (isNaN(compare.getTime())) return false;
    const days = (0, $96eLn.daysBetween)(now, compare);
    return now > compare && days >= 1 && days <= 6;
};
const $3115c8606ec7b652$export$ec037696a34b52ab = ({ connectedSite: connectedSite, cloudId: cloudId, viewer: viewer })=>{
    const { shouldShowNewLozenge: shouldShowNewLozenge, shouldShowTryLozenge: shouldShowTryLozenge, product: product, isCurrentSite: isCurrentSite } = connectedSite;
    const isExistingLozengeShown = shouldShowNewLozenge || shouldShowTryLozenge;
    if (product?.productType !== 'JIRA_SOFTWARE' || isExistingLozengeShown || // Can't be eligible if existing lozenge is shown
    !viewer) return false;
    // Must be the current site, have a cloudId/tenantId and be viewed in EN
    const isEligibleViewer = isCurrentSite && cloudId !== undefined && (viewer.locale || '').toLowerCase().startsWith('en');
    return isEligibleViewer && $3115c8606ec7b652$var$isWithinD1to6AI(product.activationDate);
};
const $3115c8606ec7b652$export$cb1249f4f0058a10 = (experimentNudgeToJira)=>{
    const hasFiredExperiment = (0, $gwFzn.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { nudgeToJiraCohort: nudgeToJiraCohort } = experimentNudgeToJira || {};
    const { activationDate: activationDate, hasAdminAccess: hasAdminAccess, product: product, subproduct: subproduct } = experimentNudgeToJira?.attributes || {};
    const attributes = (0, $gwFzn.useMemo)(()=>({
            activationDate: activationDate,
            hasAdminAccess: hasAdminAccess,
            product: product,
            subproduct: subproduct
        }), [
        activationDate,
        hasAdminAccess,
        product,
        subproduct
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (createAnalyticsEvent && !hasFiredExperiment.current && nudgeToJiraCohort && [
            'control',
            'variation'
        ].includes(nudgeToJiraCohort)) {
            createAnalyticsEvent({
                eventType: (0, $7TH2w.TRACK_EVENT_TYPE),
                action: 'exposed',
                actionSubject: 'feature',
                actionSubjectId: 'nudgeToJiraLinkExperiment',
                attributes: {
                    ...attributes,
                    flagKey: 'nudge_to_jira_in_switcher',
                    cohort: nudgeToJiraCohort
                }
            }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
            hasFiredExperiment.current = true;
        }
    }, [
        nudgeToJiraCohort,
        attributes,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("96eLn", function(module, exports) {

$parcel$export(module.exports, "daysBetween", () => $cb84187de7e28fc2$export$416492d1a5f46c79);
// https://stackoverflow.com/questions/542938/how-to-calculate-number-of-days-between-two-dates
const $cb84187de7e28fc2$var$MILLISECONDS_IN_A_DAY = 86400000;
const $cb84187de7e28fc2$export$416492d1a5f46c79 = (firstDate, secondDate)=>{
    if (!$cb84187de7e28fc2$var$isValidDate(firstDate) || !$cb84187de7e28fc2$var$isValidDate(secondDate)) return -1;
    const first = firstDate.getTime();
    const second = secondDate.getTime();
    const millisecondsBetween = Math.abs(second - first);
    return Math.round(millisecondsBetween / $cb84187de7e28fc2$var$MILLISECONDS_IN_A_DAY);
};
// https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date/44198641#44198641
const $cb84187de7e28fc2$var$isValidDate = (date)=>{
    return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
};

});



parcelRegister("z8Sbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3895427aef7debe9$export$2e2bcd8739ae039);

var $2nPZH = parcelRequire("2nPZH");
const $3895427aef7debe9$var$messages = (0, $2nPZH.defineMessages)({
    autoProvisionedSwitcherItemConfluenceDescription: {
        id: "fabric.atlassianSwitcher.autoProvConfluenceUiUpdateExperimentDescription",
        defaultMessage: "Document collaboration"
    },
    atlassianStart: {
        id: "fabric.atlassianSwitcher.start",
        defaultMessage: "Atlassian Start"
    },
    atlassianStartAriaLabel: {
        id: "fabric.atlassianSwitcher.startAriaLabel",
        defaultMessage: "Atlassian Start opens in a new tab"
    },
    switchTo: {
        id: "fabric.atlassianSwitcher.switchTo",
        defaultMessage: "Switch to"
    },
    switchToTooltip: {
        id: "fabric.atlassianSwitcher.switchToTooltip",
        defaultMessage: "Switch to\u2026"
    },
    yourApps: {
        id: "fabric.atlassianSwitcher.yourApps",
        defaultMessage: "Your apps"
    },
    yourAppsTooltip: {
        id: "fabric.atlassianSwitcher.yourAppsTooltip",
        defaultMessage: "Your apps\u2026"
    },
    switchSitesOrAppsTooltip: {
        id: "fabric.atlassianSwitcher.switchSitesOrAppsTooltip",
        defaultMessage: "Switch sites or apps"
    },
    jwmInactiveSwitcherWithJSWItemDescription: {
        id: "fabric.atlassianSwitcher.jwmInactiveSwitcherWithJSWItemDescription",
        defaultMessage: "Manage business projects, free with Jira Software"
    },
    jwmInactiveSwitcherWithDefaultItemDescription: {
        id: "fabric.atlassianSwitcher.jwmInactiveSwitcherWithDefaultItemDescription",
        defaultMessage: "Manage projects for business teams"
    },
    organisationsLabel: {
        id: "fabric.atlassianSwitcher.organisationsLabel",
        defaultMessage: "Organisations"
    },
    switcherModalLabel: {
        id: "fabric.atlassianSwitcher.modalLabel",
        defaultMessage: "Atlassian App Switcher"
    },
    resizeBarLabel: {
        id: "fabric.atlassianSwitcher.resizeBarLabel",
        defaultMessage: "Resize app switcher"
    },
    resizeBarTooltipCollapsed: {
        id: "fabric.atlassianSwitcher.resizeBarTooltipCollapsed",
        defaultMessage: "Drag to resize{separator}Press to expand"
    },
    resizeBarTooltipExpanded: {
        id: "fabric.atlassianSwitcher.resizeBarTooltipExpanded",
        defaultMessage: "Drag to resize{separator}Press to collapse"
    },
    resizeBarValueTextLabel: {
        id: "fabric.atlassianSwitcher.resizeBarValueTextLabel",
        defaultMessage: "Width"
    },
    joinStatusText: {
        id: "fabric.atlassianSwitcher.joinStatusText",
        defaultMessage: "Join"
    },
    instantAccessStatusText: {
        id: "fabric.atlassianSwitcher.instantAccessStatusText",
        defaultMessage: "Instant access"
    },
    joinTeamStatusText: {
        id: "fabric.atlassianSwitcher.joinTeamStatusText",
        defaultMessage: "Join team"
    },
    jpdDescriptionText: {
        id: "fabric.atlassianSwitcher.jpdDescriptionText",
        defaultMessage: "Prioritize and plan new ideas"
    },
    confluenceDescriptionText: {
        id: "fabric.atlassianSwitcher.confluenceDescriptionText",
        defaultMessage: "Document and collaborate"
    },
    jiraDescriptionText: {
        id: "fabric.atlassianSwitcher.jiraDescriptionText",
        defaultMessage: "Plan and track project delivery"
    },
    jsmDescriptionText: {
        id: "fabric.atlassianSwitcher.jsmDescriptionText",
        defaultMessage: "Automate and deliver IT support"
    },
    requestAccessStatusText: {
        id: "fabric.atlassianSwitcher.requestAccessStatusText",
        defaultMessage: "Request access"
    },
    requestSentStatusText: {
        id: "fabric.atlassianSwitcher.requestSentStatusText",
        defaultMessage: "Request sent"
    },
    requestAccessPendingRequestFlagTitle: {
        id: "fabric.atlassianSwitcher.successFlag.title",
        defaultMessage: "Access request sent to Admin"
    },
    requestAccessPendingRequestFlagDescription: {
        id: "fabric.atlassianSwitcher.successFlag.description",
        defaultMessage: "You'll get an email once it's approved"
    },
    requestAccessPendingRequestFlagErrorTitle: {
        id: "fabric.atlassianSwitcher.errorFlag.title",
        defaultMessage: "We couldn't add you to {product}"
    },
    requestAccessPendingRequestFlagErrorDescription: {
        id: "fabric.atlassianSwitcher.errorFlag.description",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>."
    },
    // TBLZ-2123: Growth - Trailblazers experiment - More info at go/trailblazerexperiments
    experimentNudgeToJiraConfluenceDescription: {
        id: "fabric.atlassianSwitcher.experimentNudgeToJiraConfluenceDescription",
        defaultMessage: "Bring your projects and pages closer"
    },
    experimentNudgeToJiraDescription: {
        id: "fabric.atlassianSwitcher.experimentNudgeToJiraConfluenceDescription",
        defaultMessage: "See work in lists, boards, or backlogs"
    }
});
var $3895427aef7debe9$export$2e2bcd8739ae039 = $3895427aef7debe9$var$messages;

});

parcelRegister("04v1K", function(module, exports) {

$parcel$export(module.exports, "AdminSubsection", () => $ae25faf5e98dacf9$export$1697d2fca31a8b2f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6foy0 = parcelRequire("6foy0");

var $a3xa0 = parcelRequire("a3xa0");

var $dcO0p = parcelRequire("dcO0p");

var $4HhdG = parcelRequire("4HhdG");
const $ae25faf5e98dacf9$export$1697d2fca31a8b2f = ({ adminLinks: adminLinks })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
        children: adminLinks.map((item, groupIndex)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.NavigationAnalyticsContext), {
                data: (0, $a3xa0.getItemAnalyticsContext)(groupIndex, item.key, (0, $dcO0p.AnalyticsItemType).ADMIN),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6foy0.default), {
                    tag: "li",
                    icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4HhdG.AppIcon), {
                        iconKey: item.iconKey,
                        testId: "switcher-item-icon__admin"
                    }),
                    href: item.href,
                    testId: `switcher-item__${item.key}`,
                    children: item.label
                })
            }, item.key))
    });
};

});
parcelRegister("6foy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a15c443396d7062$export$2e2bcd8739ae039);

var $6FJLn = parcelRequire("6FJLn");

var $a3xa0 = parcelRequire("a3xa0");
//error TS2347: Untyped function calls may not accept type arguments.
//@ts-ignore TypeScript 4.2.4 upgrade
const $7a15c443396d7062$var$SwitcherItemWithEvents = (0, $a3xa0.withAnalyticsEvents)({
    onClick: (0, $a3xa0.createAndFireNavigationEvent)({
        eventType: (0, $a3xa0.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: (0, $a3xa0.SWITCHER_ITEM_SUBJECT)
    })
})((0, $6FJLn.default));
var $7a15c443396d7062$export$2e2bcd8739ae039 = $7a15c443396d7062$var$SwitcherItemWithEvents;

});


parcelRegister("8FzJP", function(module, exports) {

$parcel$export(module.exports, "PartialResultError", () => $9baa2e6f7699ab2e$export$5f1b14f40a92ce71);
/* partial-result-error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
var $iXCQx = parcelRequire("iXCQx");

var $kaECR = parcelRequire("kaECR");

var $a3xa0 = parcelRequire("a3xa0");

var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $2p7B1 = parcelRequire("2p7B1");

var $eycgM = parcelRequire("eycgM");
const $9baa2e6f7699ab2e$var$style = {
    errorIconStyles: "_otyru2gc",
    errorStyles: "_1e0c1txw _4cvr1h6o _2lx21bp4 _y3gn1h6o _19pku2gc _2hwxu2gc _otyrpxbi _18u0u2gc",
    textSpacingStyles: "_otyrv77o"
};
const $9baa2e6f7699ab2e$var$ACTION = 'rendered';
const $9baa2e6f7699ab2e$export$5f1b14f40a92ce71 = ({ emptyResult: emptyResult })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isVisualRefreshEnabled = (0, $eycgM.useIsSwitcherTeam25TestCohort)();
    const fireOperationalEvent = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useCallback((payload)=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            eventType: (0, $a3xa0.OPERATIONAL_EVENT_TYPE),
            actionSubject: (0, $a3xa0.SWITCHER_PARTIAL_RESULTS),
            action: $9baa2e6f7699ab2e$var$ACTION,
            ...payload
        }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        fireOperationalEvent({
            attributes: {
                emptyResult: emptyResult
            }
        });
    }, [
        emptyResult,
        fireOperationalEvent
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
        xcss: $9baa2e6f7699ab2e$var$style.errorStyles,
        testId: "switcher-partial-error",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                xcss: $9baa2e6f7699ab2e$var$style.errorIconStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2p7B1))), {
                    label: "",
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                xcss: isVisualRefreshEnabled ? $9baa2e6f7699ab2e$var$style.textSpacingStyles : undefined,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                    as: "p",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...emptyResult ? (0, $kaECR.default).errorEmptyPartialResults : (0, $kaECR.default).errorPartialResults
                    })
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                as: "p",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $kaECR.default).errorPartialResultsRefresh
                })
            })
        ]
    });
};

});

parcelRegister("7NMcw", function(module, exports) {

$parcel$export(module.exports, "JoinProductItem", () => $980a7e467411fcfc$export$6c6a96f5b52bb942);

var $7UHDa = parcelRequire("7UHDa");

var $2Nwuj = parcelRequire("2Nwuj");

var $dh538 = parcelRequire("dh538");

var $gwFzn = parcelRequire("gwFzn");

var $aIk0I = parcelRequire("aIk0I");

var $c6GJD = parcelRequire("c6GJD");

var $5uYFa = parcelRequire("5uYFa");

var $gtzep = parcelRequire("gtzep");

var $kBWmB = parcelRequire("kBWmB");

var $a3xa0 = parcelRequire("a3xa0");

var $dBxQj = parcelRequire("dBxQj");

var $z8Sbd = parcelRequire("z8Sbd");

var $jzhw9 = parcelRequire("jzhw9");

var $5L38b = parcelRequire("5L38b");

var $u9agA = parcelRequire("u9agA");

var $inPa6 = parcelRequire("inPa6");

var $7TH2w = parcelRequire("7TH2w");

var $4HhdG = parcelRequire("4HhdG");
var $980a7e467411fcfc$export$a4cf803cc5ad528 = /*#__PURE__*/ function(AccessRequestCapabilityType) {
    AccessRequestCapabilityType["DIRECT_ACCESS"] = "DIRECT_ACCESS";
    AccessRequestCapabilityType["REQUEST_ACCESS"] = "REQUEST_ACCESS";
    AccessRequestCapabilityType["ACCESS_EXISTS"] = "ACCESS_EXISTS";
    AccessRequestCapabilityType["ACCESS_GRANTED"] = "ACCESS_GRANTED";
    AccessRequestCapabilityType["PENDING_REQUEST_EXISTS"] = "PENDING_REQUEST_EXISTS";
    AccessRequestCapabilityType["PENDING_REQUEST_CREATED"] = "PENDING_REQUEST_CREATED";
    AccessRequestCapabilityType["DENIED_REQUEST_EXISTS"] = "DENIED_REQUEST_EXISTS";
    AccessRequestCapabilityType["APPROVED_REQUEST_EXISTS"] = "APPROVED_REQUEST_EXISTS";
    AccessRequestCapabilityType["ERROR"] = "ERROR";
    return AccessRequestCapabilityType;
}({});
const $980a7e467411fcfc$var$productMap = {
    JIRA_SOFTWARE: {
        id: 'jira-software',
        productName: 'Jira',
        description: (0, $z8Sbd.default).jiraDescriptionText,
        requestAccessStatus: (0, $z8Sbd.default).joinTeamStatusText,
        directAccessStatus: (0, $z8Sbd.default).instantAccessStatusText
    },
    CONFLUENCE: {
        id: 'confluence',
        productName: 'Confluence',
        description: (0, $z8Sbd.default).confluenceDescriptionText,
        requestAccessStatus: (0, $z8Sbd.default).joinTeamStatusText,
        directAccessStatus: (0, $z8Sbd.default).instantAccessStatusText
    },
    JIRA_PRODUCT_DISCOVERY: {
        id: 'jira-product-discovery',
        productName: 'Jira Product Discovery',
        description: (0, $z8Sbd.default).jpdDescriptionText,
        requestAccessStatus: (0, $z8Sbd.default).joinStatusText,
        directAccessStatus: (0, $z8Sbd.default).joinStatusText
    },
    JIRA_SERVICE_DESK: {
        id: 'jira-servicedesk',
        productName: 'Jira Service Management',
        description: (0, $z8Sbd.default).jsmDescriptionText,
        requestAccessStatus: (0, $z8Sbd.default).joinStatusText,
        directAccessStatus: (0, $z8Sbd.default).joinStatusText
    }
};
const $980a7e467411fcfc$var$SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $980a7e467411fcfc$var$JOIN_ACTION = 'join';
const $980a7e467411fcfc$var$REQUEST_ACTION = 'request';
function $980a7e467411fcfc$var$getPrioritisedProduct(joinableSiteLinks) {
    const sortedProducts = joinableSiteLinks.sort((a, b)=>{
        if (a.productType === 'JIRA_SOFTWARE' || a.productType === 'CONFLUENCE') return -1;
        if (b.productType === 'JIRA_SOFTWARE' || b.productType === 'CONFLUENCE') return 1;
        return -1;
    });
    const directAccess = sortedProducts.filter((link)=>link.capability === 'DIRECT_ACCESS');
    return directAccess[0] || sortedProducts[0];
}
const $980a7e467411fcfc$var$REQUEST_ACCESS_URL = '/gateway/api/invitations/v1/access-requests/request';
async function $980a7e467411fcfc$export$a4d31bf50f905ca2(product, cloudId) {
    try {
        const response = await (0, $kBWmB.fetchJson)($980a7e467411fcfc$var$REQUEST_ACCESS_URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: `ari:cloud:${product}::site/${cloudId}`
            })
        });
        const result = response.results[`ari:cloud:${product}::site/${cloudId}`];
        if (result === "ACCESS_GRANTED" || result === "ACCESS_EXISTS" || result === "PENDING_REQUEST_CREATED") return {
            status: true,
            results: response.results
        };
        return {
            status: false,
            results: response?.results
        };
    } catch (e) {
        return {
            status: false
        };
    }
}
const $980a7e467411fcfc$export$6c6a96f5b52bb942 = ({ joinableSiteLinks: joinableSiteLinks, showFlag: showFlag })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [requestSent, setRequestSent] = (0, $gwFzn.useState)(false);
    const [showSpotlight, setShowSpotlight] = (0, $gwFzn.useState)(false);
    const fireProductAccessRequested = async (product, result)=>{
        const analyticsAttributes = {
            products: [
                product
            ],
            inviteResult: [
                result
            ],
            integration: (0, $a3xa0.SWITCHER_SOURCE),
            selfRequest: true
        };
        createAnalyticsEvent({
            eventType: (0, $7TH2w.TRACK_EVENT_TYPE),
            action: 'requested',
            actionSubject: 'productAccess',
            attributes: {
                ...analyticsAttributes
            }
        }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
    };
    const fireActionedButtonClickEvent = (product, actionType)=>{
        createAnalyticsEvent({
            eventType: (0, $a3xa0.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'actionedJoinProductSpotlight',
            attributes: {
                product: product,
                actionType: actionType
            }
        }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
    };
    const fireJoinProductItemClicked = (product, actionType)=>{
        createAnalyticsEvent({
            eventType: (0, $a3xa0.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'joinProductItem',
            attributes: {
                product: product,
                actionType: actionType
            }
        }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
    };
    const onDismissItemClicked = ()=>{
        setShowSpotlight(false);
        createAnalyticsEvent({
            eventType: (0, $a3xa0.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'dismissedJoinProductSpotlight'
        }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
    };
    const onRequestAccessError = ()=>{
        createAnalyticsEvent({
            eventType: (0, $a3xa0.OPERATIONAL_EVENT_TYPE),
            action: 'failed',
            actionSubject: 'switcherRequestAccess',
            actionSubjectId: 'joinProductSpotlight'
        }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
    };
    const onGetStartedItemRequestAccessClicked = (product, cloudId, productName)=>{
        fireActionedButtonClickEvent(product, 'request');
        handleRaFlow(product, cloudId, productName);
        setShowSpotlight(false);
    };
    const onGetStartedItemJoinClicked = (product, href)=>{
        fireActionedButtonClickEvent(product, 'join');
        setShowSpotlight(false);
        href && window.open(href, '_blank');
    };
    (0, $gwFzn.useEffect)(()=>{
        // Wait for display animations prior to rendering spotlight
        setTimeout(()=>setShowSpotlight(true), 500);
    }, []);
    const handleRaFlow = async (product, cloudId, productName)=>{
        const raResponse = await $980a7e467411fcfc$export$a4d31bf50f905ca2(product, cloudId);
        if (raResponse?.status) {
            setRequestSent(true);
            showFlag?.({
                appearance: 'success',
                title: formatMessage((0, $z8Sbd.default).requestAccessPendingRequestFlagTitle),
                description: formatMessage((0, $z8Sbd.default).requestAccessPendingRequestFlagDescription),
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jzhw9))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon-success, #22A06B)"
                }),
                isAutoDismiss: true
            });
            fireProductAccessRequested(product, raResponse.results);
            return;
        }
        onRequestAccessError();
        showFlag?.({
            appearance: 'error',
            title: formatMessage((0, $z8Sbd.default).requestAccessPendingRequestFlagErrorTitle, {
                product: productName
            }),
            description: formatMessage((0, $z8Sbd.default).requestAccessPendingRequestFlagErrorDescription, {
                a: (chunks)=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__navigation-exp') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                        href: $980a7e467411fcfc$var$SUPPORT_LINK,
                        children: chunks
                    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                    /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
                        href: $980a7e467411fcfc$var$SUPPORT_LINK,
                        children: chunks
                    })
            }),
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5L38b))), {
                label: "error",
                spacing: "spacious",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_secondaryColor: "var(--ds-icon-inverse, #FFFFFF)"
            }),
            isAutoDismiss: true
        });
    };
    const cohort = (0, $c6GJD.default).getExperimentValue('joinable_products_in_switcher', 'cohort', 'not-enrolled', {
        fireExperimentExposure: false
    });
    const { cloudId: cloudId, users: users, href: href, iconKey: iconKey, label: label, productType: productType, capability: capability } = $980a7e467411fcfc$var$getPrioritisedProduct(joinableSiteLinks) || {};
    const eligible = (0, $gwFzn.useMemo)(()=>joinableSiteLinks.length > 0 && (cohort === 'variation' || cohort === 'control') && !!productType, [
        productType,
        joinableSiteLinks.length,
        cohort
    ]);
    const isEnabled = eligible && cohort === 'variation';
    (0, $gwFzn.useEffect)(()=>{
        if (eligible) {
            (0, $c6GJD.default).manuallyLogExperimentExposure('joinable_products_in_switcher');
            createAnalyticsEvent({
                eventType: (0, $a3xa0.OPERATIONAL_EVENT_TYPE),
                action: 'exposed',
                actionSubject: 'feature',
                attributes: {
                    flagKey: 'joinable_products_in_switcher',
                    cohort: cohort,
                    value: cohort
                }
            }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.SCREEN_EVENT_TYPE),
                name: 'joinProductScreen',
                attributes: {
                    eligibleProducts: joinableSiteLinks.length,
                    joinProductExperiment: cohort
                }
            }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
        }
    }, [
        eligible,
        cohort,
        createAnalyticsEvent,
        joinableSiteLinks.length,
        cloudId,
        productType
    ]);
    if (!isEnabled || !productType) return null;
    const mappedProductType = $980a7e467411fcfc$var$productMap[productType];
    if (mappedProductType?.description && (capability === 'DIRECT_ACCESS' || capability === undefined)) return /*#__PURE__*/ (0, $7UHDa.jsx)("li", {
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5uYFa.JoinableProductSpotlight), {
            product: productType,
            cloudId: cloudId,
            showSpotlight: showSpotlight,
            onDismissItemClicked: onDismissItemClicked,
            onGetStartedItemClicked: ()=>onGetStartedItemJoinClicked(mappedProductType.id, href),
            analyticsChannel: (0, $a3xa0.NAVIGATION_CHANNEL),
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.ViewedTracker), {
                    subject: "joinProductItem",
                    data: {
                        product: mappedProductType.id,
                        eligibleProducts: joinableSiteLinks.length,
                        joinProductExperiment: cohort,
                        actionType: $980a7e467411fcfc$var$JOIN_ACTION
                    }
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gtzep.default), {
                    icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4HhdG.AppIcon), {
                        iconKey: iconKey
                    }),
                    href: href,
                    users: users,
                    onItemClick: ()=>fireJoinProductItemClicked(mappedProductType.id, $980a7e467411fcfc$var$JOIN_ACTION),
                    target: "_blank",
                    rel: "noreferrer",
                    description: formatMessage(mappedProductType.description),
                    tag: "div",
                    maxCount: 2,
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                        space: "space.100",
                        alignBlock: "center",
                        children: [
                            label,
                            ' ',
                            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aIk0I.default), {
                                appearance: "new",
                                children: [
                                    formatMessage(mappedProductType.directAccessStatus),
                                    ' '
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
    if (mappedProductType?.id && capability === 'REQUEST_ACCESS') return /*#__PURE__*/ (0, $7UHDa.jsx)("li", {
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5uYFa.JoinableProductSpotlight), {
            cloudId: cloudId,
            product: productType,
            showSpotlight: showSpotlight,
            onDismissItemClicked: onDismissItemClicked,
            onGetStartedItemClicked: ()=>onGetStartedItemRequestAccessClicked(mappedProductType.id, cloudId, mappedProductType.productName),
            analyticsChannel: (0, $a3xa0.NAVIGATION_CHANNEL),
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.ViewedTracker), {
                    subject: "joinProductItem",
                    data: {
                        product: mappedProductType.id,
                        eligibleProducts: joinableSiteLinks.length,
                        joinProductExperiment: cohort,
                        actionType: $980a7e467411fcfc$var$REQUEST_ACTION
                    }
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gtzep.default), {
                    icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4HhdG.AppIcon), {
                        iconKey: iconKey
                    }),
                    users: users,
                    onItemClick: ()=>{
                        fireJoinProductItemClicked(mappedProductType.id, $980a7e467411fcfc$var$REQUEST_ACTION);
                        handleRaFlow(mappedProductType.id, cloudId, mappedProductType.productName);
                    },
                    description: formatMessage(mappedProductType.description),
                    tag: "div",
                    maxCount: 2,
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                        space: "space.100",
                        alignBlock: "center",
                        children: [
                            label,
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
                                appearance: "new",
                                children: requestSent ? formatMessage((0, $z8Sbd.default).requestSentStatusText) : formatMessage(mappedProductType.requestAccessStatus)
                            })
                        ]
                    })
                })
            ]
        })
    });
    return null;
};

});
parcelRegister("5uYFa", function(module, exports) {

$parcel$export(module.exports, "JoinableProductSpotlight", () => $4cbc0bfb2bb4bc9b$export$522ddf3d2279e159);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $5loD0 = parcelRequire("5loD0");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $7TH2w = parcelRequire("7TH2w");

var $inPa6 = parcelRequire("inPa6");

var $5RBJ9 = parcelRequire("5RBJ9");
var $6cnUO = parcelRequire("6cnUO");
var $5izcQ = parcelRequire("5izcQ");
var $2Fndw = parcelRequire("2Fndw");

var $5XfQZ = parcelRequire("5XfQZ");

const $4cbc0bfb2bb4bc9b$var$AnimationIllustration = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7qZQE")));
const $4cbc0bfb2bb4bc9b$var$SPOTLIGHT_MESSAGE_ID = {
    JIRA_SOFTWARE: 'joinable-product-switcher-jira',
    CONFLUENCE: 'joinable-product-switcher-confluence',
    JIRA_PRODUCT_DISCOVERY: 'joinable-product-switcher-jpd',
    JIRA_SERVICE_DESK: 'joinable-product-switcher-jsm'
};
const $4cbc0bfb2bb4bc9b$var$REMINDER_MESSAGE_ID = {
    JIRA_SOFTWARE: 'joinable-product-jira-reminder',
    CONFLUENCE: 'joinable-product-confluence-reminder',
    JIRA_PRODUCT_DISCOVERY: 'joinable-product-jpd-reminder',
    JIRA_SERVICE_DESK: 'joinable-product-jsm-reminder'
};
const $4cbc0bfb2bb4bc9b$var$productMessages = {
    CONFLUENCE: {
        productName: 'Confluence',
        description: (0, $5XfQZ.messages).confluenceDescription
    },
    JIRA_SOFTWARE: {
        productName: 'Jira',
        description: (0, $5XfQZ.messages).jiraDescription
    },
    JIRA_PRODUCT_DISCOVERY: {
        productName: 'Jira Product Discovery',
        description: (0, $5XfQZ.messages).jiraProductDiscoveryDescription
    },
    JIRA_SERVICE_DESK: {
        productName: 'Jira Service Management',
        description: (0, $5XfQZ.messages).jiraServiceManagementDescription
    }
};
const $4cbc0bfb2bb4bc9b$var$ContainerStyles = null;
const $4cbc0bfb2bb4bc9b$var$LargeContainerStyles = null;
const $4cbc0bfb2bb4bc9b$var$HeadingDivStyles = null;
const $4cbc0bfb2bb4bc9b$var$AnimationContainerStyles = null;
const $4cbc0bfb2bb4bc9b$export$522ddf3d2279e159 = ({ children: children, showSpotlight: showSpotlight, onGetStartedItemClicked: onGetStartedItemClicked, onDismissItemClicked: onDismissItemClicked, cloudId: cloudId, product: product, analyticsChannel: analyticsChannel })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [spotlightEligible, setSpotlightEligible] = (0, $gwFzn.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [spotlightReason, setSpotlightReason] = (0, $gwFzn.useState)();
    const coordinationClient = (0, $gwFzn.useMemo)(()=>{
        try {
            return new (0, $5loD0.default)({
                cloudId: cloudId,
                stargateUrl: '/gateway/api'
            });
        } catch (_) {
            return null;
        }
    }, [
        cloudId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const fireSpotlightScreenEvent = (spotlightReason)=>{
            createAnalyticsEvent({
                eventType: (0, $7TH2w.SCREEN_EVENT_TYPE),
                name: 'joinProductSpotlight',
                attributes: {
                    spotlightReason: spotlightReason,
                    product: product
                }
            }).fire(analyticsChannel);
        };
        const fireNotEligibleOperational = (reason)=>{
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'joinableProductSpotlightEligibility',
                attributes: {
                    reason: reason
                }
            }).fire(analyticsChannel);
        };
        const checkSpotlightEligibility = async (coordinationClient)=>{
            try {
                const startedProductCheck = await coordinationClient.start($4cbc0bfb2bb4bc9b$var$SPOTLIGHT_MESSAGE_ID[product]);
                if (startedProductCheck) {
                    setSpotlightReason('firstTime');
                    setSpotlightEligible(startedProductCheck);
                    fireSpotlightScreenEvent('firstTime');
                    return;
                }
                const sevenDayReminder = await coordinationClient.start($4cbc0bfb2bb4bc9b$var$REMINDER_MESSAGE_ID[product]);
                if (sevenDayReminder) {
                    setSpotlightReason('sevenDayReminder');
                    setSpotlightEligible(sevenDayReminder);
                    fireSpotlightScreenEvent('reminder');
                    return;
                }
                fireNotEligibleOperational('not-eligible');
            } catch (_) {
                fireNotEligibleOperational('error');
            }
        };
        if (coordinationClient && showSpotlight) checkSpotlightEligibility(coordinationClient);
    }, [
        coordinationClient,
        product,
        showSpotlight,
        createAnalyticsEvent,
        analyticsChannel
    ]);
    const onDismissSpotlight = async ()=>{
        onDismissItemClicked?.();
        await coordinationClient?.stop(spotlightReason === 'firstTime' ? $4cbc0bfb2bb4bc9b$var$SPOTLIGHT_MESSAGE_ID[product] : $4cbc0bfb2bb4bc9b$var$REMINDER_MESSAGE_ID[product]);
    };
    const onRequestOrJoinSite = async ()=>{
        onGetStartedItemClicked?.();
        await coordinationClient?.stop(spotlightReason === 'firstTime' ? $4cbc0bfb2bb4bc9b$var$SPOTLIGHT_MESSAGE_ID[product] : $4cbc0bfb2bb4bc9b$var$REMINDER_MESSAGE_ID[product]);
    };
    const { productName: productName, description: description } = $4cbc0bfb2bb4bc9b$var$productMessages[product];
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6cnUO.default), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5izcQ.default), {
                name: "joinableProductSpotlight",
                children: children
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Fndw.default), {
                children: showSpotlight && spotlightEligible && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5RBJ9.default), {
                    testId: "testId-joinable-product-in-switcher-spotlight",
                    dialogPlacement: 'right top',
                    dialogWidth: 330,
                    actions: [
                        {
                            onClick: onRequestOrJoinSite,
                            text: formatMessage((0, $5XfQZ.messages).getStartedButtonText)
                        },
                        {
                            onClick: onDismissSpotlight,
                            text: formatMessage((0, $5XfQZ.messages).dismissButtonText)
                        }
                    ],
                    header: ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                            className: (0, $35pXk.default)([
                                product === 'CONFLUENCE' ? "_4t3i1lit" : "_4t3imgvx"
                            ]),
                            children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                                className: (0, $35pXk.default)([
                                    "_kqswstnw _154iidpf _1ltvidpf _1bsb1ns9"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                                        fallback: null,
                                        children: /*#__PURE__*/ (0, $7UHDa.jsx)($4cbc0bfb2bb4bc9b$var$AnimationIllustration, {
                                            product: product
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                                        className: (0, $35pXk.default)([
                                            "_ca0qutpp _u5f3v47k _n3tdidpf _19bvv47k"
                                        ]),
                                        children: children
                                    })
                                ]
                            })
                        }),
                    heading: formatMessage((0, $5XfQZ.messages).spotlightTitleMessage, {
                        product: productName
                    }),
                    target: "joinableProductSpotlight",
                    targetRadius: 3,
                    targetBgColor: "var(--ds-icon-inverse, #FFFFFF)",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...description
                    })
                }, "joinableProductSpotlight")
            })
        ]
    });
};

});
parcelRegister("5XfQZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $150c24d309f38aa9$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $150c24d309f38aa9$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    spotlightTitleMessage: {
        id: "cross-joinable-products-in-switcher.title",
        defaultMessage: "Join your team in {product}"
    },
    getStartedButtonText: {
        id: "cross-joinable-products-in-switcher.getStartedButton.text",
        defaultMessage: "Get started"
    },
    dismissButtonText: {
        id: "cross-joinable-products-in-switcher.dismissButton.text",
        defaultMessage: "No thanks"
    },
    confluenceDescription: {
        id: "cross-joinable-products-in-switcher.confluence.description",
        defaultMessage: "Edit together in real-time, align teams, and unify documentation for faster delivery."
    },
    jiraDescription: {
        id: "cross-joinable-products-in-switcher.request-access-error-flag.description-support-link",
        defaultMessage: "Plan, organize, and track work in one place to ship projects faster."
    },
    jiraProductDiscoveryDescription: {
        id: "cross-joinable-products-in-switcher.request-access-error-flag.description-support-link",
        defaultMessage: "Prioritize ideas, plan roadmaps, and unify your workflow from discovery to delivery."
    },
    jiraServiceManagementDescription: {
        id: "cross-joinable-products-in-switcher.request-access-error-flag.description-support-link",
        defaultMessage: "Automate workflows and view support requests in one place to deliver faster, superior IT service."
    }
});

});

parcelRegister("7qZQE", function(module, exports) {

let $569aefdc6449431b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $569aefdc6449431b$var$load("ej4rO"),
    $569aefdc6449431b$var$load("5dGIX")
]).then(()=>parcelRequire('6IPlc'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});






parcelRegister("bfFYO", function(module, exports) {

$parcel$export(module.exports, "CustomLinksSection", () => $ef264a7667c2640a$export$f130c4818eb40eea);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $fJvXe = parcelRequire("fJvXe");
var $6foy0 = parcelRequire("6foy0");

var $a3xa0 = parcelRequire("a3xa0");

var $kaECR = parcelRequire("kaECR");

var $dcO0p = parcelRequire("dcO0p");

var $4jR19 = parcelRequire("4jR19");

var $grirN = parcelRequire("grirN");
var $88ga6 = parcelRequire("88ga6");

var $4HhdG = parcelRequire("4HhdG");

var $eycgM = parcelRequire("eycgM");
const $ef264a7667c2640a$export$f130c4818eb40eea = ({ customLinks: customLinks })=>{
    (0, $88ga6.useExperienceSuccess)((0, $grirN.Experience).RENDER_CUSTOM_LINKS_SECTION);
    const isVisualRefreshEnabled = (0, $eycgM.useIsSwitcherTeam25TestCohort)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fJvXe.SectionContainer), {
        sectionId: "customLinks",
        title: isVisualRefreshEnabled ? undefined : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $kaECR.default).more
        }),
        children: customLinks.map(({ analyticsAttributes: analyticsAttributes, label: label, href: href, iconKey: iconKey }, groupIndex)=>// todo: id in SwitcherItem should be consumed from custom link resolver
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.NavigationAnalyticsContext), {
                data: (0, $a3xa0.getItemAnalyticsContext)(groupIndex, null, (0, $dcO0p.AnalyticsItemType).CUSTOM_LINK, undefined, analyticsAttributes),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6foy0.default), {
                    tag: "li",
                    icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4HhdG.AppIcon), {
                        iconKey: iconKey,
                        testId: "switcher-item-icon__custom"
                    }),
                    href: href,
                    children: label
                })
            }, groupIndex + '.' + label))
    });
};

});

parcelRegister("jhVsa", function(module, exports) {

$parcel$export(module.exports, "default", () => $67e0fe7c51fccd6f$export$2e2bcd8739ae039);
/* empty-state-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4jR19 = parcelRequire("4jR19");

var $eEA8O = parcelRequire("eEA8O");

var $gdv5Z = parcelRequire("gdv5Z");
var $iXCQx = parcelRequire("iXCQx");

var $7hXDW = parcelRequire("7hXDW");

var $792JG = parcelRequire("792JG");

var $kaECR = parcelRequire("kaECR");

var $dcO0p = parcelRequire("dcO0p");

var $a3xa0 = parcelRequire("a3xa0");

var $grirN = parcelRequire("grirN");
var $88ga6 = parcelRequire("88ga6");
const $67e0fe7c51fccd6f$var$styles = {
    content: "_1e0c1txw _4cvr1h6o _1bah1h6o _2lx21bp4",
    bannerWrapper: "_otyr1ejb _4t3inbzd",
    title: "_19pkidpf _otyrpxbi",
    body: "_19pkidpf _otyr1ejb _y3gn1h6o"
};
const $67e0fe7c51fccd6f$var$EXPLORE_PRODUCTS_LINK_ANALYTIC_KEY = 'explore-products';
const $67e0fe7c51fccd6f$var$EmptyStateContent = ({ exploreProductsLink: exploreProductsLink })=>{
    (0, $88ga6.useExperienceSuccess)((0, $grirN.Experience).RENDER_SWITCHER_EMPTY_STATE);
    const buttonProps = {
        href: exploreProductsLink,
        target: '_blank',
        rel: 'noopener noreferrer'
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        "data-testid": "empty-state-content",
        className: (0, $35pXk.default)([
            $67e0fe7c51fccd6f$var$styles.content
        ]),
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                xcss: $67e0fe7c51fccd6f$var$styles.bannerWrapper,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
                    src: (0, $792JG.default),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                xcss: $67e0fe7c51fccd6f$var$styles.title,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                    size: "medium",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...(0, $kaECR.default).emptyStateExploreProductsTitle
                    })
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                xcss: $67e0fe7c51fccd6f$var$styles.body,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                    as: "p",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...(0, $kaECR.default).emptyStateExploreProductsBody
                    })
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.NavigationAnalyticsContext), {
                data: (0, $a3xa0.getItemAnalyticsContext)(0, $67e0fe7c51fccd6f$var$EXPLORE_PRODUCTS_LINK_ANALYTIC_KEY, (0, $dcO0p.AnalyticsItemType).EMPTY_STATE_EXPLORE_PRODUCTS),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                    appearance: "link",
                    ...buttonProps,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...(0, $kaECR.default).emptyStateExploreProductsLink
                    })
                })
            }, $67e0fe7c51fccd6f$var$EXPLORE_PRODUCTS_LINK_ANALYTIC_KEY)
        ]
    });
};
var $67e0fe7c51fccd6f$export$2e2bcd8739ae039 = $67e0fe7c51fccd6f$var$EmptyStateContent;

});
parcelRegister("792JG", function(module, exports) {

$parcel$export(module.exports, "default", () => $80833b01d351f8a3$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // TODO: https://product-fabric.atlassian.net/browse/DSP-3818
var $80833b01d351f8a3$export$2e2bcd8739ae039 = `data:image/svg+xml,%3Csvg fill='none' viewBox='0 0 249 211' width='249' height='211' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23j)'%3E%3Crect width='248.1' height='210.9' fill='%23fff' fill-opacity='.01'/%3E%3Cpath d='m24.83 210.9c9.3013 0 16.842-1.459 16.842-3.259 0-1.799-7.5402-3.258-16.842-3.258s-16.841 1.459-16.841 3.258c0 1.8 7.5402 3.259 16.841 3.259z' fill='url(%23i)' opacity='.25'/%3E%3Cpath d='m44.906 73.438-0.6505-1.5097c1.0327-0.3881 1.3511-0.7336 1.3739-0.8743 0.0364-0.1962-0.4095-0.627-0.7052-0.9127-0.5641-0.5459-1.342-1.3008-1.0236-2.269 0.2366-0.725 0.9235-1.0065 1.3785-1.1899 0.141-0.0597 0.3821-0.1578 0.4367-0.2132-0.0136-0.2047-0.6869-0.8615-0.9735-1.1473-0.6733-0.6525-1.4331-1.3946-0.9145-2.2092 0.3822-0.6014 1.1328-0.5843 1.6287-0.5715 0.1911 0.0043 0.5914 0.0128 0.6869-0.0469 0-0.0043 0.1729-0.3455-0.3958-1.5908l1.5968-0.6398c0.2685 0.5971 1.0919 2.4097 0 3.4034-0.4094 0.3711-0.9235 0.4734-1.3829 0.499 0.0091 0.0086 0.0182 0.0171 0.0227 0.0256 0.7825 0.7592 1.7515 1.706 1.3602 2.8106-0.2547 0.7122-0.9326 0.9852-1.3829 1.1686-0.1502 0.0597-0.3731 0.1535-0.4277 0.2047 0.0546 0.0682 0.414 0.418 0.6324 0.6269 0.5686 0.5545 1.3466 1.3094 1.1646 2.3159-0.141 0.87-0.9372 1.5609-2.4248 2.1196z' fill='%230065FF'/%3E%3Cpath d='m211.61 26.835-145.75 12.995c-1.8743 0.1664-3.3847 2.1112-3.3847 4.3374v94.664c0 2.231 1.5104 4.184 3.3847 4.363l45.806 4.445v27.069l36.276 4.491-0.245-28.063 63.908 6.197c3.012 0.29 5.468-1.783 5.468-4.636v-121.18c5e-3 -2.8532-2.456-4.9473-5.468-4.6786z' fill='url(%23h)'/%3E%3Cpath d='m67.334 131.11v-85.58l141.95-11.174v107.4l-141.95-10.645z' fill='%23B2D4FF'/%3E%3Cpath d='m118.33 47.545-30.917 2.1239v76.914l30.917 2.013v-81.051z' fill='%23fff'/%3E%3Cpath d='m201.8 134.02-78.325-5.088v-49.839l78.325-1.2966v56.224z' fill='%23fff'/%3E%3Cpath d='m131.92 121.54v-34.674l61.438-1.0193v39.684l-61.438-3.991z' fill='%23DEEBFF'/%3E%3Cpath d='m201.8 70.077-78.325 2.1709v-25.056l78.325-5.3823v28.268z' fill='%23fff'/%3E%3Cpath d='m140.98 58.783c0 3.2499-2.497 5.9794-5.55 6.0988-3.025 0.1194-5.454-2.3755-5.454-5.5699 0-3.1945 2.429-5.9197 5.454-6.0946 3.053-0.1706 5.55 2.3158 5.55 5.5657z' fill='%23DEEBFF'/%3E%3Cpath d='m171.87 51.213 3.58 6.0007-3.58 6.3462-7.042 0.273-3.462-5.941 3.462-6.2737 7.042-0.4052z' fill='%23DEEBFF'/%3E%3Cpath d='m150.35 52.36 6.733 11.682-13.324 0.5204 6.591-12.202z' fill='%23B2D4FF'/%3E%3Cpath d='m193.98 62.698-13.015 0.5075v-12.616l13.015-0.7506v12.859z' fill='%23B2D4FF'/%3E%3Cpath d='m111.41 134.41 36.617 2.747v-47.784c0-9.6898-8.553-17.46-18.884-17.158-9.881 0.29-17.733 7.8858-17.733 17.158v45.038z' fill='%230065FF'/%3E%3Cg opacity='.15'%3E%3Cpath d='m115.88 78.146c1.369 5.1392 4.108 10.197 8.321 13.516 5.436 4.282 8.748 2.0259 14.243 6.214 9.308 7.0925 7.225 19.426 9.59 23.786v-32.286c0-9.6898-8.552-17.46-18.884-17.158-5.313 0.1578-10.036 2.4267-13.27 5.9282z' fill='%23091E42' opacity='.15'/%3E%3C/g%3E%3Cpath d='m148.02 137.16v-10.108l-36.449 7.374 36.449 2.734z' fill='%230049B0'/%3E%3Cpath d='m111.41 134.41 36.617 2.747-69.509 72.158-41.485-6.671 74.377-68.234z' fill='url(%23g)'/%3E%3Cpath d='m81.246 130.58c-0.5004-0.09-0.9007-0.9-0.7187-1.548 0.1546-0.568 0.7096-0.849 0.8188-0.904 0.4049-0.205 0.5414-0.077 1.0236-0.222 0.9827-0.299 1.4058-1.139 1.6332-1.02 0.0546 0.03 0.1047 0.12 0.0683 0.393 0.0546 8e-3 0.1319 0.025 0.1683 0.081 0.0773 0.119-0.0819 0.333-0.1592 0.431-0.778 1.015-1.1647 1.522-1.4558 1.791-0.7506 0.695-1.1282 1.041-1.3785 0.998z' fill='%23D4B696'/%3E%3Cpath d='m81.801 127.06c-0.3549 0.171-0.5414 0.456-0.5869 0.525-0.2366 0.366-0.969 1.509-0.6369 1.782 0.1592 0.133 0.4959 5e-3 0.6506-0.085 0.3048-0.171 0.2183-0.614 0.514-0.861 0.0637-0.056 0.0956-0.086 0.1638-0.15 0.1592-0.153 0.2411-0.23 0.2229-0.277-0.0318-0.094-0.3002-0.026-0.3821-0.145-0.1502-0.205 0.4549-0.759 0.3503-0.866-0.0455-0.042-0.232 0.047-0.2957 0.077z' fill='%23D4B696'/%3E%3Cpath d='m83.775 128.78c-0.2048 0.26-0.3913 0.35-0.7643 0.597-1.0009 0.652-1.5104 1.211-1.5786 1.151-0.041-0.034 0.1092-0.238 0.1956-0.349 0.6687-0.892 2.2019-2.606 2.493-2.41 0.1365 0.094-0.0546 0.64-0.3457 1.011z' fill='%23D4B696'/%3E%3Cpath d='m80.486 129.62 0.4868 1.894 1.6059-0.282-0.2047-1.612h-1.888z' fill='%23D4B696'/%3E%3Cpath d='m59.491 125.6c0.4913 0.136 1.2374-0.418 1.392-1.071 0.1365-0.571-0.2183-1.057-0.2911-1.156-0.2593-0.354-0.4459-0.298-0.8052-0.635-0.7279-0.687-0.7006-1.612-0.9599-1.604-0.0637 5e-3 -0.1502 0.06-0.2503 0.32-0.05-0.017-0.1273-0.034-0.1865 0-0.1274 0.073-0.091 0.333-0.0682 0.452 0.2001 1.237 0.3002 1.851 0.4276 2.218 0.3276 0.938 0.5004 1.407 0.7416 1.476z' fill='%23D4B696'/%3E%3Cpath d='m60.706 122.22c0.232 0.303 0.2639 0.635 0.2684 0.716 0.0319 0.427 0.132 1.758-0.2957 1.86-0.2047 0.051-0.4458-0.209-0.5413-0.354-0.1866-0.282 0.1046-0.64-0.041-0.985-0.0318-0.077-0.0455-0.12-0.0728-0.201-0.0682-0.204-0.1046-0.307-0.0682-0.341 0.0773-0.068 0.2775 0.102 0.4094 0.034 0.232-0.119-0.0364-0.87 0.1092-0.921 0.0728-0.017 0.1911 0.141 0.232 0.192z' fill='%23D4B696'/%3E%3Cpath d='m58.113 122.92c0.0546 0.32 0.1774 0.482 0.3913 0.857 0.5732 1.007 0.7597 1.723 0.8507 1.702 0.05-0.013 0.0182-0.26-0.0046-0.397-0.1637-1.079-0.696-3.263-1.0509-3.211-0.1728 0.025-0.2638 0.597-0.1865 1.049z' fill='%23D4B696'/%3E%3Cpath d='m59.032 124.9-0.5505 1.433 1.756 0.252 0.646-2.06-1.8515 0.375z' fill='%23D4B696'/%3E%3Cpath d='m64.627 154.4c-0.1911 0.755-0.4458 1.889-0.6324 3.279-0.2365 1.753-0.2957 3.353-0.1319 7.647 0.0637 1.642 0.1592 3.749 0.3139 6.202-0.0682 1.019-0.1274 2.06-0.1638 3.113-0.1546 4.069-0.0591 7.933 0.2093 11.562 0.8143 9e-3 1.6332 0.021 2.4475 0.03 0.2184-3.416 0.5186-6.922 0.9053-10.504 0.1411-1.306 0.2912-2.598 0.4504-3.877 0.1047-0.819 0.2821-2.133 0.5232-3.745 1.1055-7.378 1.8515-9.297 0.6278-11.131-0.4913-0.73-1.6287-1.949-4.5493-2.576z' fill='url(%23f)'/%3E%3Cpath d='m72.343 154.08c2.8797 3.458 5.9323 7.527 8.9075 12.223 3.1026 4.896 5.5228 9.54 7.4199 13.707-0.8098 0.218-1.6196 0.435-2.4339 0.653-0.8416-1.058-1.897-2.384-3.1117-3.915-2.2564-2.849-2.8024-3.562-3.4438-4.619-1.01-1.676-1.615-3.165-1.9653-4.163-1.3238-0.661-2.4885-1.25-3.4484-1.736-3.5893-1.817-6.6874-3.42-8.8438-5.689-0.8234-0.866-1.4921-1.808-1.433-2.862 0.0136-0.2 0.0864-0.584 0.232-1.339 0.1501-0.776 0.2866-1.412 0.3776-1.834 0.9417 0.085 1.9926 0.128 3.139 0.098 1.7606-0.051 3.3073-0.264 4.6039-0.524z' fill='url(%23e)'/%3E%3Cpath d='m88.229 178.36c0.3003 0.712 0.7006 1.522 1.242 2.371 0.6005 0.943 1.7378 1.463 2.8979 1.331 0.7324-0.081 1.4603-0.167 2.1927-0.248 0.0637 0.192 0.0501 0.15 0.1183 0.341-1.019 0.529-2.0381 1.058-3.0617 1.587-0.3139 0.026-1.201 0.107-1.2465 0.388-0.0091 0.06 0.0182 0.149 0.182 0.273-0.2821 0.132-0.5732 0.265-0.8735 0.392-0.3048 0.128-0.6642 0.03-0.8461-0.23-0.8507-1.203-3.1436-4.461-3.3665-4.951 0.9189-0.418 1.8379-0.836 2.7614-1.254z' fill='%23253858'/%3E%3Cpath d='m66.847 184.92c-0.0683 0.333-0.1411 1.177-0.1866 2.022-0.0682 1.232 0.6551 2.384 1.8425 2.917 0.464 0.209 0.9326 0.422 1.3966 0.631-0.05 0.175-0.0409 0.141-0.0864 0.316-1.06-0.064-2.12-0.128-3.1845-0.192-0.2548-0.128-0.9781-0.469-1.1601-0.277-0.0409 0.042-0.0637 0.123-0.0045 0.294-0.4413-0.043-0.8962-0.098-1.3694-0.175-0.0637-0.073-0.1092-0.128-0.1683-0.205 0.0091-0.132 0.0182-0.294 0.0273-0.482 0.0728-1.693 0.0137-4.572 0.1137-5.16 0.9235 0.102 1.8516 0.205 2.7797 0.311z' fill='%23253858'/%3E%3Cpath d='m73.476 143.13c-4.149-0.303-7.1424-0.713-7.3517-0.798-0.1865-0.077-0.3776-0.162-0.3776-0.162-0.0591-0.026-0.1137-0.051-0.182-0.081-1.5285-0.7-5.0997-2.678-6.3053-6.82-1.3602-4.678 1.3239-8.41 1.7106-8.935-0.8962-0.14-1.7925-0.277-2.6932-0.418-0.7279 1.152-2.8524 4.841-2.0062 9.494 0.7597 4.158 3.4802 6.824 4.7039 8.022 1.2374 1.212 2.443 2.047 3.3119 2.581 0.3184 0.917 0.6232 2.085 0.7461 3.454 0.2047 2.278-0.182 4.167-0.5596 5.425 2.9161 0.09 5.8322 0.175 8.7483 0.265-1.0964-1.224-1.2329-2.133-1.151-2.747 0.1865-1.373 1.5832-1.975 1.6878-3.604 0.041-0.652-0.141-1.198-0.2911-1.544 1.0463-0.179 5.4364-1.04 8.3706-4.84 4.2172-5.464 1.4877-11.904 1.3102-12.296-0.9053 0.465-1.806 0.93-2.7113 1.394 0.3594 0.704 0.8689 2.888 0.7642 4.325-0.2775 3.996-3.9624 7.361-7.7246 7.285z' fill='%230065FF'/%3E%3Cpath d='m70.409 136.93c-0.0636 0.043-0.1637 0.09-0.3184 0.158-0.4276 0.188-0.6869 0.367-0.8416 0.542-0.3958 0.448 0.1092 0.985-0.0501 1.991-0.0182 0.103-0.0682 0.397-0.0273 0.785 0.0182 0.196 0.0546 0.337 0.0637 0.371 0.0683 0.299 0.0501 0.947-0.2866 2.427 0.141-0.077 0.2821-0.158 0.4231-0.235 0.4003-0.277 0.8052-0.554 1.2056-0.831 0.7915-0.857 0.9781-1.007 0.8552-1.437-0.1501-0.517-0.4094-1.421-0.3867-1.463 0.2321-0.367 0.6187-0.525 0.2048-0.794-0.2366-0.153-0.414-0.26-0.4732-0.29-0.1865-0.085-0.3776-0.366-0.3685-1.224z' fill='%23D4B696'/%3E%3Cpath d='m69.277 137.6c0.4458 1.164 0.9781 3.062 0.787 5.391-0.0045 0.059-0.0091 0.119-0.0182 0.179-0.232 2.354-2.6659 4.013-5.0952 3.373-0.0819-0.021-0.1683-0.046-0.2502-0.072-0.0137-4e-3 -0.0273-9e-3 -0.041-0.013-1.5149-0.486-2.1836-2.132-1.4648-3.476 0.4822-0.904 0.737-1.706 0.8825-2.367 0.4413-2.03-0.0637-3.25 1.01-4.282 0.8189-0.785 2.0972-1.023 2.5203-1.104 0.8189-0.154 1.251-0.056 1.4603 0.025 0.5004 0.184 0.8234 0.465 0.9781 0.623 0.3776 0.367 0.555 0.755 0.6415 0.981-0.182 0.06-0.3822 0.136-0.5915 0.239-0.3411 0.157-0.6141 0.341-0.8188 0.503z' fill='%23172B4D'/%3E%3Cpath d='m79.145 190.03c8.8619-2.327 15.538-5.912 14.912-8.008-0.6261-2.096-8.3176-1.908-17.18 0.419-8.8618 2.327-15.538 5.912-14.912 8.008 0.6261 2.095 8.3177 1.908 17.18-0.419z' fill='%23091E42' opacity='.15'/%3E%3Cpath d='m42.6 88.053h-1.8606v2.866h1.8606v-2.866z' fill='%2348CC8C'/%3E%3Cpath d='m69.736 25.376h-1.8606v2.866h1.8606v-2.866z' fill='%2348CC8C'/%3E%3Cpath d='m32.88 41.755-1.3157 1.2335 2.1617 2.0265 1.3156-1.2334-2.1616-2.0266z' fill='%23165ECC'/%3E%3Cpath d='m183.75 21.181-1.316 1.2335 2.162 2.0265 1.316-1.2334-2.162-2.0266z' fill='%2348CC8C'/%3E%3Cpath d='m105.42 0h-1.86v2.866h1.86v-2.866z' fill='%23FFC400'/%3E%3Cpath d='m231.1 62.351-1.315 1.2335 2.161 2.0265 1.316-1.2334-2.162-2.0266z' fill='%23165ECC'/%3E%3Cpath d='m236.3 41.756-1.316 1.2334 2.162 2.0266 1.316-1.2334-2.162-2.0266z' fill='%2348CC8C'/%3E%3Cpath d='m25.616 68.53-1.3156-1.2334-2.1617 2.0266 1.3157 1.2334 2.1616-2.0266z' fill='%23FFC400'/%3E%3Cpath d='m116.48 19.489-1.316-1.2334-2.162 2.0265 1.316 1.2335 2.162-2.0266z' fill='%23165ECC'/%3E%3Cpath d='m160.76 8.6057-1.316-1.2334-2.162 2.0266 1.316 1.2334 2.162-2.0265z' fill='%23165ECC'/%3E%3Cpath d='m248.1 66.898-1.315-1.2334-2.162 2.0266 1.316 1.2334 2.161-2.0266z' fill='%23FFC400'/%3E%3Cpath d='m130.62 15.55-0.65-1.5098c1.032-0.3881 1.351-0.7336 1.373-0.8743 0.037-0.1962-0.409-0.627-0.705-0.9127-0.564-0.5459-1.342-1.3008-1.023-2.2689 0.236-0.72504 0.923-1.0065 1.378-1.1899 0.141-0.05971 0.382-0.15781 0.437-0.21325-0.014-0.20472-0.687-0.86151-0.974-1.1473-0.673-0.65253-1.433-1.3946-0.914-2.2092 0.382-0.60135 1.133-0.58429 1.629-0.5715 0.191 0.00427 0.591 0.0128 0.687-0.04691 0-0.00427 0.172-0.34546-0.396-1.5908l1.597-0.63974c0.268 0.59709 1.091 2.4097 0 3.4034-0.41 0.37105-0.924 0.47341-1.383 0.499 9e-3 0.00853 0.018 0.01706 0.022 0.02558 0.783 0.75916 1.752 1.706 1.361 2.8106-0.255 0.71225-0.933 0.98519-1.383 1.1686-0.151 0.0597-0.373 0.1535-0.428 0.2047 0.055 0.0683 0.414 0.418 0.632 0.627 0.569 0.5544 1.347 1.3093 1.165 2.3158-0.141 0.8658-0.937 1.561-2.425 2.1197z' fill='%230065FF'/%3E%3Cpath d='m232.21 101.26-0.651-1.5099c1.033-0.3881 1.351-0.7336 1.374-0.8743 0.037-0.1962-0.409-0.627-0.705-0.9127-0.564-0.5459-1.342-1.3008-1.024-2.269 0.237-0.725 0.924-1.0065 1.379-1.1899 0.141-0.0597 0.382-0.1578 0.437-0.2132-0.014-0.2047-0.687-0.8615-0.974-1.1473-0.673-0.6525-1.433-1.3946-0.914-2.2092 0.382-0.6014 1.132-0.5843 1.628-0.5715 0.191 0.0043 0.592 0.0128 0.687-0.0469 0-0.0043 0.173-0.3455-0.396-1.5908l1.597-0.6398c0.269 0.5971 1.092 2.4097 0 3.4034-0.409 0.3711-0.923 0.4734-1.383 0.499 9e-3 0.0086 0.019 0.0171 0.023 0.0256 0.783 0.7592 1.752 1.706 1.36 2.8106-0.254 0.7122-0.932 0.9852-1.383 1.1686-0.15 0.0597-0.373 0.1535-0.427 0.2047 0.054 0.0682 0.414 0.418 0.632 0.6269 0.569 0.5545 1.347 1.3094 1.165 2.3159-0.141 0.8658-0.937 1.5568-2.425 2.1198z' fill='%230065FF'/%3E%3Cpath d='m96.795 122.19c-0.7552-0.461-1.6969-1.152-2.584-2.154-1.7742-2.004-2.3292-4.128-2.5294-5.246 0.3321-1.557 1.2829-4.691 4.1717-6.338 1.2966-0.737 3.3756-1.39 3.926-0.801 0.5825 0.618-1.2283 2.776-1.6195 3.275-1.2238 1.335-2.4475 2.67-3.6713 4.001 0.3822 0.528 0.7734 1.126 1.1464 1.795 0.6324 1.13 1.0691 2.201 1.3694 3.126-0.0683 0.785-0.141 1.561-0.2093 2.342z' fill='%23F1DAD5'/%3E%3Cpath d='m107.77 158.77c6.251 0 11.318-1.764 11.318-3.941 0-2.176-5.067-3.94-11.318-3.94s-11.319 1.764-11.319 3.94c0 2.177 5.068 3.941 11.319 3.941z' fill='%23091E42' opacity='.15'/%3E%3Cpath d='m97.418 118.59c0.0591-0.217 0.1455-0.46 0.2593-0.725 0.1364-0.307 0.2911-0.576 0.4412-0.797 0.182 0.047 0.4732 0.115 0.8371 0.174 0.3139 0.052 0.5596 0.073 0.687 0.086 0.7419 0.089 2.1559 0.23 5.9639 0.469 0.182 0.188 0.441 0.473 0.714 0.836 0.992 1.309 1.356 2.503 1.511 3.019 2.584 8.837 3.098 12.296 3.098 12.296s1.037 6.564 2.056 14.006c-0.036 0.017-0.823 0.52-1.656 0.793-0.3 0.099-0.723 0.209-1.278 0.252-0.669-1.006-1.424-2.38-1.97-4.099-0.864-2.721-0.814-5.092-0.646-6.593-0.282-1.326-0.782-3.212-1.706-5.374-0.541-1.267-2.229-5.207-3.084-5.054-0.815 0.145-0.182 3.915-0.11 10.957 0.037 3.791 0.019 6.896-4e-3 8.965-0.241 0.119-0.928 0.422-1.797 0.17-0.869-0.251-1.1602-0.584-1.1602-0.584-0.1774-0.768-0.4185-1.941-0.5959-3.386-0.0728-0.619-0.1092-1.122-0.1502-1.834-0.0727-1.195-0.1546-2.871-0.2001-4.969-0.3731-4.205-0.4732-5.647-0.4777-6.052 0-0.098-0.0091-0.524-0.091-1.083-0.0182-0.124-0.0409-0.243-0.0819-0.439-0.2729-1.276-1.4785-6.713-1.16-8.684 0.1592-0.989 0.4048-1.804 0.6005-2.35z' fill='%23F0D0B4'/%3E%3Cpath d='m113.06 147.66c-0.273 0.234-0.883 0.699-1.865 0.951-0.737 0.187-1.379 0.183-1.761 0.153 0.378 1.28 0.742 2.303 1.006 3.003 0.564 1.492 1.055 2.52 1.196 4.111 0.032 0.341 0.036 0.623 0.036 0.81l1.902-8e-3c0.105-0.09 0.214-0.184 0.318-0.273 0.169 0.085 0.337 0.171 0.505 0.26h4.841c0.305 0 0.518-0.226 0.423-0.448l-1.929-0.469c-2.006-0.49-3.467-1.825-3.744-3.433-0.187-1.075-0.4-2.261-0.582-3.109-0.11-0.525-0.228-1.041-0.346-1.548z' fill='%23172B4D'/%3E%3Cpath d='m99.361 147.14c0.3731 0.132 0.969 0.29 1.711 0.295 0.837 4e-3 1.492-0.192 1.883-0.342-0.032 1.779-0.059 3.553-0.091 5.331l0.978 0.039c0.341 0.013 0.528 0.315 0.328 0.537-0.451 0.444-0.901 0.883-1.352 1.327-0.086 0.251-0.336 0.84-0.95 1.198-0.128 0.077-0.346 0.201-0.66 0.239-0.409 0.047-0.769-0.077-0.933-0.175-0.5409-0.311-0.5182-1.113-0.5591-2.525-0.0273-1.036-0.1092-2.073-0.1547-3.109-0.0273-0.657-0.0819-1.629-0.2002-2.815z' fill='%23172B4D'/%3E%3Cpath d='m122.02 100.81c-0.213-0.145-0.323-0.128-0.373-0.235-0.077-0.166 0.096-0.397 0.478-0.7976 0.564-0.5971 0.942-0.9895 1.624-1.4287 0.187-0.1195 0.437-0.2687 0.755-0.418 0.228-0.1066 1.001-0.4563 1.165-0.3156 0.091 0.081 0.059 0.2644-0.132 0.3583-0.191 0.0895-0.041 0.0085-0.346 0.1535-0.141 0.0682-0.96 0.6056-0.755 0.789 0.032 0.0298 0.082 0.0426 0.114 0.0725 0.045 0.0426 0.041 0.0853 0.059 0.1279 0.041 0.1067 0.141 0.1408 0.196 0.192 0.173 0.1535 0.027 0.5587 9e-3 0.6056-0.173 0.4561-0.687 0.6271-0.774 0.6521-0.091 0.175-0.286 0.482-0.668 0.696-0.205 0.115-0.501 0.277-0.756 0.179-0.263-0.103-0.213-0.371-0.596-0.631z' fill='%23F1DAD5'/%3E%3Cpath d='m97.054 118.67c-0.5413 1.966-1.0509 4.022-1.5194 6.159-0.869 3.979-1.4786 7.762-1.9016 11.302 0.6323 0.307 1.5922 0.729 2.816 1.087 6.4415 1.898 12.056-0.294 13.048-0.699 1.014-0.414 2.443-1.101 3.999-2.231-1.456-5.672-2.739-9.788-3.171-10.799-0.419-0.976-0.842-1.804-1.406-2.67-1.137-1.744-2.416-2.985-3.307-3.753l-8.5575 1.604z' fill='url(%23d)'/%3E%3Cpath d='m98.538 99.535c0.6869-0.7592 2.5064-0.853 3.4754-0.1749 0.032 0.0213 0.078 0.0555 0.269 0.2303 1.36 1.233 2.484 2.214 2.42 3.412-0.014 0.252-0.064 0.465-0.114 0.614 0.232 0.056 0.56 0.175 0.81 0.448 0.6 0.644 0.414 1.744-0.1 2.401-0.769 0.981-2.366 1.105-3.303 0.601-0.255-0.136-0.505-0.341-0.505-0.341-0.173-0.175-0.432-0.448-0.719-0.797-1.4145-1.719-3.4026-5.101-2.2334-6.3934z' fill='%23172B4D'/%3E%3Cpath d='m100.69 99.287c0.71 0.4563 1.569 1.4548 1.956 1.9828 0.059 0.098 0.077 0.145 0.323 0.218 0.246 0.072 0.551 0.068 0.523 0.234-0.027 0.167-0.318 0.423-0.327 0.563l0.587 1.685c0.082 0.243-0.019 0.508-0.251 0.64l-0.464 0.268-2.902 1.664c0.255-1.049 0.45-2.184 0.56-3.399 0.018-0.214 0.031-0.423 0.045-0.632 0.159-0.196 0.464-0.618 0.546-1.228 0.014-0.102 0.077-0.614-0.15-1.228-0.137-0.3498-0.314-0.6057-0.446-0.7678z' fill='%23F1DAD5'/%3E%3Cpath d='m102.5 107.92-3.7263 0.315c0.0455-0.512 0.0591-1.13-0.0045-1.825-0.0683-0.695-0.2002-1.305-0.3458-1.804 1.242-0.107 2.4836-0.209 3.7256-0.316l0.351 3.63z' fill='%23F1DAD5'/%3E%3Cpath d='m94.757 109.22c0.2093-0.171 0.4186-0.341 0.6324-0.512 0 0 0.7824-0.597 1.806-0.947 1.8107-0.622 5.4955-0.729 7.9385-0.878 1.574-0.098 2.675-0.167 4.14-0.397 2.206-0.345 3.967-0.861 5.118-1.25 0.487-0.345 1.151-0.814 1.952-1.364 2.151-1.472 3.011-1.954 4.403-3.033 0.496-0.383 1.128-0.8995 1.843-1.5478 0.1 0.2047 0.204 0.4691 0.273 0.7888 0.095 0.457 0.082 0.849 0.045 1.126-2.206 3.254-4.686 5.016-6.219 5.92-1.742 1.023-3.489 1.667-4.717 2.12-2.088 0.767-3.922 1.236-5.296 1.526 0.228 0.299 0.514 0.755 0.678 1.357 0.228 0.853 9e-3 1.288-0.136 2.512-0.237 2-9e-3 3.902-9e-3 3.902s-1.347 0.785-5.259 0.785c-2.3661 0-2.8938-0.128-4.8955-0.341 0.0819-1.651-0.0273-3.967-0.8826-6.564-0.4094-1.241-0.9144-2.312-1.4148-3.203z' fill='%23F1DAD5'/%3E%3Cpath d='m94.384 115.28c0.1228 0 0.2411 8e-3 0.3639 0.017-0.0864-0.124-0.1728-0.248-0.2593-0.367 1.2238-1.335 2.4475-2.67 3.6713-4.001 0.3912-0.499 2.202-2.657 1.6195-3.275-0.555-0.589-2.6294 0.06-3.926 0.802-2.8888 1.646-3.8396 4.776-4.1717 6.337 0.0546 0.295 0.1319 0.657 0.2457 1.071 0.6733-0.367 1.4921-0.584 2.4566-0.584z' fill='%232DB07C'/%3E%3Cpath d='m113.33 108.72c0-1.053 0-2.102-5e-3 -3.156-1.073 0.32-2.443 0.661-4.058 0.917-1.465 0.231-2.561 0.299-4.139 0.397-2.443 0.149-6.1284 0.256-7.939 0.879-1.0236 0.349-1.8061 0.946-1.8061 0.946-0.2092 0.171-0.4185 0.342-0.6323 0.512 0.5004 0.892 1.0008 1.962 1.4103 3.203 0.8598 2.597 0.9644 4.909 0.8825 6.564 2.0017 0.213 2.5294 0.341 4.8946 0.341 3.908 0 5.259-0.785 5.259-0.785s-0.227-1.902 0.01-3.902c0.145-1.224 0.363-1.659 0.136-2.512-0.159-0.601-0.45-1.058-0.678-1.356 1.374-0.29 3.207-0.76 5.296-1.527 0.386-0.145 0.85-0.316 1.369-0.521z' fill='url(%23c)'/%3E%3Cpath d='m100.24 99.27c0.441 0.8489 0.391 1.5059 0.336 2.0899-0.1 1.088 0.46 1.552 0.842 3.339 0.264 1.246 0.396 1.868 0.136 2.363-0.778 1.48-4.2669 2.12-5.3997 0.708-0.6323-0.789-0.3139-1.949-0.1819-2.346-0.2685-0.541-0.6461-1.514-0.5141-2.716 0.0409-0.359 0.1228-0.674 0.182-0.858 0.3684-1.126 2.2973-3.13 4.5997-2.5799z' fill='%23172B4D'/%3E%3Cpath d='m3.1345 180 0.17742 2.363 2.5067-0.521-0.19107-1.842h-2.493z' fill='%23B5917C'/%3E%3Cpath d='m35.721 168.17c-0.2183 0.678-0.2229 0.831-0.2183 0.942 0.0091 0.132 0.0273 0.469 0.232 0.717 0.4776 0.575 1.8015 0.477 2.584-0.043 0.3275-0.218 0.5049-0.473 0.7642-0.849 0.3412-0.49 0.3048-0.648 0.2639-0.725-0.0682-0.132-0.2411-0.187-0.3548-0.213 0.3093-0.311 0.3412-0.495 0.2957-0.606-0.0819-0.213-0.505-0.371-0.505-0.371 0.0227-0.064 0.1774-0.482 0.0045-0.61-0.0591-0.042-0.1364-0.038-0.464 0.026-0.6096 0.119-0.5914 0.154-0.7006 0.141-0.373-0.056-0.4231-0.457-0.7506-0.465-0.1911-4e-3 -0.3412 0.132-0.4413 0.226-0.2275 0.209-0.2366 0.409-0.4049 0.96-0.1228 0.405-0.1228 0.315-0.3048 0.87z' fill='%23B5917C'/%3E%3Cpath d='m6.0778 182.13c-0.49587-0.559-0.6369-0.648-0.73698-0.704-0.12738-0.068-0.44583-0.243-0.78703-0.217-0.79612 0.06-1.4558 1.181-1.4194 2.107 0.01365 0.388 0.15013 0.674 0.34575 1.096 0.25476 0.55 0.42308 0.61 0.51862 0.623 0.15922 0.017 0.3048-0.086 0.39124-0.167 0.10918 0.422 0.25931 0.55 0.38669 0.58 0.24111 0.051 0.62325-0.196 0.62325-0.196 0.04549 0.056 0.3412 0.414 0.55501 0.346 0.07279-0.022 0.11373-0.09 0.24112-0.389 0.23656-0.558 0.19107-0.563 0.2684-0.644 0.25931-0.268 0.65965-0.085 0.84617-0.341 0.11373-0.153 0.06824-0.35 0.04094-0.482-0.06823-0.298-0.24111-0.422-0.65054-0.87-0.30026-0.337-0.21837-0.286-0.62326-0.742z' fill='%23B5917C'/%3E%3Cpath d='m18.033 179.03c4.7449 4.657 5.2863 8.047 4.9678 10.21-0.3639 2.49-1.9289 3.774-5.4682 9.003-2.0654 3.049-3.5985 5.66-4.5903 7.434-0.7597-0.414-1.5194-0.828-2.2792-1.241 0.9099-2.461 1.0418-4.18 0.9781-5.319-0.0227-0.435-0.1137-1.471 0.3094-2.716 0.05-0.154 0.1683-0.47 0.8643-1.685 1.0282-1.791 1.9562-3.16 2.5022-3.924 0.4094-0.571 0.7506-1.045 0.9917-1.369-0.4549-0.776-1.4103-2.392-2.6431-4.521-1.8925-3.258-2.8342-4.926-2.6386-7.015 0.0546-0.589 0.182-1.067 0.2775-1.374 0.7734 0.559 1.9243 1.258 3.4392 1.796 1.2693 0.443 2.4112 0.635 3.2892 0.721z' fill='url(%23b)'/%3E%3Cpath d='m17.724 167.32c0.6551 1.369 1.1374 2.516 2.3475 3.719 1.5058 1.497 3.1799 2.197 4.1307 2.512 1.3284 0.154 3.139 0.218 5.2226-0.145 3.6349-0.631 6.2007-2.235 7.5382-3.216-0.4959-0.644-0.9918-1.283-1.4876-1.927-1.3557 0.315-2.8524 0.597-4.4811 0.814-2.2246 0.295-4.2672 0.401-6.0733 0.405-1.7242-2.414-2.9252-4.235-3.7486-5.535-0.6233-0.981-1.3693-2.24-2.766-2.491-0.3184-0.056-1.1418-0.205-1.6423 0.192-1.2647 1.006 0.5005 4.708 0.9599 5.672z' fill='%23FFC400'/%3E%3Cpath d='m13.884 168.53-0.7279 11.477 7.8567-1.028c0.7779-2.047 0.6414-3.365 0.3457-4.205-0.0819-0.23-0.1911-0.473-0.2729-0.883-0.2821-1.454 0.3048-2.653 0.4503-2.985 0.455-1.037 0.6733-2.943-0.3093-6.747-0.1228-0.508-0.323-0.9-0.5186-1.19-1.3011-1.941-4.0944-2.043-4.4993-2.052-0.0364 0.546-0.0682 1.088-0.1046 1.634-0.8871 0.017-1.6241 0.648-1.7151 1.475l-0.505 4.504z' fill='%23FFC400'/%3E%3Cpath d='m17.183 161.36c0.4776 0.013 0.8689 0.128 1.1873 0.311 1.0464 0.606 1.3785 2.256 1.4604 2.934 0.4776 3.809 0.1728 11.784 0.1546 12.228-2.9752 0.281-5.955 0.567-8.9302 0.849 0.2001-4.581 0.3958-9.157 0.5959-13.738l1.1692-1.343c0.7415-0.853 1.8106-1.322 2.9343-1.288 0 4e-3 1.4239 0.047 1.4285 0.047z' fill='%23FFE380'/%3E%3Cpath d='m14.462 159.11c-0.1365 0.235 0.2502 0.7 0.091 1.544-0.0455 0.239-0.1183 0.427-0.1592 0.525 0.4367 0.256 1.2783 0.673 2.4202 0.759 0.7324 0.055 1.342-0.039 1.7605-0.141 0.2594-1.348 0.3913-2.022 0.3913-2.022s-0.0091 0.043-0.0228 0.12c-3.4347-1.105-4.3263-1.054-4.481-0.785z' fill='%239C7761'/%3E%3Cpath d='m18.634 152.81c0.1865 0.375 0.3685 0.789 0.5414 1.245 0.232 0.627 0.3957 1.215 0.514 1.74 0.0592 0.09 0.1592 0.239 0.3048 0.422 0.4368 0.546 0.8644 0.858 0.7734 1.011-0.0091 0.013-0.4322 0.222-0.5004 0.29-0.1456 0.141 0.091 1.484-0.1547 2.06-0.3548 0.836-4.1626 2.068-5.4728 0.154-0.1865-0.269-0.5914-0.623-0.8644-1.229 0.132-0.025 0.323-0.072 0.5141-0.187 0.4368-0.261 0.6233-0.661 0.6961-0.811 0.3321-0.699 1.1646-2.465 2.3565-3.207 0.1501-0.094 0.4595-0.269 0.7643-0.61 0.2957-0.341 0.4458-0.674 0.5277-0.878z' fill='%23B5917C'/%3E%3Cpath d='m17.488 154.33c0.4185 1.864 0.3093 2.393 0.0955 2.478-0.1046 0.043-0.1911-0.034-0.878-0.29-0.8143-0.302-0.9326-0.29-0.9963-0.238-0.1956 0.149 0.0273 0.695 0.1274 0.912-0.414 0.461-0.828 0.921-1.242 1.382 0.041 0.179 0.0865 0.503-0.0864 0.806-0.0228 0.038-0.0455 0.073-0.0728 0.107-0.141-0.094-0.4049-0.273-0.7006-0.529-1.1191-0.973-2.5521-2.934-1.8652-4.465 0.0819-0.184 0.2548-0.495 0.646-0.819 0 0 0.1228-0.107 0.2684-0.205 1.1055-0.755 4.2536-1.054 5.5274-1.723 0.1001-0.051 0.3821-0.209 0.6096-0.111 0.232 0.102 0.2911 0.431 0.3093 0.64-0.0955 0.277-0.2684 0.665-0.5823 1.066-0.4049 0.507-0.8598 0.819-1.16 0.989z' fill='%23253858'/%3E%3Cpath d='m38.933 182.74c-0.3366-0.721-0.9053-1.041-1.6468-1.638-0.8189-0.661-1.8971-1.71-2.9116-3.344-1.3329-1.603-3.3937-2.367-5.4091-2.196-0.1456 8e-3 -0.2547 0.021-0.323 0.03l-17.619 2.303 0.0546 0.358c0.0819 0.555 0.2502 1.079 0.4959 1.561 0.5414 1.075 1.3238 1.689 1.7469 2.013 1.524 1.169 3.2892 1.531 4.3719 1.672 3.1162 0.405 5.2817-0.418 8.8302-1.305 0.7506-0.188 1.6332-0.397 2.634-0.606 0.7188 0.96 1.4376 1.89 2.1518 2.781 0.5323 0.644 1.5422 1.872 2.5249 2.405 0.3321 0.18 1.4102 0.691 3.2982 0.256l1.5195-1.113c0.4185-0.878 0.7961-2.094 0.282-3.177z' fill='url(%23a)'/%3E%3Cpath d='m47.099 188.19c-1.0372 1.155-3.2527 3.702-4.0398 3.531-0.0318-9e-3 -0.2365-0.064-0.3639 0.034-0.1183 0.094-0.0956 0.273-0.1047 0.371-0.0136 0.222-0.2092 0.525-1.0053 0.879-0.0228 0.021-0.1593 0.14-0.3685 0.14-0.1274 0-0.2548-0.042-0.3458-0.136l-1.3966-1.403c-0.3048-0.307-0.2639-0.811 0.0955-1.122 0.1683-0.132 0.414-0.345 0.646-0.657 0.5778-0.767 0.4777-1.335 0.9008-1.556 0.3912-0.205 0.737 0.149 1.4285 0.294 0.282-0.017 0.5823-0.056 0.8962-0.115 1.483-0.29 2.5612-1.011 3.2209-1.557 0.323 0.239 0.6414 0.473 0.9644 0.712-0.1046 0.12-0.2957 0.324-0.5277 0.585z' fill='%23505F79'/%3E%3Cpath d='m34.661 187.27 5.1953 4.73 2.9843-2.644-3.8168-6.231-4.3628 4.145z' fill='%23505F79'/%3E%3Cpath d='m18.311 208.65c-1.6105-0.017-5.118-8e-3 -5.4728-0.687-0.0137-0.025-0.1001-0.213-0.2593-0.238-0.1547-0.026-0.2866 0.102-0.3731 0.162-0.191 0.128-0.5641 0.183-1.3647-0.171-0.0319-4e-3 -0.2139-0.026-0.3503-0.179-0.0819-0.094-0.1274-0.213-0.1092-0.337l0.2684-1.902c0.0591-0.414 0.5004-0.704 0.9826-0.644 0.2138 0.038 0.5505 0.081 0.9508 0.051 1.0009-0.072 1.4058-0.503 1.8516-0.337 0.4185 0.154 0.3457 0.627 0.6642 1.22 0.1956 0.192 0.414 0.388 0.6642 0.576 1.1828 0.887 2.4612 1.215 3.3255 1.343 0.0091 0.384 0.0182 0.768 0.0228 1.152-0.1456 0-0.4368-5e-3 -0.8007-9e-3z' fill='%23505F79'/%3E%3Cpath d='m11.173 199.05-0.596 6.768 4.0716 0.482 2.7114-6.721-6.187-0.529z' fill='%23505F79'/%3E%3Cpath d='m10.914 166.88c-0.282 2.665-0.6914 3.651-0.8006 5.544-0.0728 1.241-0.0182 3.024 0.5823 5.229 0.2456 0.154 0.5186 0.29 0.8098 0.414 2.1609 0.878 4.3855 0.166 5.309-0.192 0.1092-0.542 0.2138-1.092 0.3139-1.646 0.8461-4.816 1.0645-9.392 0.8734-13.64 0.0137-0.934-0.8006-1.689-1.7924-1.672l-2.7432 0.047c-1.2238 0.022-2.2383 0.896-2.3656 2.035 0.0091 0.891-0.0137 2.243-0.1866 3.881z' fill='%23FFC400'/%3E%3Cpath d='m15.754 161.32c-0.1911-0.563-5.5047-0.857-10.536 2.482-1.0964 0.73-4.9041 3.22-5.2044 6.99-0.0045493 0.06-0.0090986 0.124-0.0090986 0.201-0.022746 0.93 0.11373 1.813 0.52772 3.037 0.58686 1.731 0.9599 1.936 1.151 3.237 0.06824 0.464 0.03184 0.511 0.09553 0.955 0.18198 1.322 0.70059 2.333 1.1146 2.99 0.00455 0 1.5559-0.133 1.5604-0.133 0.6005-0.055 1.201-0.11 1.5604-0.132-0.14558-2.132-0.34574-4.337-0.6096-6.606-0.15923-1.386-0.3412-2.742-0.53227-4.065 2.3884-1.155 4.2581-2.021 5.3954-2.546 2.9389-1.347 4.9451-2.196 4.9451-3.399 0-0.588-0.4913-1.1-0.2138-1.911 0.2457-0.725 0.8189-0.912 0.7552-1.1z' fill='%23FFC400'/%3E%3Cpath d='m77.834 44.701v87.191l-10.5-0.784v-85.58l10.5-0.8274z' fill='%230065FF'/%3E%3Cpath d='m75.728 52.33c0 1.8552-1.4285 3.4162-3.1709 3.4844-1.7287 0.0683-3.1163-1.3562-3.1163-3.1816s1.3876-3.3821 3.1163-3.4802c1.7424-0.0981 3.1709 1.3222 3.1709 3.1774z' fill='%23fff'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='i' x1='7.9864' x2='41.672' y1='207.64' y2='207.64' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23091E42' offset='0'/%3E%3Cstop stop-color='%23091E42' stop-opacity='0' offset='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='h' x1='62.482' x2='217.08' y1='103.01' y2='103.01' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FF991F' offset='0'/%3E%3Cstop stop-color='%23FFC400' offset='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='g' x1='92.529' x2='92.529' y1='209.32' y2='134.41' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%234C9AFF' stop-opacity='.6' offset='0'/%3E%3Cstop stop-color='%23358AFF' stop-opacity='.7399' offset='.2333'/%3E%3Cstop stop-color='%230065FF' offset='.6674'/%3E%3C/linearGradient%3E%3ClinearGradient id='f' x1='66.788' x2='66.788' y1='186.24' y2='154.4' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%234C9AFF' offset='0'/%3E%3Cstop stop-color='%230065FF' offset='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='e' x1='63.991' x2='88.671' y1='167.37' y2='167.37' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%230052CC' offset='0'/%3E%3Cstop stop-color='%232684FF' offset='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='d' x1='93.635' x2='113.5' y1='127.52' y2='127.52' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2300875A' offset='0'/%3E%3Cstop stop-color='%2302895C' offset='.3797'/%3E%3Cstop stop-color='%230A9062' offset='.5623'/%3E%3Cstop stop-color='%23179C6D' offset='.7027'/%3E%3Cstop stop-color='%2329AE7D' offset='.8217'/%3E%3Cstop stop-color='%2341C490' offset='.9259'/%3E%3Cstop stop-color='%2357D9A3' offset='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='c' x1='94.759' x2='113.33' y1='112.44' y2='112.44' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2336B37E' offset='0'/%3E%3Cstop stop-color='%2379F2C0' offset='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='b' x1='8.7461' x2='23.325' y1='191.54' y2='189.37' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FFAB00' offset='.3455'/%3E%3Cstop stop-color='%23FFC400' offset='1'/%3E%3C/linearGradient%3E%3ClinearGradient id='a' x1='31.68' x2='23.922' y1='173.42' y2='184.38' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FFC400' offset='0'/%3E%3Cstop stop-color='%23FF991F' offset='.5644'/%3E%3C/linearGradient%3E%3CclipPath id='j'%3E%3Crect width='248.1' height='210.9' fill='%23fff'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A`;

});


parcelRegister("97yjv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ed712843db4fe54$export$2e2bcd8739ae039);
/* organisation-selector.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dBxQj = parcelRequire("dBxQj");

var $z8Sbd = parcelRequire("z8Sbd");

var $bWv7m = parcelRequire("bWv7m");

var $f8Iqd = parcelRequire("f8Iqd");

var $a3xa0 = parcelRequire("a3xa0");

var $4sqgR = parcelRequire("4sqgR");

var $inPa6 = parcelRequire("inPa6");

var $alOHm = parcelRequire("alOHm");

var $dh538 = parcelRequire("dh538");
const $4ed712843db4fe54$var$styles = {
    orgList: "_ca0qutpp _u5f3idpf _n3tdutpp _19bvidpf _1bsb8vuz",
    orgListTransition: "_v56411uq",
    sidebar: "_1s7zzgxb _1e0c1txw _2lx2vrvc _18m91wug",
    orgItem: "_19pkutpp",
    dragging: "_v564glyw _80omuf7j"
};
const $4ed712843db4fe54$var$OrganisationSelector = ({ activeOrgId: activeOrgId, handleSetActiveOrg: handleSetActiveOrg, organisations: organisations, product: product, switchToSectionHeight: switchToSectionHeight })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const orgItemBtnElements = (0, $gwFzn.useRef)([]);
    const orgListRef = (0, $gwFzn.useRef)(null);
    const [isDragging, setIsDragging] = (0, $gwFzn.useState)(false);
    const [percentageOpen, setPercentageOpen] = (0, $gwFzn.useState)(0);
    const [resizeControlInitDone, setResizeControlInitDone] = (0, $gwFzn.useState)(false);
    const [initialHeight, setInitialHeight] = (0, $gwFzn.useState)(0); // The keyboard implementation is based on
    // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tablist_role#keyboard_interactions
    // https://www.w3.org/WAI/ARIA/apg/patterns/tabs/examples/tabs-manual/
    const onKeyDownHandler = (event, index)=>{
        let flag = false;
        switch(event.key){
            // move focus to previous tab
            case 'ArrowUp':
                orgItemBtnElements.current[(orgItemBtnElements.current.length + (index - 1)) % orgItemBtnElements.current.length].focus();
                flag = true;
                break;
            // move focus to next tab
            case 'ArrowDown':
                orgItemBtnElements.current[(index + 1) % orgItemBtnElements.current.length].focus();
                flag = true;
                break;
            // move focus To the fist tab
            case 'Home':
                orgItemBtnElements.current[0].focus();
                flag = true;
                break;
            // move focus To the last tab
            case 'End':
                orgItemBtnElements.current[orgItemBtnElements.current.length - 1].focus();
                flag = true;
                break;
            default:
                break;
        }
        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    };
    const fireClickEvent = (0, $gwFzn.useCallback)((payload)=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            eventType: (0, $a3xa0.UI_EVENT_TYPE),
            actionSubject: (0, $a3xa0.SWITCHER_ORG_ITEM),
            action: 'clicked',
            ...payload
        }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent
    ]); // This will be used during resizing
    const updateOrgSelectorComponentWidth = (0, $gwFzn.useCallback)((newWidth)=>{
        setPercentageOpen(Math.min(1, (newWidth - (0, $alOHm.COLLAPSED_ORG_SELECTOR_WIDTH)) / ((0, $alOHm.DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH) - (0, $alOHm.COLLAPSED_ORG_SELECTOR_WIDTH))));
        orgListRef.current?.style.setProperty('width', `${newWidth}px`); // Ensure that the state is updated in the next tick so the transition style is applied after the width is updated
        setTimeout(()=>{
            setResizeControlInitDone(true);
        }, 0);
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (orgListRef.current?.scrollHeight) setInitialHeight(orgListRef.current.scrollHeight);
    }, []);
    if (organisations.size === 0) return null;
    const organisationsList = Array.from(organisations.entries());
    const isSwitcherDynamicHeight = (0, $dh538.fg)('app_switcher_dynamic_height');
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        className: (0, $35pXk.default)([
            $4ed712843db4fe54$var$styles.sidebar
        ]),
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.ViewedTracker), {
                subject: (0, $a3xa0.SWITCHER_ORG_LIST),
                data: {
                    numOrganisations: organisationsList.length
                }
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                role: "tablist",
                "aria-label": formatMessage((0, $z8Sbd.default).organisationsLabel),
                "aria-orientation": "vertical",
                ref: orgListRef,
                style: {
                    height: isSwitcherDynamicHeight && initialHeight > (switchToSectionHeight ?? 0) ? `${switchToSectionHeight}px` : `${initialHeight}px`
                },
                className: (0, $35pXk.default)([
                    $4ed712843db4fe54$var$styles.orgList,
                    resizeControlInitDone && $4ed712843db4fe54$var$styles.orgListTransition,
                    isDragging && $4ed712843db4fe54$var$styles.dragging
                ]),
                children: organisationsList.map(([id, org], index)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $f8Iqd.default), {
                        product: product,
                        triggerSubject: "orgItem",
                        hideFallbackUI: true,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                            className: (0, $35pXk.default)([
                                index > 0 && $4ed712843db4fe54$var$styles.orgItem
                            ]),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bWv7m.default), {
                                onKeyDown: (e)=>{
                                    onKeyDownHandler(e, index);
                                },
                                tabIndex: !activeOrgId || activeOrgId === id ? undefined : -1,
                                isActive: activeOrgId === id,
                                ref: (elem)=>{
                                    if (elem) orgItemBtnElements.current[index] = elem;
                                },
                                onClick: ()=>{
                                    fireClickEvent({
                                        attributes: {
                                            organisation: {
                                                id: id
                                            }
                                        }
                                    });
                                    handleSetActiveOrg(id);
                                },
                                percentageOpen: percentageOpen,
                                ...org
                            })
                        })
                    }, id))
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4sqgR.default), {
                onDragStart: ()=>{
                    setIsDragging(true);
                },
                onDragEnd: ()=>{
                    setIsDragging(false);
                },
                updateOrgSelectorComponentWidth: updateOrgSelectorComponentWidth
            })
        ]
    });
};
var $4ed712843db4fe54$export$2e2bcd8739ae039 = $4ed712843db4fe54$var$OrganisationSelector;

});
parcelRegister("bWv7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $dadd6be6bf7c1aaa$export$2e2bcd8739ae039);
/* organisation-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $3gadb = parcelRequire("3gadb");

var $3654r = parcelRequire("3654r");

var $78Fx5 = parcelRequire("78Fx5");

var $eycgM = parcelRequire("eycgM");

var $cOrQJ = parcelRequire("cOrQJ");
const $dadd6be6bf7c1aaa$var$getArbitraryElement = (arr, seed)=>{
    const charCodes = seed.split('').reduce((a, b, i)=>{
        return a + b.charCodeAt(0);
    }, 0);
    return arr[charCodes % arr.length];
};
const $dadd6be6bf7c1aaa$var$OrganisationItem = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ onKeyDown: onKeyDown, displayName: displayName, isActive: isActive, onClick: onClick, tabIndex: tabIndex, id: id, percentageOpen: percentageOpen = 1 }, ref)=>{
    const isVisualRefreshEnabled = (0, $eycgM.useIsSwitcherTeam25TestCohort)();
    const displayInitials = displayName.substring(0, 2);
    const { colorMode: observedColorMode } = (0, $cOrQJ.default)();
    const isDarkMode = observedColorMode === 'dark';
    const variantArray = isVisualRefreshEnabled ? $dadd6be6bf7c1aaa$var$variantsRefreshed : $dadd6be6bf7c1aaa$var$variants;
    const variantKey = $dadd6be6bf7c1aaa$var$getArbitraryElement(variantArray, displayName);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            $dadd6be6bf7c1aaa$var$orgItemStyles.container,
            isActive && $dadd6be6bf7c1aaa$var$orgItemStyles.activeContainer
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            content: displayName,
            position: "right",
            ignoreTooltipPointerEvents: true,
            children: ({ ref: tooltipRef, 'aria-describedby': _, ...tooltipProps })=>/*#__PURE__*/ (0, $7UHDa.jsxs)("button", {
                    ...tooltipProps,
                    role: "tab",
                    "aria-selected": isActive ? 'true' : 'false',
                    ref: (0, $3654r.default)([
                        ref,
                        tooltipRef
                    ]),
                    onKeyDown: onKeyDown,
                    "aria-label": displayName,
                    id: `${(0, $78Fx5.SWITCHER_TAB_BUTTON_PREFIX)}-${id}`,
                    "aria-controls": `${(0, $78Fx5.SWITCHER_TAB_PANEL_PREFIX)}-${id}`,
                    tabIndex: tabIndex,
                    onClick: onClick,
                    className: (0, $35pXk.default)([
                        isVisualRefreshEnabled && $dadd6be6bf7c1aaa$var$orgItemStyles.tooltipContainerRefreshed,
                        !isVisualRefreshEnabled && $dadd6be6bf7c1aaa$var$orgItemStyles.tooltipContainerOriginal
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                            className: (0, $35pXk.default)([
                                isVisualRefreshEnabled && $dadd6be6bf7c1aaa$var$orgItemStyles.tokenRefreshed,
                                !isVisualRefreshEnabled && $dadd6be6bf7c1aaa$var$orgItemStyles.tokenOriginal,
                                isVisualRefreshEnabled && isDarkMode && $dadd6be6bf7c1aaa$var$darkTokens[variantKey],
                                !(isVisualRefreshEnabled && isDarkMode) && $dadd6be6bf7c1aaa$var$lightTokens[variantKey],
                                !isVisualRefreshEnabled && $dadd6be6bf7c1aaa$var$originalTokens[variantKey],
                                isActive && $dadd6be6bf7c1aaa$var$orgItemStyles.active
                            ]),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                                "aria-hidden": "true",
                                className: (0, $35pXk.default)([
                                    $dadd6be6bf7c1aaa$var$orgItemStyles.initial
                                ]),
                                children: displayInitials
                            })
                        }),
                        percentageOpen > 0 && /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                            "aria-hidden": "true",
                            style: {
                                opacity: percentageOpen
                            },
                            "data-testid": `switcher-org-name`,
                            className: (0, $35pXk.default)([
                                $dadd6be6bf7c1aaa$var$orgItemStyles.text
                            ]),
                            children: displayName
                        })
                    ]
                })
        })
    });
});
const $dadd6be6bf7c1aaa$var$variants = [
    'red',
    'blue',
    'green',
    'yellow',
    'purple',
    'magenta',
    'teal',
    'orange',
    'lime',
    'gray'
];
const $dadd6be6bf7c1aaa$var$variantsRefreshed = [
    'purple',
    'blue',
    'lime',
    'yellow'
];
const $dadd6be6bf7c1aaa$var$originalTokens = {
    red: "_bfhk1vk5 _syaz9lu1",
    blue: "_bfhk4v9p _syazpnps",
    green: "_bfhk1wnw _syazh55r",
    yellow: "_bfhk3fv2 _syazfb2s",
    purple: "_bfhk1jkz _syaz10m5",
    magenta: "_bfhkv9ra _syaz1s8m",
    teal: "_bfhk1a17 _syaz17qg",
    orange: "_bfhkf2vu _syaz1q28",
    lime: "_bfhkz2ec _syaz1tco",
    gray: "_bfhk1v33 _syaz1dyx"
};
const $dadd6be6bf7c1aaa$var$lightTokens = {
    purple: "_bfhkp7j4 _syaz2ibx _irr3m0d5",
    blue: "_bfhkavxe _syazsc1o _irr3ay3p",
    lime: "_bfhkm890 _syaz1ik3 _irr3d4y8",
    yellow: "_bfhk1ozg _syazekll _irr319g9"
};
const $dadd6be6bf7c1aaa$var$darkTokens = {
    purple: "_bfhk1jkz _syaz2ibx _irr31wyu",
    blue: "_bfhk4v9p _syazsc1o _irr316e6",
    lime: "_bfhkz2ec _syaz1ik3 _irr31eds",
    yellow: "_bfhk3fv2 _syazekll _irr3lg04"
};
const $dadd6be6bf7c1aaa$var$orgItemStyles = {
    initial: "_vwz41f4h",
    text: "_11c82smr _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq _v564g17y _k48p1wq8 _syaz1fxt _1e0ccj1k _sudp1e54 _1yyjkb7n _1nmz9jpi _4t3i1osq _19bvu2gc _1bto1l2s _y3gn1e5h",
    container: "_19bvutpp _u5f3utpp _kqswh2mm _1kt9b3bt _1cs8stnw _qnecidpf _1aukidpf _19woidpf _1mp41l7b _1c28gqwt _fp3bgqwt _4cvxu1se _1xqcu1se _q4ztqkzo _105iqkzo",
    activeContainer: "_1h6db29m _1rusb29m",
    tooltipContainerOriginal: "_bfhk18uv _1h6d3acm _189eidpf _1dqonqa1 _18zridpf _1rjcidpf _1e0c1txw _2lx2vrvc _4cvr1h6o _80omtlke _1bsb1osq _16l4txnc",
    tooltipContainerRefreshed: "_bfhk18uv _1h6d3acm _189eidpf _1dqonqa1 _18zrv77o _1rjcv77o _1e0c1txw _2lx2vrvc _4cvr1h6o _80omtlke _1bsb1osq",
    tokenOriginal: "_11c81ixg _bfhk18uv _2rkopd34 _16jlidpf _1o9zidpf _i0dl1wug _18zridpf _1rjcidpf _1h6d3acm _1dqonqa1 _189eyh40 _k48p1wq8 _80omtlke _vchh18uv _y3gn1h6o _s7n4nkob _1p1d1dk0 _syaz15cr _1bsb1f4h _4t3i1f4h",
    tokenRefreshed: "_11c82smr _bfhk18uv _2rkopd34 _16jlidpf _1o9zidpf _i0dl1wug _18zridpf _1rjcidpf _1h6d3acm _1dqonqa1 _189eyh40 _k48p1wq8 _vchh18uv _y3gn1h6o _s7n4nkob _1p1d1dk0 _syaz15cr _1bsb1f4h _4t3i1f4h",
    active: "_1h6db29m _mizu1r31 _ra3xglyw _128midpf _pojju1se _19lvtxnc"
};
var $dadd6be6bf7c1aaa$export$2e2bcd8739ae039 = $dadd6be6bf7c1aaa$var$OrganisationItem;

});

parcelRegister("4sqgR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7415462069858c14$export$2e2bcd8739ae039);
/* resize-control.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $httJc = parcelRequire("httJc");

var $d8F95 = parcelRequire("d8F95");

var $2ZsRZ = parcelRequire("2ZsRZ");

var $inPa6 = parcelRequire("inPa6");

var $alOHm = parcelRequire("alOHm");

var $a3xa0 = parcelRequire("a3xa0");
var $7415462069858c14$var$AnalyticsActionType = /*#__PURE__*/ function(AnalyticsActionType) {
    AnalyticsActionType["CLICKED"] = "clicked";
    AnalyticsActionType["DRAGGED"] = "dragged";
    return AnalyticsActionType;
}($7415462069858c14$var$AnalyticsActionType || {});
var $7415462069858c14$var$AnalyticsSubjectIdType = /*#__PURE__*/ function(AnalyticsSubjectIdType) {
    AnalyticsSubjectIdType["MOUSE"] = "mouse";
    AnalyticsSubjectIdType["KEYBOARD"] = "keyboard";
    return AnalyticsSubjectIdType;
}($7415462069858c14$var$AnalyticsSubjectIdType || {});
const $7415462069858c14$var$resizeControlStyles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _u7coidpf _152tidpf _1e021osq"
};
const $7415462069858c14$var$ResizeControl = ({ updateOrgSelectorComponentWidth: updateOrgSelectorComponentWidth, onDragStart: onDragStart, onDragEnd: onDragEnd })=>{
    // Distance of mouse from left sidebar onMouseDown
    const offset = (0, $gwFzn.useRef)(0);
    const keyboardEventTimeout = (0, $gwFzn.useRef)();
    const unbindEvents = (0, $gwFzn.useRef)(null);
    const [width, setWidth] = (0, $gwFzn.useState)((0, $alOHm.COLLAPSED_ORG_SELECTOR_WIDTH));
    const [lastWidth, setLastWidth] = (0, $gwFzn.useState)(width);
    const [isResizing, setIsResizing] = (0, $gwFzn.useState)(false);
    const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $gwFzn.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const widthRef = (0, $gwFzn.useRef)(width);
    const stableWidth = (0, $gwFzn.useRef)(width);
    const styleRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        stableWidth.current = width;
    }, [
        width
    ]);
    const isCollapsed = width === (0, $alOHm.COLLAPSED_ORG_SELECTOR_WIDTH);
    const updateOrgSelectorWidth = (0, $gwFzn.useCallback)((newWidth)=>{
        updateOrgSelectorComponentWidth(newWidth);
        setWidth(newWidth);
    }, [
        updateOrgSelectorComponentWidth
    ]); // Update state from cache on mount
    // Get initial width value from local storage, if available, else fallback to default (COLLAPSED_ORG_SELECTOR_WIDTH)
    (0, $gwFzn.useEffect)(()=>{
        const widthFromStorage = localStorage.getItem((0, $alOHm.ORG_SELECTOR_WIDTH_LS_KEY));
        let cachedWidth = widthFromStorage ? parseInt(widthFromStorage) : (0, $alOHm.COLLAPSED_ORG_SELECTOR_WIDTH);
        updateOrgSelectorWidth(cachedWidth);
    }, [
        updateOrgSelectorWidth
    ]); // Every time other than mount, update local storage
    const notFirstRun = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (notFirstRun.current) localStorage.setItem((0, $alOHm.ORG_SELECTOR_WIDTH_LS_KEY), `${width}`);
        if (!notFirstRun.current) notFirstRun.current = true;
    }, [
        width
    ]);
    const fireEvent = (0, $gwFzn.useCallback)((action, actionSubjectId, newWidth)=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            eventType: (0, $a3xa0.UI_EVENT_TYPE),
            actionSubject: (0, $a3xa0.SWITCHER_ORG_NAME_EXPAND_PANEL),
            actionSubjectId: actionSubjectId,
            action: action,
            attributes: {
                newWidth: newWidth
            }
        }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const fireClickEvent = (0, $gwFzn.useCallback)((actionSubjectId)=>{
        fireEvent("clicked", actionSubjectId, isCollapsed ? Math.max(lastWidth, (0, $alOHm.DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH)) : (0, $alOHm.COLLAPSED_ORG_SELECTOR_WIDTH));
    }, [
        fireEvent,
        isCollapsed,
        lastWidth
    ]);
    const fireDragEvent = (0, $gwFzn.useCallback)((actionSubjectId, newWidth)=>{
        fireEvent("dragged", actionSubjectId, newWidth);
    }, [
        fireEvent
    ]);
    const onKeyDown = (event)=>{
        if (!isGrabAreaFocused || isResizing) return false;
        const { key: key } = event;
        const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
        const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
        const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
        if (isSpaceOrEnter) {
            fireClickEvent("keyboard");
            toggleOrgSelectorCb();
            event.preventDefault();
        }
        if (isLeftOrTopArrow || isRightOrBottomArrow) {
            event.preventDefault(); // prevent content scroll
            const step = 10;
            const stepValue = isLeftOrTopArrow ? -step : step;
            const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
            let width = stableWidth.current + stepValue;
            if (isRightOrBottomArrow) {
                if (width <= (0, $alOHm.DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH)) // snap open i.e., expand to default width
                width = (0, $alOHm.DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH);
                else if (width > (0, $alOHm.MAX_ORG_SELECTOR_EXPANDED_WIDTH) || hasModifierKey) // expand to max width
                width = (0, $alOHm.MAX_ORG_SELECTOR_EXPANDED_WIDTH);
            } else {
                if (width < (0, $alOHm.DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH)) // snap closed i.e., collapse
                width = (0, $alOHm.COLLAPSED_ORG_SELECTOR_WIDTH);
                else if (hasModifierKey) // snap to default expanded width
                width = (0, $alOHm.DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH);
            }
            fireDragEvent("keyboard", width); // Nesting the setTimeout within requestAnimationFrame helps
            // the browser schedule the setTimeout call in an efficient manner
            requestAnimationFrame(()=>{
                keyboardEventTimeout.current = window.setTimeout(()=>{
                    keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                    setLastWidth(width);
                    setIsResizing(false);
                    updateOrgSelectorWidth(width);
                }, 50);
            });
        }
    };
    const [onUpdateResize] = (0, $gwFzn.useState)(()=>(0, $2ZsRZ.default)(({ clientX: clientX })=>{
            if (clientX < 0) {
                onResizeOffLeftOfScreen();
                return;
            }
            const delta = clientX - offset.current;
            if (delta === 0) return;
            const width = stableWidth.current;
            const newWidth = Math.max(Math.min(width + delta, (0, $alOHm.MAX_ORG_SELECTOR_EXPANDED_WIDTH)), (0, $alOHm.COLLAPSED_ORG_SELECTOR_WIDTH));
            widthRef.current = newWidth;
            updateOrgSelectorComponentWidth(newWidth);
        }));
    const onResizeOffLeftOfScreen = ()=>{
        onUpdateResize.cancel();
        unbindEvents.current?.();
        unbindEvents.current = null;
        offset.current = 0;
        onDragEnd?.();
        fireDragEvent("mouse", (0, $alOHm.COLLAPSED_ORG_SELECTOR_WIDTH));
        collapseOrgSelector();
    };
    const expandOrgSelector = (0, $gwFzn.useCallback)(()=>{
        let expandWidth = Math.max(lastWidth, (0, $alOHm.DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH));
        setLastWidth(lastWidth);
        updateOrgSelectorWidth(expandWidth);
        setIsResizing(false);
    }, [
        lastWidth,
        updateOrgSelectorWidth
    ]);
    const collapseOrgSelector = (0, $gwFzn.useCallback)(()=>{
        setLastWidth(width);
        updateOrgSelectorWidth((0, $alOHm.COLLAPSED_ORG_SELECTOR_WIDTH));
        setIsResizing(false);
    }, [
        width,
        updateOrgSelectorWidth
    ]);
    const toggleOrgSelector = (0, $gwFzn.useCallback)(()=>{
        if (isCollapsed) expandOrgSelector();
        else collapseOrgSelector();
    }, [
        isCollapsed,
        expandOrgSelector,
        collapseOrgSelector
    ]);
    const toggleOrgSelectorCb = (0, $gwFzn.useCallback)((event)=>{
        // don't cascade down
        event?.stopPropagation();
        toggleOrgSelector();
    }, [
        toggleOrgSelector
    ]);
    const onFinishResizing = ()=>{
        onDragEnd?.();
        if (widthRef.current === 0) {
            // click
            fireClickEvent("mouse");
            toggleOrgSelector();
        } else if (widthRef.current < (0, $alOHm.MIN_ORG_SELECTOR_EXPAND_WIDTH)) {
            // snap closed i.e., collapse
            fireDragEvent("mouse", (0, $alOHm.COLLAPSED_ORG_SELECTOR_WIDTH));
            collapseOrgSelector();
        } else if (widthRef.current >= (0, $alOHm.MIN_ORG_SELECTOR_EXPAND_WIDTH) && widthRef.current < (0, $alOHm.DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH)) {
            // snap open i.e., expand to default width
            fireDragEvent("mouse", (0, $alOHm.DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH));
            setLastWidth((0, $alOHm.DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH));
            setIsResizing(false);
            updateOrgSelectorWidth((0, $alOHm.DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH));
        } else {
            // resize to desired width
            fireDragEvent("mouse", widthRef.current);
            setLastWidth(widthRef.current);
            setIsResizing(false);
            updateOrgSelectorWidth(widthRef.current);
        }
        unbindEvents.current?.();
        unbindEvents.current = null;
        onUpdateResize.cancel();
        widthRef.current = 0;
        offset.current = 0;
    };
    const onMouseDown = (event)=>{
        // Only allow left (primary) clicks to trigger resize
        if (event.button !== 0) return;
         // It is possible for a mousedown to fire during a resize
        // Example: the user presses another pointer button while dragging
        if (isResizing) // the resize will be cancelled by our global event listeners
        return;
        offset.current = event.clientX;
        widthRef.current = 0;
        unbindEvents.current = (0, $d8F95.bindAll)(window, [
            {
                type: 'mousemove',
                listener: (event)=>{
                    onUpdateResize({
                        clientX: event.clientX
                    });
                }
            },
            {
                type: 'mouseup',
                listener: onFinishResizing
            },
            {
                type: 'mousedown',
                listener: (()=>{
                    let hasFramePassed = false;
                    requestAnimationFrame(()=>{
                        hasFramePassed = true;
                    });
                    return function listener() {
                        if (hasFramePassed) onFinishResizing();
                    };
                })()
            },
            {
                type: 'visibilitychange',
                listener: onFinishResizing
            },
            {
                type: 'click',
                listener: onFinishResizing
            },
            {
                type: 'keydown',
                listener: (event)=>{
                    // Can cancel resizing by pressing "Escape"
                    // Will return org selector panel to the same size it was before the resizing started
                    if (event.key === 'Escape') {
                        widthRef.current = stableWidth.current;
                        onFinishResizing();
                    }
                }
            }
        ]);
        onDragStart?.();
        setIsResizing(true);
    };
    const onFocus = (0, $gwFzn.useCallback)(()=>{
        setIsGrabAreaFocused(true);
    }, []);
    const onBlur = (0, $gwFzn.useCallback)(()=>{
        setIsGrabAreaFocused(false);
    }, []);
    const isMaxWidth = width === (0, $alOHm.MAX_ORG_SELECTOR_EXPANDED_WIDTH);
    const getOrgSelectorPercentage = (currentWidth)=>{
        const total = (currentWidth - (0, $alOHm.COLLAPSED_ORG_SELECTOR_WIDTH)) / ((0, $alOHm.MAX_ORG_SELECTOR_EXPANDED_WIDTH) - (0, $alOHm.COLLAPSED_ORG_SELECTOR_WIDTH));
        if (total < 0) return 0;
        if (total > 1) return 100;
        return Math.floor(total * 100);
    };
    const orgSelectorPercentageExpanded = getOrgSelectorPercentage(width);
    (0, $gwFzn.useEffect)(()=>{
        if (isResizing) {
            const cursor = isCollapsed ? 'e-resize' : isMaxWidth ? 'w-resize' : 'ew-resize';
            const styles = `
			/*
			 * Blocking selection while resizing
			 * Notes:
			 * - This prevents a user selection being caused by resizing
			 * - Safari + Firefox \u{2192} all good
			 * - Chrome \u{2192} This will undo the current selection while resizing (not ideal)
			 *   - The current selection will resume after resizing
			 *
			 * Setting the cursor to be ${cursor} on all elements so that even if the user
			 * pointer slips off the resize handle, the cursor will still be the resize cursor
			 *
			 * Disabling pointer events on iframes when resizing,
			 * as iframes will swallow user events when the user is over them
			 *
			 * eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
			 */
			* {
			  user-select: none !important;
			  cursor: ${cursor} !important;
			}
			iframe {
			  pointer-events: none !important;
			}
		  `;
            const style = document.createElement('style');
            style.innerHTML = styles;
            document.head.appendChild(style);
            styleRef.current = style;
            return ()=>{
                if (styleRef.current) {
                    document.head.removeChild(styleRef.current);
                    styleRef.current = null;
                }
            };
        }
    }, [
        isResizing,
        isCollapsed,
        isMaxWidth
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            $7415462069858c14$var$resizeControlStyles.root
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $httJc.default), {
            isCollapsed: isCollapsed,
            isMaxWidth: isMaxWidth,
            onKeyDown: onKeyDown,
            onMouseDown: onMouseDown,
            onFocus: onFocus,
            onBlur: onBlur,
            orgSelectorPercentageExpanded: orgSelectorPercentageExpanded,
            isResizing: isResizing
        })
    });
};
var $7415462069858c14$export$2e2bcd8739ae039 = $7415462069858c14$var$ResizeControl;

});
parcelRegister("httJc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c3f63d8a3cb0ab3$export$2e2bcd8739ae039);
/* grab-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $1Whri = parcelRequire("1Whri");

var $3gadb = parcelRequire("3gadb");

var $dBxQj = parcelRequire("dBxQj");

var $z8Sbd = parcelRequire("z8Sbd");

var $fVUfS = parcelRequire("fVUfS");
let $0c3f63d8a3cb0ab3$var$varLineColor = '--ds-background-neutral-subtle';
const $0c3f63d8a3cb0ab3$var$grabAreaStyles = {
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _1bsbftgi _kqswstnw _4t3i1osq _bfhk18uv _nt751r31 _49pcglyw _1hvwidpf _xeao1fvw _1g4g1fvw _7skv1fvw",
    before: "_1sb2b3bt _kqswstnw _1ltvx0bf _154ize3t _94n5ze3t _1bsbftgi",
    inBetween: "_80omuf7j",
    collapsed: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _80om19th _bfhk18uv",
    maxWidth: "_80omdq7d",
    line: "_v564z97a _1e0c1ule _1bsbyh40 _4t3i1osq _bfhk1w7a"
};
const $0c3f63d8a3cb0ab3$var$GrabArea = ({ isCollapsed: isCollapsed, isMaxWidth: isMaxWidth, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onFocus: onFocus, onBlur: onBlur, orgSelectorPercentageExpanded: orgSelectorPercentageExpanded, isResizing: isResizing })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: isResizing ? null : formatMessage(isCollapsed ? (0, $z8Sbd.default).resizeBarTooltipCollapsed : (0, $z8Sbd.default).resizeBarTooltipExpanded, {
            separator: /*#__PURE__*/ (0, $7UHDa.jsx)("br", {})
        }),
        position: "mouse",
        mousePosition: "right",
        delay: 1000,
        hideTooltipOnMouseDown: true,
        hideTooltipOnClick: true,
        children: // we omit aria-describedby to prevent button label from overriding
        ({ ref: tooltipRef, 'aria-describedby': _, ...tooltipProps })=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fVUfS.default), {
                ...tooltipProps,
                "aria-label": formatMessage((0, $z8Sbd.default).resizeBarLabel),
                type: "button" // The slider role is applied to a button to utilize the native
                ,
                // interactive and disabled functionality on the resize slider. While a
                // range input would be more semantically accurate, it does not affect
                // usability.
                role: "slider",
                xcss: (0, $1Whri.cx)($0c3f63d8a3cb0ab3$var$grabAreaStyles.root, !isCollapsed && !isMaxWidth && $0c3f63d8a3cb0ab3$var$grabAreaStyles.inBetween, isCollapsed && $0c3f63d8a3cb0ab3$var$grabAreaStyles.collapsed, isMaxWidth && $0c3f63d8a3cb0ab3$var$grabAreaStyles.maxWidth),
                ref: tooltipRef,
                "aria-orientation": "vertical",
                "aria-valuenow": orgSelectorPercentageExpanded,
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuetext": `${formatMessage((0, $z8Sbd.default).resizeBarValueTextLabel)} ${orgSelectorPercentageExpanded}%`,
                onKeyDown: onKeyDown,
                onMouseDown: onMouseDown,
                onFocus: onFocus,
                onBlur: onBlur,
                testId: "org-selector-resize-bar",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                        className: (0, $35pXk.default)([
                            $0c3f63d8a3cb0ab3$var$grabAreaStyles.before
                        ])
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                        className: (0, $35pXk.default)([
                            $0c3f63d8a3cb0ab3$var$grabAreaStyles.line
                        ])
                    })
                ]
            })
    });
};
var $0c3f63d8a3cb0ab3$export$2e2bcd8739ae039 = $0c3f63d8a3cb0ab3$var$GrabArea;

});



parcelRegister("iKB3c", function(module, exports) {

$parcel$export(module.exports, "default", () => $c06eb11c2f6ed191$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $7hXDW = parcelRequire("7hXDW");

var $eycgM = parcelRequire("eycgM");
const $c06eb11c2f6ed191$var$CurrentOrganisation = (props)=>{
    const isVisualRefreshEnabled = (0, $eycgM.useIsSwitcherTeam25TestCohort)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
        as: "h2",
        size: isVisualRefreshEnabled ? 'small' : 'medium',
        children: props.displayName
    });
};
var $c06eb11c2f6ed191$export$2e2bcd8739ae039 = $c06eb11c2f6ed191$var$CurrentOrganisation;

});

parcelRegister("39NFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c244d7f087c25bd$export$2e2bcd8739ae039);
/* current-user.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
var $iXCQx = parcelRequire("iXCQx");

var $eycgM = parcelRequire("eycgM");
const $6c244d7f087c25bd$var$currentUserStyles = {
    root: "_19pkv77o"
};
const $6c244d7f087c25bd$var$CurrentUser = ({ email: email })=>{
    const isVisualRefreshEnabled = (0, $eycgM.useIsSwitcherTeam25TestCohort)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $6c244d7f087c25bd$var$currentUserStyles.root,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
            as: "p",
            color: isVisualRefreshEnabled ? 'color.text.subtlest' : 'color.text.subtle',
            weight: "regular",
            size: "small",
            children: email
        })
    });
};
var $6c244d7f087c25bd$export$2e2bcd8739ae039 = $6c244d7f087c25bd$var$CurrentUser;

});

parcelRegister("hcLCO", function(module, exports) {

$parcel$export(module.exports, "OrgContext", () => $723d80aaaadd997f$export$c4a9d90eb427f09c);
$parcel$export(module.exports, "useOrgProvider", () => $723d80aaaadd997f$export$4f81942ca340d49d);
$parcel$export(module.exports, "default", () => $723d80aaaadd997f$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $723d80aaaadd997f$export$c4a9d90eb427f09c = /*#__PURE__*/ (0, $gwFzn.createContext)([
    '',
    ()=>{}
]);
const $723d80aaaadd997f$var$OrgProvider = ({ children: children })=>{
    const [orgId, setOrgId] = (0, $gwFzn.useState)('');
    const setOrgIdCallback = (0, $gwFzn.useCallback)((id)=>{
        setOrgId(id);
    }, [
        setOrgId
    ]);
    const orgProviderState = (0, $gwFzn.useMemo)(()=>[
            orgId,
            setOrgIdCallback
        ], [
        orgId,
        setOrgIdCallback
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($723d80aaaadd997f$export$c4a9d90eb427f09c.Provider, {
        value: orgProviderState,
        children: children
    });
};
const $723d80aaaadd997f$export$4f81942ca340d49d = ()=>(0, $gwFzn.useContext)($723d80aaaadd997f$export$c4a9d90eb427f09c);
var $723d80aaaadd997f$export$2e2bcd8739ae039 = $723d80aaaadd997f$var$OrgProvider;

});


parcelRegister("4aISp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9edacd0580c1e52f$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $lICpR = parcelRequire("lICpR");

var $dcO0p = parcelRequire("dcO0p");

var $c2TlB = parcelRequire("c2TlB");
var $9edacd0580c1e52f$export$2e2bcd8739ae039 = ({ cloudId: cloudId, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c2TlB.FlightDeckProvider), {
        children: (productConfiguration)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $lICpR.UserPermissionProvider), {
                cloudId: cloudId,
                permissionId: (0, $dcO0p.Permissions).MANAGE,
                children: (managePermission)=>children({
                        productConfiguration: productConfiguration,
                        managePermission: managePermission
                    })
            })
    });
};

});
parcelRegister("c2TlB", function(module, exports) {

$parcel$export(module.exports, "FlightDeckProvider", () => $6382434be202e562$export$56da85ac9d40dbcd);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $c5kBK = parcelRequire("c5kBK");

var $cj14x = parcelRequire("cj14x");

var $grirN = parcelRequire("grirN");

var $2GCGk = parcelRequire("2GCGk");

var $lzcvT = parcelRequire("lzcvT");

var $alOHm = parcelRequire("alOHm");

var $kaECR = parcelRequire("kaECR");
const $6382434be202e562$var$client = new (0, $c5kBK.default)('atlassian-switcher', {
    handlers: {},
    // Switch the FD default storage from localStorage to sessionStorage to avoid issues related to GDPR policy.
    // The storageEngine option isn't exposed directly by the FD SDK, but you can still pass it in
    // https://hello.jira.atlassian.cloud/browse/NAVX-658
    //@ts-ignore
    storageEngine: 'sessionStorage'
});
const $6382434be202e562$var$transformFlightDeckArtifactToProductConfiguration = (artifact)=>{
    const artifactMap = new Map();
    for (const product of artifact.products){
        const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, rebrandedDisplayName: rebrandedDisplayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey, rebrandedIconKey: rebrandedIconKey } = product;
        artifactMap.set(apsKey, {
            key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
            href: siteUrlSuffix,
            ordinal: ordinal,
            label: (0, $2GCGk.formatLabel)(displayName),
            rebrandedLabel: rebrandedDisplayName && (0, $2GCGk.formatLabel)(rebrandedDisplayName),
            description: (0, $2GCGk.formatDescription)(subtitle),
            iconKey: iconKey,
            rebrandedIconKey: rebrandedIconKey
        });
        // TODO: remove this once Asset app becomes standalone app
        if (apsKey === 'JIRA_SERVICE_DESK' && !artifactMap.has((0, $alOHm.ASSETS_APP_KEY))) artifactMap.set((0, $alOHm.ASSETS_APP_KEY), {
            key: (0, $alOHm.ASSETS_APP_KEY),
            href: '/jira/assets',
            ordinal: ordinal + 0.1,
            label: (0, $2GCGk.formatLabel)((0, $kaECR.default).assets),
            iconKey: 'assets'
        });
    }
    return {
        products: Object.fromEntries(artifactMap),
        links: Object.fromEntries(artifact.links.map(({ apsKey: apsKey, ...link })=>[
                apsKey,
                {
                    ...link,
                    key: apsKey.toLowerCase(),
                    href: link.url,
                    label: (0, $2GCGk.formatLabel)(link.displayName),
                    description: (0, $2GCGk.formatDescription)(link.subtitle),
                    iconKey: 'admin'
                }
            ]))
    };
};
const $6382434be202e562$export$56da85ac9d40dbcd = ({ children: children })=>{
    const { ProviderComponent: FlightDeckDataProvider } = (0, $gwFzn.useMemo)(()=>{
        return (0, $cj14x.createProviderWithCustomFetchData)('flightDeck', (0, $grirN.ExperienceMark).API_FLIGHT_DECK, async ()=>{
            const artifact = await $6382434be202e562$var$client.fetchConfigFromFlightDeck({
                name: 'app-switcher-fe',
                dimensions: {
                    environmentType: 'prod',
                    perimeter: (0, $lzcvT.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
                }
            });
            return $6382434be202e562$var$transformFlightDeckArtifactToProductConfiguration(artifact);
        });
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(FlightDeckDataProvider, {
        children: children
    });
};

});
parcelRegister("2GCGk", function(module, exports) {

$parcel$export(module.exports, "formatLabel", () => $ea0d4fd6a5dec6f1$export$957d7daebd899f12);
$parcel$export(module.exports, "formatDescription", () => $ea0d4fd6a5dec6f1$export$f731e929548061dc);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
const $ea0d4fd6a5dec6f1$export$957d7daebd899f12 = (label)=>{
    return typeof label === 'string' ? label : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...label
    });
};
const $ea0d4fd6a5dec6f1$export$f731e929548061dc = (description)=>{
    return typeof description === 'string' ? description : description ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...description
    }) : null;
};

});



parcelRegister("7vBp6", function(module, exports) {

$parcel$export(module.exports, "mapResultsToSwitcherProps", () => $d496aacc0c25a836$export$3a4e55b5fbedb4d4);

var $8EOe8 = parcelRequire("8EOe8");

var $irYQs = parcelRequire("irYQs");

var $dcO0p = parcelRequire("dcO0p");

var $2ni8G = parcelRequire("2ni8G");

var $iDr1W = parcelRequire("iDr1W");

var $62H0u = parcelRequire("62H0u");

var $6jqOS = parcelRequire("6jqOS");

var $iFil1 = parcelRequire("iFil1");

var $dnXdB = parcelRequire("dnXdB");

var $eoE9K = parcelRequire("eoE9K");

var $4MtK3 = parcelRequire("4MtK3");

var $fMKjJ = parcelRequire("fMKjJ");

var $lqMZE = parcelRequire("lqMZE");

var $2GCGk = parcelRequire("2GCGk");

var $kaECR = parcelRequire("kaECR");
function $d496aacc0c25a836$var$collectAvailableProductLinks(cloudId, mapUrl, productConfiguration, availableProducts, orgId, viewer) {
    if (availableProducts && productConfiguration) {
        if ((0, $irYQs.isError)(productConfiguration)) throw new (0, $iFil1.SwitcherLoadError)((0, $iFil1.SwitcherLoadErrorReason).PRODUCT_CONFIGURATION, productConfiguration.error);
        if ((0, $irYQs.isError)(availableProducts)) throw new (0, $iFil1.SwitcherLoadError)((0, $iFil1.SwitcherLoadErrorReason).AVAILABLE_PRODUCTS, availableProducts.error);
        if ((0, $irYQs.isComplete)(productConfiguration) && (0, $irYQs.isComplete)(availableProducts)) {
            let productConfigurationMap = productConfiguration.data.products;
            // all T25 features need to put behind "test" experiment group
            if (availableProducts.data.switcherTeam25ExperimentCohort === 'test') {
                // add Goals config
                productConfigurationMap = (0, $lqMZE.buildGoalsProduct)(productConfigurationMap, availableProducts.data?.isGoalsAsAppEnabled);
                // add Teams config
                productConfigurationMap = (0, $fMKjJ.buildTeamsProduct)(productConfigurationMap, availableProducts.data?.isTeamsAsAppEnabled);
                // add SCAS config
                productConfigurationMap = (0, $eoE9K.buildRovoScasProducts)(productConfigurationMap, availableProducts.data?.isScasAsAppEnabled);
            }
            if (availableProducts.data.isAnalyticsRebrandEnabled && productConfigurationMap.ANALYTICS) productConfigurationMap.ANALYTICS.iconKey = 'atlassian-analytics-rebrand';
            // analytics i18n
            if (productConfigurationMap.ANALYTICS) productConfigurationMap.ANALYTICS.label = (0, $2GCGk.formatLabel)((0, $kaECR.default).analytics);
            return (0, $8EOe8.getAvailableProductLinks)(productConfigurationMap, availableProducts.data, cloudId, mapUrl, orgId, viewer);
        }
        return;
    }
    return;
}
function $d496aacc0c25a836$var$collectIsPartialResult(availableProducts) {
    if (availableProducts) {
        if ((0, $irYQs.isError)(availableProducts)) throw new (0, $iFil1.SwitcherLoadError)((0, $iFil1.SwitcherLoadErrorReason).AVAILABLE_PRODUCTS, availableProducts.error);
        if ((0, $irYQs.isComplete)(availableProducts)) return availableProducts.data.isPartial;
        return false;
    }
    return false;
}
function $d496aacc0c25a836$var$collectCanManageLinks(managePermission) {
    if ((0, $irYQs.isComplete)(managePermission)) return managePermission.data;
}
function $d496aacc0c25a836$var$extractExploreProductsLink(productConfiguration) {
    const EXPLORE_PRODUCTS_LINK_TYPE = 'ATLASSIAN_WEBSITE_TRY_PRODUCTS';
    const exploreProductsFallbackLink = 'https://www.atlassian.com/try';
    if ((0, $irYQs.isComplete)(productConfiguration)) return productConfiguration.data.links[EXPLORE_PRODUCTS_LINK_TYPE]?.href || exploreProductsFallbackLink;
    return exploreProductsFallbackLink;
}
function $d496aacc0c25a836$var$collectCustomLinks(customLinks, userSiteData) {
    if (customLinks === undefined || (0, $irYQs.isError)(userSiteData)) return [];
    if ((0, $irYQs.isComplete)(customLinks) && (0, $irYQs.isComplete)(userSiteData)) return (0, $8EOe8.getCustomLinkItems)(customLinks.data, userSiteData.data.currentSite);
}
function $d496aacc0c25a836$var$asUserSiteDataProviderResult(availableProductsProvider, cloudId, product) {
    switch(availableProductsProvider.status){
        case (0, $irYQs.Status).LOADING:
        case (0, $irYQs.Status).ERROR:
            return availableProductsProvider;
        case (0, $irYQs.Status).COMPLETE:
            if (availableProductsProvider.data.sites.length === 0) {
                const reason = availableProductsProvider.data.isPartial ? (0, $6jqOS.UserSiteDataErrorReason).APS_PARTIAL_EMPTY_RESULT : (0, $6jqOS.UserSiteDataErrorReason).APS_EMPTY_RESULT;
                return {
                    status: (0, $irYQs.Status).ERROR,
                    data: null,
                    error: new (0, $6jqOS.UserSiteDataError)(reason, `Available products returned an empty list`)
                };
            }
            const site = availableProductsProvider.data.sites.find((site)=>cloudId && site.cloudId && site.cloudId?.toLowerCase() === cloudId.toLowerCase() || // below will capture tenantless products as we set the cloudId to the productId in APS
                product && site.cloudId && site.cloudId?.toLowerCase() === product.toLowerCase());
            if (!site) return {
                status: (0, $irYQs.Status).ERROR,
                data: null,
                error: new (0, $6jqOS.UserSiteDataError)((0, $6jqOS.UserSiteDataErrorReason).APS_NO_SITE_MATCH, `could not find site in availableProducts for cloudId ${cloudId}`)
            };
            return {
                status: (0, $irYQs.Status).COMPLETE,
                data: {
                    currentSite: {
                        url: site.url,
                        products: site.availableProducts
                    }
                }
            };
    }
}
function $d496aacc0c25a836$export$3a4e55b5fbedb4d4({ cloudId: cloudId, results: results, features: features, product: product, adminUrl: adminUrl, customizeLinks: customizeLinks, orgId: orgId, viewer: viewer }) {
    const collect = (0, $2ni8G.createCollector)();
    const { availableProducts: availableProducts, productConfiguration: productConfiguration, joinableSites: joinableSites, managePermission: managePermission, customLinks: customLinks } = results;
    const userSiteData = $d496aacc0c25a836$var$asUserSiteDataProviderResult(availableProducts, cloudId, product);
    const hasLoadedAvailableProducts = (0, $irYQs.hasLoaded)(productConfiguration) && (0, $irYQs.hasLoaded)(availableProducts);
    const hasLoadedAdminLinks = (0, $irYQs.hasLoaded)(managePermission);
    const hasLoadedJoinableSites = (0, $irYQs.hasLoaded)(joinableSites);
    let mapUrl = (url)=>url;
    let getExtendedAnalyticsAttributes = ()=>({});
    if (customizeLinks) {
        const originCustomLinks = customizeLinks();
        mapUrl = originCustomLinks.mapUrl;
        getExtendedAnalyticsAttributes = originCustomLinks.getExtendedAnalyticsAttributes;
    }
    const organisations = availableProducts.data?.sites.reduce((acc, site)=>{
        if (site.org && !acc.has(site.org.id)) acc.set(site.org.id, site.org);
        return acc;
    }, new Map());
    const licensedProductLinks = collect($d496aacc0c25a836$var$collectAvailableProductLinks(cloudId, mapUrl, productConfiguration, availableProducts, orgId, viewer), []);
    if ((0, $irYQs.hasLoaded)(availableProducts) && licensedProductLinks.length > 0) {
        // 1. Add Company hub
        const item = (0, $4MtK3.buildCompanyHub)(availableProducts, productConfiguration, cloudId);
        if (item) licensedProductLinks.unshift(item);
        // 2. Add Atlassian Home or Start
        if (product !== (0, $dcO0p.Product).START) licensedProductLinks.unshift((0, $dnXdB.buildAtlassianHomeOrStartSwitcherItemType)(orgId, availableProducts));
    }
    return {
        organisations: organisations,
        getExtendedAnalyticsAttributes: getExtendedAnalyticsAttributes,
        licensedProductLinks: licensedProductLinks,
        isPartialResult: $d496aacc0c25a836$var$collectIsPartialResult(availableProducts),
        adminLinks: collect((0, $iDr1W.collectAdminLinks)(availableProducts, productConfiguration, adminUrl), []),
        joinableSiteLinks: collect((0, $62H0u.collectJoinableSiteLinks)(joinableSites, productConfiguration), []),
        customLinks: collect($d496aacc0c25a836$var$collectCustomLinks(customLinks, userSiteData), []),
        exploreProductsLink: $d496aacc0c25a836$var$extractExploreProductsLink(productConfiguration),
        showManageLink: collect($d496aacc0c25a836$var$collectCanManageLinks(managePermission), false),
        hasLoaded: hasLoadedAvailableProducts && hasLoadedAdminLinks && hasLoadedJoinableSites,
        hasLoadedCritical: hasLoadedAvailableProducts,
        hasLoadedInstanceProviders: customLinks && (0, $irYQs.hasLoaded)(customLinks) && (0, $irYQs.hasLoaded)(userSiteData),
        rawProviderResults: {
            productConfiguration: productConfiguration,
            availableProducts: availableProducts,
            joinableSites: joinableSites,
            managePermission: managePermission,
            customLinks: customLinks,
            userSiteData: userSiteData
        },
        features: features,
        switcherTeam25ExperimentCohort: availableProducts?.data?.switcherTeam25ExperimentCohort,
        isTeam25AppRebrandEnabled: availableProducts?.data?.isTeam25AppRebrandEnabled
    };
}

});
parcelRegister("8EOe8", function(module, exports) {

$parcel$export(module.exports, "getProductSiteUrl", () => $413aee6c7b850b7d$export$85b57c3ed6afbbf);
$parcel$export(module.exports, "getAvailableProductLinks", () => $413aee6c7b850b7d$export$32f4e249bd5fd43b);
$parcel$export(module.exports, "getCustomLinkItems", () => $413aee6c7b850b7d$export$7d1238f001f509f3);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $kaECR = parcelRequire("kaECR");

var $96eLn = parcelRequire("96eLn");

var $c6GJD = parcelRequire("c6GJD");

var $9fhu3 = parcelRequire("9fhu3");

var $dh538 = parcelRequire("dh538");
const $413aee6c7b850b7d$export$891dc7068a3d5e65 = 14;
const $413aee6c7b850b7d$export$6e594fe130dbe3b = 14;
const $413aee6c7b850b7d$export$fdccde09f45ad7c9 = {
    // pf-activity specific object types. To be removed when pf-activity is deprecated
    'jira-project': (0, $kaECR.default).jiraProject,
    'confluence-space': (0, $kaECR.default).confluenceSpace,
    jiraProject: (0, $kaECR.default).jiraProject,
    confluenceSpace: (0, $kaECR.default).confluenceSpace
};
const $413aee6c7b850b7d$export$67f17c6479073ed3 = (type)=>{
    return $413aee6c7b850b7d$export$fdccde09f45ad7c9[type] ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...$413aee6c7b850b7d$export$fdccde09f45ad7c9[type]
    }) : type;
};
const $413aee6c7b850b7d$export$85b57c3ed6afbbf = (availableProductMap, product, siteUrl)=>{
    if (product.url) return product.url;
    if (availableProductMap[product.productType]?.href) return siteUrl + availableProductMap[product.productType].href;
    return siteUrl;
};
const $413aee6c7b850b7d$var$getAvailableProductLinkFromSiteProduct = (productConfigurationMap, connectedSites, mapUrl, rebrand = false)=>{
    const topSite = connectedSites.find((site)=>site.isCurrentSite) || connectedSites.sort((a, b)=>a.siteName.localeCompare(b.siteName))[0];
    const productType = topSite.product.productType;
    const productLinkProperties = productConfigurationMap[productType];
    if (!productLinkProperties) return null;
    return {
        ...productLinkProperties,
        label: rebrand && productLinkProperties.rebrandedLabel ? productLinkProperties.rebrandedLabel : productLinkProperties.label,
        iconKey: rebrand && productLinkProperties.rebrandedIconKey ? productLinkProperties.rebrandedIconKey : productLinkProperties.iconKey,
        key: productType + topSite.siteName,
        href: mapUrl($413aee6c7b850b7d$export$85b57c3ed6afbbf(productConfigurationMap, topSite.product, topSite.siteUrl), productType),
        iconUrl: productLinkProperties.iconUrl,
        description: topSite.siteName,
        productType: productType,
        childItems: connectedSites.length > 1 ? connectedSites.map((site)=>({
                href: mapUrl($413aee6c7b850b7d$export$85b57c3ed6afbbf(productConfigurationMap, site.product, site.siteUrl), productType),
                label: site.siteName,
                avatar: site.avatar
            })).sort((a, b)=>a.label.localeCompare(b.label)) : [],
        shouldShowNewLozenge: topSite.shouldShowNewLozenge,
        shouldShowNewBoldLozenge: topSite.shouldShowNewBoldLozenge,
        shouldShowTryLozenge: topSite.shouldShowTryLozenge,
        autoProvisionDate: topSite.autoProvisionDate,
        isProductInactive: topSite.isProductInactive,
        isCompanyHubPublishedAndPremium: topSite.isCompanyHubPublishedAndPremium,
        companyHubName: topSite.companyHubName,
        experimentNudgeToJira: topSite.experimentNudgeToJira
    };
};
const $413aee6c7b850b7d$var$isNewlyAutoProvisioned = (product)=>{
    const { autoProvisionDate: autoProvisionDate } = product;
    let isConsideredNew = false;
    if (autoProvisionDate) {
        const days = (0, $96eLn.daysBetween)(new Date(autoProvisionDate), new Date());
        isConsideredNew = days <= $413aee6c7b850b7d$export$891dc7068a3d5e65 && days >= 0;
    }
    return isConsideredNew;
};
const $413aee6c7b850b7d$var$getIsRecentEndUserActivatedProduct = (product)=>{
    const { endUserActivationDate: endUserActivationDate, productType: productType } = product;
    if (!endUserActivationDate || ![
        'CONFLUENCE',
        'JIRA_SERVICE_DESK',
        'JIRA_PRODUCT_DISCOVERY',
        'LOOM'
    ].includes(productType)) return false;
    const days = (0, $96eLn.daysBetween)(new Date(endUserActivationDate), new Date());
    return days <= $413aee6c7b850b7d$export$6e594fe130dbe3b && days >= 0;
};
const $413aee6c7b850b7d$export$32f4e249bd5fd43b = (productConfigurationMap, availableProducts, cloudId, mapUrl, orgId, viewer)=>{
    const productsMap = {};
    let shouldRemoveJWM = false;
    const isNudgeToJiraEnabled = (0, $dh538.fg)('nudge_to_jira_in_switcher_gate');
    availableProducts.sites.forEach((site)=>{
        const { availableProducts: availableProducts, avatar: avatar, displayName: displayName, url: url } = site;
        // only apply org level filtering if org data is available
        if ('org' in site && site.org && orgId) {
            if (orgId !== site.org.id) return;
        }
        availableProducts.forEach((product)=>{
            const { activationDate: activationDate, autoProvisionDate: autoProvisionDate, isCompanyHubPublishedAndPremium: isCompanyHubPublishedAndPremium, companyHubName: companyHubName } = product;
            let productKey = product.productType;
            if ([
                'JIRA_SOFTWARE',
                'JIRA_PRODUCT_DISCOVERY',
                'JIRA_SERVICE_DESK'
            ].includes(productKey)) shouldRemoveJWM = true;
            // if a site has JWM only and no other Jiras, JWM needs to appear under "Jira"
            // to ensure that this happens, we set JSM's productKey to 'JIRA_SOFTWARE'
            // this will ensure that JWM is not removed, even if another site has JSW/JPD/JSM
            if (productKey === 'JIRA_BUSINESS' && !availableProducts.some(({ productType: productType })=>[
                    'JIRA_SOFTWARE',
                    'JIRA_PRODUCT_DISCOVERY',
                    'JIRA_SERVICE_DESK'
                ].includes(productType))) productKey = 'JIRA_SOFTWARE';
            if (!productsMap[productKey]) productsMap[productKey] = [];
            const isRecentEndUserActivatedProduct = $413aee6c7b850b7d$var$getIsRecentEndUserActivatedProduct(product);
            const isCurrentSite = Boolean(cloudId) && site.cloudId?.toLowerCase() === cloudId?.toLowerCase();
            const shouldShowNewLozenge = isRecentEndUserActivatedProduct || product.productType !== 'CONFLUENCE' && $413aee6c7b850b7d$var$isNewlyAutoProvisioned(product);
            const shouldShowTryLozenge = product.productType === 'CONFLUENCE' && $413aee6c7b850b7d$var$isNewlyAutoProvisioned(product);
            // TBLZ-2123: Growth - Trailblazers experiment - More info at go/trailblazerexperiments
            const experimentNudgeToJira = isNudgeToJiraEnabled && product.productType === 'JIRA_SOFTWARE' ? {
                attributes: {
                    activationDate: activationDate,
                    hasAdminAccess: site.adminAccess,
                    product: viewer?.product,
                    subproduct: viewer?.subproduct
                },
                isEligibleForNudgeToJiraAATest: undefined,
                nudgeToJiraCohort: undefined
            } : undefined;
            productsMap[productKey].push({
                product: product,
                isCurrentSite: isCurrentSite,
                isCompanyHubPublishedAndPremium: isCompanyHubPublishedAndPremium,
                companyHubName: companyHubName,
                shouldShowNewLozenge: shouldShowNewLozenge,
                shouldShowTryLozenge: shouldShowTryLozenge,
                autoProvisionDate: autoProvisionDate,
                siteName: displayName,
                siteUrl: url,
                avatar: avatar,
                experimentNudgeToJira: experimentNudgeToJira
            });
        });
    });
    // TBLZ-2123: Growth - Trailblazers experiment - More info at go/trailblazerexperiments
    if (isNudgeToJiraEnabled && productsMap['JIRA_SOFTWARE']?.length === 1) {
        const [connectedSite] = productsMap['JIRA_SOFTWARE'];
        const isEligibleForNudgeToJira = (0, $9fhu3.getIsEligibleForNudgeToJira)({
            connectedSite: connectedSite,
            cloudId: cloudId,
            viewer: viewer
        });
        // Experiment
        if (isEligibleForNudgeToJira) {
            const nudgeToJiraCohort = (0, $c6GJD.default).getExperimentValue('nudge_to_jira_in_switcher', 'cohort', 'not-enrolled');
            connectedSite.shouldShowNewBoldLozenge = nudgeToJiraCohort === 'variation';
            connectedSite.experimentNudgeToJira = {
                ...connectedSite.experimentNudgeToJira,
                nudgeToJiraCohort: nudgeToJiraCohort
            };
        }
    }
    // END TBLZ-2123: Growth - Trailblazers experiment - More info at go/trailblazerexperiments
    const items = [];
    for(const productType in productsMap){
        if (productType === 'JIRA_BUSINESS' && shouldRemoveJWM) continue;
        const rebrand = productType === 'JIRA_SOFTWARE' || productType === 'JIRA_BUSINESS';
        // Rebranding Rules:
        // 1. When both Jira Work Management (JWM) and Jira Software (JSW) appear, rebrand both and only show one link
        // 2. When only one of them (JWM or JSW) appears, rebrand both
        // for more info: https://hello.atlassian.net/wiki/spaces/Spork/pages/4059534637/Spork+Rebranding+Appswitcher+behaviour
        const connectedSites = productsMap[productType];
        const link = $413aee6c7b850b7d$var$getAvailableProductLinkFromSiteProduct(productConfigurationMap, connectedSites, mapUrl, rebrand);
        if (link) items.push(link);
    }
    return items.sort((a, b)=>{
        return a.ordinal - b.ordinal;
    });
};
const $413aee6c7b850b7d$export$7d1238f001f509f3 = (list, currentSite)=>{
    const defaultProductCustomLinks = [
        `${currentSite.url}/secure/MyJiraHome.jspa`,
        `${currentSite.url}/wiki/`
    ];
    return list.filter((customLink)=>defaultProductCustomLinks.indexOf(customLink.link) === -1).map((customLink)=>({
            key: customLink.key,
            label: customLink.label,
            iconKey: 'custom-link',
            href: customLink.link,
            analyticsAttributes: {
                linkType: customLink.local ? 'customLink' : 'applink'
            }
        }));
};

});

parcelRegister("2ni8G", function(module, exports) {

$parcel$export(module.exports, "createCollector", () => $92df0f4cc8f5281f$export$e637547e96a5e788);
/**
 * Creates a function that "collects" and returns values !== undefined,
 * falls back to default value for subsequent calls after first value === undefined
 */ function $92df0f4cc8f5281f$export$e637547e96a5e788() {
    let keepCollecting = true;
    return (nextResult, defaultValue)=>{
        if (keepCollecting && nextResult !== undefined) return nextResult;
        keepCollecting = false;
        return defaultValue;
    };
}

});

parcelRegister("iDr1W", function(module, exports) {

$parcel$export(module.exports, "collectAdminLinks", () => $e76026b2baa7bb13$export$d4478d1fb3aa2a35);

var $irYQs = parcelRequire("irYQs");
function $e76026b2baa7bb13$export$2a5744d9b5ca1c4d(link, productConfigurationResponse, adminUrl, keySuffix) {
    const productConfigItem = productConfigurationResponse.links[link.linkType];
    if (productConfigItem) {
        const href = adminUrl && link.linkType.toLowerCase() === 'administration' ? adminUrl : link.url || productConfigItem.href;
        return {
            ...productConfigItem,
            key: productConfigItem.key + keySuffix,
            href: href
        };
    }
    return null;
}
function $e76026b2baa7bb13$export$d4478d1fb3aa2a35(availableProducts, productConfiguration, adminUrl) {
    if ((0, $irYQs.isError)(availableProducts) || (0, $irYQs.isError)(productConfiguration)) return [];
    if ((0, $irYQs.isComplete)(availableProducts) && availableProducts.data && (0, $irYQs.isComplete)(productConfiguration) && productConfiguration.data) return availableProducts.data.links.reduce((acc, link, i)=>{
        const productLink = $e76026b2baa7bb13$export$2a5744d9b5ca1c4d(link, productConfiguration.data, adminUrl, i);
        if (productLink) acc.push(productLink);
        return acc;
    }, []).sort((a, b)=>a.ordinal - b.ordinal);
    return [];
}

});

parcelRegister("62H0u", function(module, exports) {

$parcel$export(module.exports, "collectJoinableSiteLinks", () => $2b9de538e1cd92c9$export$32a9c03f0f3c69f2);

var $1XDwP = parcelRequire("1XDwP");

var $irYQs = parcelRequire("irYQs");
function $2b9de538e1cd92c9$export$32a9c03f0f3c69f2(joinableSites, productConfiguration) {
    if (joinableSites === undefined || (0, $irYQs.isError)(joinableSites)) return [];
    if ((0, $irYQs.isComplete)(joinableSites) && (0, $irYQs.isComplete)(productConfiguration)) {
        const joinableSiteLinks = (0, $1XDwP.getJoinableSiteLinks)(joinableSites.data.sites, productConfiguration.data.products);
        // Rebranding Rules:
        // 1. When both Jira Work Management (JWM) and Jira Software (JSW) appear, rebrand both and only show one link
        // 2. When only one of them (JWM or JSW) appears, rebrand both
        // for more info: https://hello.atlassian.net/wiki/spaces/Spork/pages/4059534637/Spork+Rebranding+Appswitcher+behaviour
        // check if JWM needed
        const shouldRemoveJWM = joinableSiteLinks.some(({ productType: productType })=>productType && [
                'JIRA_SOFTWARE',
                'JIRA_PRODUCT_DISCOVERY',
                'JIRA_SERVICE_DESK'
            ].includes(productType));
        // remove JWM
        const filteredJoinableSiteLinks = joinableSiteLinks.filter((p)=>!(p.productType === 'JIRA_BUSINESS' && shouldRemoveJWM));
        // rebrand JSW and/or JWM
        for (const joinableSiteLink of filteredJoinableSiteLinks){
            const productConfig = joinableSiteLink.productType && productConfiguration.data.products[joinableSiteLink.productType];
            if ((joinableSiteLink.productType === 'JIRA_SOFTWARE' || joinableSiteLink.productType === 'JIRA_BUSINESS') && productConfig) {
                joinableSiteLink.iconKey = productConfig.rebrandedIconKey ?? joinableSiteLink.iconKey;
                joinableSiteLink.label = productConfig.rebrandedLabel ?? joinableSiteLink.label;
            }
        }
        return filteredJoinableSiteLinks;
    }
}

});
parcelRegister("1XDwP", function(module, exports) {

$parcel$export(module.exports, "getJoinableSiteLinks", () => $e38b03e7ea37a3d2$export$237b3fbfd5f82cfa);

var $dcO0p = parcelRequire("dcO0p");

var $g91ly = parcelRequire("g91ly");
// Design decision from
// https://hello.atlassian.net/wiki/spaces/~kgalek/pages/563815188/Join+from+Atlassian+switcher%3A+design+so+far
const $e38b03e7ea37a3d2$var$MAX_JOINABLE_SITES = 3;
const $e38b03e7ea37a3d2$export$237b3fbfd5f82cfa = (joinableSites = [], productConfigurationMap)=>{
    let joinableSiteLinks = [];
    const legacyProductKeyMap = (0, $g91ly.mapLegacyProductKeyToSwitcherProductKey)(productConfigurationMap);
    for (let site of joinableSites){
        const productKeys = Object.keys(site.users || site.products);
        for (let productKey of productKeys){
            const productType = legacyProductKeyMap[productKey];
            const productConfig = productConfigurationMap[productType];
            if (!productConfig) continue;
            const { label: label, iconKey: iconKey, href: href } = productConfig;
            let productUrl = site.url;
            let users = [];
            const product = site?.products?.[productKey] || [];
            const capability = !Array.isArray(product) ? product.capability : undefined;
            if (productKey === (0, $dcO0p.ProductKey).CONFLUENCE) productUrl = site.url + href;
            // in Bitbucket, it uses site.users as an array of JoinableUser
            if (site.users) users = site.users[productKey];
            else if (site.products) {
                // in Trello, it is currently an empty array (stripped off from an array of user id string)
                if (Array.isArray(product)) users = [];
                else if (Object.keys(product).length) {
                    users = product.collaborators || [];
                    // if productUrl is not given somehow, it falls back to the href from AVAILABLE_PRODUCT_DATA_MAP
                    if (product.productUrl) productUrl = product.productUrl;
                }
            }
            joinableSiteLinks.push({
                key: site.cloudId || productKey,
                label: label,
                description: site.displayName,
                iconKey: iconKey,
                href: productUrl,
                users: users.map((user)=>({
                        name: user.displayName,
                        src: user.avatarUrl,
                        appearance: 'circle',
                        size: 'small'
                    })),
                cloudId: site.cloudId,
                productType: productType,
                capability: capability
            });
            if (joinableSiteLinks.length >= $e38b03e7ea37a3d2$var$MAX_JOINABLE_SITES) return joinableSiteLinks;
        }
    }
    return joinableSiteLinks;
};

});
parcelRegister("g91ly", function(module, exports) {

$parcel$export(module.exports, "mapLegacyProductKeyToSwitcherProductKey", () => $c95e2a0cd50f6253$export$e897327ecc5e58bb);
const $c95e2a0cd50f6253$export$e897327ecc5e58bb = (productConfigurationMap)=>{
    return Object.entries(productConfigurationMap).reduce((acc, [key, entry])=>{
        return {
            ...acc,
            [entry.key]: key
        };
    }, {});
};

});



parcelRegister("dnXdB", function(module, exports) {

$parcel$export(module.exports, "buildAtlassianHomeOrStartSwitcherItemType", () => $dac00ade3f5d91b7$export$88155bb10a21dc47);

var $irYQs = parcelRequire("irYQs");

var $bMAxh = parcelRequire("bMAxh");

var $cw9iP = parcelRequire("cw9iP");

var $d1Cm1 = parcelRequire("d1Cm1");

var $lzcvT = parcelRequire("lzcvT");
const $dac00ade3f5d91b7$export$88155bb10a21dc47 = (orgId, availableProducts)=>{
    const isHomeRebrandEnabled = availableProducts?.data?.isHomeRebrandEnabled ?? false;
    let homeUrl = (0, $d1Cm1.getHomeUrl)(availableProducts) ?? 'https://home.atlassian.com';
    if (availableProducts && (0, $irYQs.isComplete)(availableProducts) && availableProducts.data.startUrl) {
        // atlassian home is not available in FedRamp we fallback to atlassian start
        if ((0, $lzcvT.isFedRamp)()) return (0, $cw9iP.default)(availableProducts.data.startUrl);
    }
    // orgID can be empty string and we only pass it if it's not empty
    if (orgId) homeUrl = `${homeUrl}/o/${orgId}`;
    return (0, $bMAxh.default)(homeUrl, isHomeRebrandEnabled);
};

});
parcelRegister("bMAxh", function(module, exports) {

$parcel$export(module.exports, "default", () => $52df5508687c7737$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $kaECR = parcelRequire("kaECR");
var $52df5508687c7737$export$2e2bcd8739ae039 = (homeUrl, isHomeRebrandEnabled)=>({
        key: 'atlassian-home',
        iconKey: isHomeRebrandEnabled ? 'atlassian-home' : 'atlassian',
        label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...isHomeRebrandEnabled ? (0, $kaECR.default).home : (0, $kaECR.default).atlassianHome
        }),
        href: homeUrl,
        productType: 'ATLASSIAN_HOME'
    });

});

parcelRegister("cw9iP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aeacb2d30396a80$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $kaECR = parcelRequire("kaECR");
var $5aeacb2d30396a80$export$2e2bcd8739ae039 = (startUrl)=>({
        key: 'atlassian-start',
        iconKey: 'atlassian',
        label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $kaECR.default).atlassianStart
        }),
        href: startUrl
    });

});

parcelRegister("d1Cm1", function(module, exports) {

$parcel$export(module.exports, "getHomeUrl", () => $1c5aef32d2f75138$export$1df767a34042eb2d);

var $irYQs = parcelRequire("irYQs");
const $1c5aef32d2f75138$export$1df767a34042eb2d = (availableProducts)=>{
    if (availableProducts && (0, $irYQs.isComplete)(availableProducts) && availableProducts.data.startUrl) {
        if (availableProducts.data.startUrl.includes('.stg.')) return 'https://home.stg.atlassian.com';
        return 'https://home.atlassian.com';
    }
    return;
};

});


parcelRegister("eoE9K", function(module, exports) {

$parcel$export(module.exports, "buildRovoScasProducts", () => $f17ac1032eb8072f$export$1a862577e121e15);

var $lzcvT = parcelRequire("lzcvT");

var $2GCGk = parcelRequire("2GCGk");

var $kaECR = parcelRequire("kaECR");
const $f17ac1032eb8072f$export$1a862577e121e15 = (productConfigurationMap, isScasAsAppEnabled)=>{
    const configMap = {
        ...productConfigurationMap
    };
    if ((0, $lzcvT.isFedRamp)() || !isScasAsAppEnabled) return configMap;
    configMap.SEARCH = {
        label: (0, $2GCGk.formatLabel)((0, $kaECR.default).search),
        iconKey: 'search',
        key: 'search',
        ordinal: 20
    };
    configMap.CHAT = {
        label: (0, $2GCGk.formatLabel)((0, $kaECR.default).chat),
        iconKey: 'chat',
        key: 'chat',
        ordinal: 21
    };
    configMap.STUDIO = {
        label: (0, $2GCGk.formatLabel)((0, $kaECR.default).studio),
        iconKey: 'studio',
        key: 'studio',
        ordinal: 22
    };
    return configMap;
};

});

parcelRegister("4MtK3", function(module, exports) {

$parcel$export(module.exports, "buildCompanyHub", () => $6ae3674e196d9698$export$a05354a3c35e1f7e);

var $irYQs = parcelRequire("irYQs");

var $fwpSD = parcelRequire("fwpSD");

var $8EOe8 = parcelRequire("8EOe8");

var $2ni8G = parcelRequire("2ni8G");

var $iFil1 = parcelRequire("iFil1");
function $6ae3674e196d9698$var$collectCurrentSiteAvailableProducts(currentCloudId, productConfiguration, availableProducts) {
    if (availableProducts && productConfiguration) {
        if ((0, $irYQs.isError)(productConfiguration)) throw new (0, $iFil1.SwitcherLoadError)((0, $iFil1.SwitcherLoadErrorReason).PRODUCT_CONFIGURATION, productConfiguration.error);
        if ((0, $irYQs.isError)(availableProducts)) throw new (0, $iFil1.SwitcherLoadError)((0, $iFil1.SwitcherLoadErrorReason).AVAILABLE_PRODUCTS, availableProducts.error);
        if (Boolean(currentCloudId) && (0, $irYQs.isComplete)(productConfiguration) && (0, $irYQs.isComplete)(availableProducts)) {
            const currentSite = availableProducts.data.sites.find((site)=>site.cloudId?.toLowerCase() === currentCloudId.toLowerCase());
            return currentSite?.availableProducts.map((product)=>({
                    ...product,
                    url: (0, $8EOe8.getProductSiteUrl)(productConfiguration.data.products, product, currentSite.url)
                }));
        }
        return;
    }
    return;
}
const $6ae3674e196d9698$export$a05354a3c35e1f7e = (availableProducts, productConfiguration, cloudId)=>{
    const collect = (0, $2ni8G.createCollector)();
    if (availableProducts.data?.switcherTeam25ExperimentCohort === 'test' && availableProducts.data?.companyHubAsAnAppEnabled && cloudId) {
        const currentSiteAvailableProducts = collect($6ae3674e196d9698$var$collectCurrentSiteAvailableProducts(cloudId, productConfiguration, availableProducts), []);
        const confluenceWithCompanyHubPublished = currentSiteAvailableProducts.find((product)=>product.isCompanyHubPublishedAndPremium);
        if (confluenceWithCompanyHubPublished) return (0, $fwpSD.default)(`${confluenceWithCompanyHubPublished.url}/company-hub`, confluenceWithCompanyHubPublished.companyHubName);
    }
    return;
};

});
parcelRegister("fwpSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7504cc6ccdbaf0b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $kaECR = parcelRequire("kaECR");
var $f7504cc6ccdbaf0b$export$2e2bcd8739ae039 = (url, label)=>({
        key: 'company-hub',
        iconKey: 'company-hub',
        label: label ?? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $kaECR.default).companyHub
        }),
        href: url,
        productType: 'COMPANY_HUB'
    });

});


parcelRegister("fMKjJ", function(module, exports) {

$parcel$export(module.exports, "buildTeamsProduct", () => $b04046bbfb06d653$export$a9520a9a291e5323);

var $lzcvT = parcelRequire("lzcvT");

var $2GCGk = parcelRequire("2GCGk");

var $kaECR = parcelRequire("kaECR");
function $b04046bbfb06d653$export$a9520a9a291e5323(productConfigurationMap, isTeamsAsAppEnabled) {
    if ((0, $lzcvT.isFedRamp)() || !isTeamsAsAppEnabled) return productConfigurationMap;
    return {
        ...productConfigurationMap,
        TEAMS: {
            label: (0, $2GCGk.formatLabel)((0, $kaECR.default).teams),
            iconKey: 'teams',
            key: 'teams',
            ordinal: 19
        }
    };
}

});

parcelRegister("lqMZE", function(module, exports) {

$parcel$export(module.exports, "buildGoalsProduct", () => $cd586c486da1a3ab$export$878fa2603ef7b20a);

var $lzcvT = parcelRequire("lzcvT");

var $2GCGk = parcelRequire("2GCGk");

var $kaECR = parcelRequire("kaECR");
function $cd586c486da1a3ab$export$878fa2603ef7b20a(productConfigurationMap, isGoalsAsAppEnabled) {
    if ((0, $lzcvT.isFedRamp)() || !isGoalsAsAppEnabled) return productConfigurationMap;
    return {
        ...productConfigurationMap,
        GOALS: {
            label: (0, $2GCGk.formatLabel)((0, $kaECR.default).goals),
            iconKey: 'goals',
            key: 'goals',
            ordinal: 18
        }
    };
}

});



//# sourceMappingURL=AppSwitcherComponentWrapper.a1425111.js.map
